/* v96: product links were shortened (rayhaan-terra-100ml-eau-de-parfum -> rayhaan-terra).
   Wishlists and recently-viewed lists saved in a shopper's browser still hold the
   old handles, so they are rewritten once to the short form before anything reads them. */
(() => {
  const shorten = (handle) => String(handle)
    .replace(/-100ml-gift-set$/, '-gift-set')
    .replace(/-\d+ml(?:-(?:eau-de-parfum|extrait-de-parfum|eau-de-toilette|parfum))?$/, '');
  const oldHandle = /([a-z0-9]+(?:-[a-z0-9]+)*-\d+ml(?:-(?:eau-de-parfum|extrait-de-parfum|eau-de-toilette|parfum|gift-set))?)(?![a-z0-9-])/g;
  try {
    ['cc-wishlist-v1', 'cc-wishlist-items-v2', 'cc-recent-products-v2', 'cc-recent-products-v1'].forEach((key) => {
      const raw = window.localStorage.getItem(key);
      if (!raw || !oldHandle.test(raw)) return;
      oldHandle.lastIndex = 0;
      window.localStorage.setItem(key, raw.replace(oldHandle, (match) => shorten(match)));
    });
  } catch (_) { /* storage unavailable: nothing to migrate */ }
})();

/* =========================================================
   Canada Cologne v2.16.27 — cc703 fixed phone arrow line
   ---------------------------------------------------------
   On phones / small tablets (<= 759px) the shelf arrows sit on ONE permanent
   line: the centre of the listing image in its final, lifted position (the
   same -5px lift the image animates up to when a card is touched).

   The line is computed from layout offsets (offsetTop / offsetHeight), which
   ignore transforms. So neither the card's reveal slide-up, nor the touch
   lift, nor paging to other cards can move the arrows: every card in a shelf
   has the same image box, so the answer is the same for all of them.

   Applies to New Arrivals / Best Sellers and You May Also Like / Recently
   Viewed. Every older geometry writer calls apply() after it sets `top`, so
   they all land on this same number; there is nothing left to race.
   Flash Sale keeps its own card-anchored geometry.
   ========================================================= */
window.CC703RailArrowTop = (function () {
  'use strict';
  var RAIL_QUERY = '(max-width: 759px)';
  var WRAP = '.template-index .product-section-home [data-cc246-wrap], .template-product .source-product-shelf .source-shelf-wrap';

  function railLayout() {
    return window.matchMedia ? window.matchMedia(RAIL_QUERY).matches : window.innerWidth <= 759;
  }
  function active(wrap) {
    if (!wrap || !railLayout()) return false;
    if (!wrap.matches || !wrap.matches(WRAP)) return false;
    return !wrap.closest('.cc-hot-deals-section');
  }
  /* Document offset from layout only — transforms are ignored by offsetTop. */
  function layoutTop(el) {
    var top = 0;
    while (el) { top += el.offsetTop || 0; el = el.offsetParent; }
    return top;
  }
  function lift() {
    var raw = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--cc290-card-hover-lift'));
    return isFinite(raw) ? raw : -5;
  }
  function parts(wrap) {
    return {
      row: wrap.querySelector('[data-cc246-row], [data-shelf-row]'),
      prev: wrap.querySelector('[data-cc246-prev], [data-shelf-prev]'),
      next: wrap.querySelector('[data-cc246-next], [data-shelf-next]')
    };
  }
  function imageBox(row) {
    var cards = row ? row.querySelectorAll('[data-product-card]') : [];
    for (var i = 0; i < cards.length; i++) {
      if (cards[i].hidden || !cards[i].offsetHeight) continue;
      var box = cards[i].querySelector('.full-bottle-strip-visual') || cards[i].querySelector('.full-bottle-strip-image-stage');
      if (box && box.offsetHeight > 0) return box;
    }
    return null;
  }
  function y(wrap) {
    var row = parts(wrap).row;
    var box = imageBox(row);
    if (!box) return NaN;
    return layoutTop(box) - layoutTop(wrap) + box.offsetHeight / 2 + lift();
  }
  function apply(wrap) {
    if (!active(wrap)) return false;
    var p = parts(wrap);
    if (!p.prev || !p.next) return false;
    var value = y(wrap);
    if (!isFinite(value)) return false;
    var px = Math.round(value * 100) / 100 + 'px';
    p.prev.style.setProperty('top', px, 'important');
    p.next.style.setProperty('top', px, 'important');
    wrap.style.setProperty('--cc703-arrow-y', px);
    if (wrap.classList.contains('source-shelf-wrap')) wrap.style.setProperty('--cc664-pdp-arrow-y', px);
    return true;
  }
  function applyAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var wraps = scope.querySelectorAll(WRAP);
    for (var i = 0; i < wraps.length; i++) apply(wraps[i]);
  }
  return { active: active, y: y, apply: apply, applyAll: applyAll, WRAP: WRAP };
})();

(() => {
  'use strict';

  const q = (selector, context = document) => context.querySelector(selector);
  const qa = (selector, context = document) => Array.from(context.querySelectorAll(selector));
  const syncHeaderCount = (selector, count) => {
    const next = Math.max(0, Math.floor(Number(count) || 0));
    qa(selector).forEach((badge) => {
      badge._ccCountVersion = (badge._ccCountVersion || 0) + 1;
      const version = badge._ccCountVersion;
      badge.setAttribute('aria-hidden', String(next === 0));
      if (next === 0) {
        badge.classList.remove('is-visible');
        return;
      }
      const text = String(next);
      if (badge.textContent !== text) badge.textContent = text;
      if (badge.classList.contains('is-visible')) return;
      window.requestAnimationFrame(() => {
        if (badge.isConnected && badge._ccCountVersion === version) badge.classList.add('is-visible');
      });
    });
  };
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const motionEnabled = () => document.body.classList.contains('cc-motion-enabled') && !reduceMotion.matches;
  /* v2.16.31 — cc706: on phones every dropdown / drawer / accordion opens and
     closes instantly (no animation). Their animations were slow and choppy on
     most phones. Everything else (shelves, hero, reveals) keeps its motion. */
  const phoneDropdowns = window.matchMedia('(max-width: 767px)');
  const dropdownMotion = () => motionEnabled() && !phoneDropdowns.matches;
  const WISHLIST_KEY = 'cc-wishlist-v1';

  /* Input-type detection for tooltip suppression.
     Media queries alone are unreliable here: touch laptops and tablets
     with a mouse report hover:hover / pointer:fine, so hover-intent
     tooltips would stick open after a tap (there is no pointerleave to
     dismiss them). Reading the actual pointer event is accurate on those
     devices. Re-evaluated on every pointerdown so hybrid devices that
     switch between finger and mouse behave correctly in both modes. */
  (function trackPointerInput() {
    const apply = (isTouch) => {
      document.documentElement.classList.toggle('cc-touch-input', isTouch);
      if (document.body) document.body.classList.toggle('cc-touch-input', isTouch);
    };
    const onPointer = (event) => {
      apply(event.pointerType === 'touch' || event.pointerType === 'pen');
    };
    if (window.PointerEvent) {
      document.addEventListener('pointerdown', onPointer, { passive: true, capture: true });
    } else if ('ontouchstart' in window) {
      document.addEventListener('touchstart', () => apply(true), { passive: true, capture: true });
    }
    // Seed from media query so the very first paint is already correct.
    if (window.matchMedia && window.matchMedia('(hover: none) and (pointer: coarse)').matches) {
      if (document.body) apply(true);
      else document.addEventListener('DOMContentLoaded', () => apply(true), { once: true });
    }
  })();


  let ccMoneyFormatter = null;
  let ccMoneyFormatterCurrency = '';
  const money = (cents) => {
    try {
      const currency = window.CANADA_COLOGNE?.currency || 'CAD';
      if (!ccMoneyFormatter || ccMoneyFormatterCurrency !== currency) {
        /* Canadian formatting for CAD so prices match the Liquid "${{amount}}"
           output ($11.99) in every browser language, not "CA$11.99". */
        ccMoneyFormatter = new Intl.NumberFormat(currency === 'CAD' ? 'en-CA' : undefined, { style: 'currency', currency });
        ccMoneyFormatterCurrency = currency;
      }
      return ccMoneyFormatter.format((Number(cents) || 0) / 100);
    } catch (_) {
      return `$${((Number(cents) || 0) / 100).toFixed(2)}`;
    }
  };

  const moneyWithCurrency = (cents) => {
    const formatted = money(cents);
    const currency = window.CANADA_COLOGNE?.currency || 'CAD';
    if (currency === 'CAD') return `${formatted.replace(/^CA\$/, '$')} CAD`;
    return `${formatted} ${currency}`;
  };

  const drawerMoney = (cents) => {
    const formatted = money(cents);
    return (window.CANADA_COLOGNE?.currency || 'CAD') === 'CAD' ? formatted.replace(/^CA\$/, '$') : formatted;
  };

  async function shopifyRequestError(response, fallback = 'Shopify request failed') {
    let description = '';
    try {
      const payload = await response.clone().json();
      description = payload?.description || payload?.message || payload?.status || '';
    } catch (_) {
      try { description = await response.clone().text(); } catch (_) {}
    }
    const error = new Error(String(description || fallback));
    error.status = response.status;
    return error;
  }

  const isStockError = (error) => error?.status === 422 || /stock|quantity|available|maximum|inventory|sold out|out of stock/i.test(error?.message || '');
  const isSoldOutError = (error) => /sold out|out of stock|unavailable|not available/i.test(error?.message || '');

  const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, (character) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;',
  }[character]));
  /* Shopper-facing name under a separate brand line (cart + wishlist drawers). Same rule as the
     product cards: keep a "Decant - " lead, remove the brand once. "Decant - Dior Dior Homme Parfum"
     → "Decant - Dior Homme Parfum"; "Lattafa Yara" (brand Lattafa) → "Yara". */
  const cleanProductTitle = (rawTitle = '', vendor = '') => {
    const original = String(rawTitle || '').trim();
    let title = original;
    let lead = '';
    const decantLead = /^decant\s*[-\u2014]\s*/i;
    if (decantLead.test(title)) {
      lead = 'Decant - ';
      title = title.replace(decantLead, '');
    }
    const brand = String(vendor || '').trim();
    if (brand) {
      const at = title.indexOf(`${brand} `);
      if (at !== -1) title = `${title.slice(0, at)}${title.slice(at + brand.length + 1)}`.trim();
    }
    return title ? `${lead}${title}` : original;
  };

  /* Performance: product images from Shopify's CDN are stored at full size
     (often ~2000px). Card, drawer and Recently Viewed images display at about
     200px, so ask the CDN for a 600px rendition (sharp on 3x phone screens)
     instead of decoding a full-size original while scrolling. */
  const sizedShopifyImage = (url = '', width = 600) => {
    const value = String(url || '');
    if (!value || !/(\/cdn\/shop\/|cdn\.shopify\.com)/.test(value)) return value;
    if (/[?&]width=/.test(value) || /_\d+x\d*\.|\.svg(\?|$)|\.gif(\?|$)/i.test(value)) return value;
    return `${value}${value.includes('?') ? '&' : '?'}width=${width}`;
  };

  const fallbackImageFor = (handle = '') => {
    const safeHandle = String(handle || '').trim();
    if (!safeHandle) return window.CANADA_COLOGNE?.fallbackPlaceholder || '';
    return `${window.CANADA_COLOGNE?.themeAssetBase || ''}fallback-${encodeURIComponent(safeHandle)}.webp`;
  };

  let ccCatalogMediaMapCache = null;
  const catalogMediaMap = () => {
    if (ccCatalogMediaMapCache) return ccCatalogMediaMapCache;
    try {
      const node = document.getElementById('CanadaCologneCatalogMediaMap');
      const records = JSON.parse(node?.textContent || '[]');
      ccCatalogMediaMapCache = new Map(records.map((record) => [String(record?.handle || '').toLowerCase(), record]));
    } catch (_) {
      ccCatalogMediaMapCache = new Map();
    }
    return ccCatalogMediaMapCache;
  };

  const canonicalProductHandle = (item = {}) => {
    const direct = String(item.handle || item.product_handle || '').trim().toLowerCase();
    if (direct) return direct;
    const url = String(item.url || '');
    const match = url.match(/\/products\/([^?/#]+)/i);
    return match ? decodeURIComponent(match[1]).toLowerCase() : '';
  };

  const catalogMediaFor = (handle = '', isDecant = null) => {
    const safeHandle = String(handle || '').trim().toLowerCase();
    if (!safeHandle) return { image: '', secondaryImage: '' };
    const record = catalogMediaMap().get(safeHandle);
    if (!record) return { image: '', secondaryImage: '' };
    const decant = typeof isDecant === 'boolean' ? isDecant : safeHandle.startsWith('decant-');
    /* Theme-asset originals are up to 2000px; drawers and recently-viewed cards
       display them far smaller, so request a 600px rendition from Shopify's CDN. */
    const sized = (url = '') => sizedShopifyImage(url);
    if (record.single1) return { image: sized(record.single1 || ''), secondaryImage: sized(record.single2 || '') };
    if (decant) return { image: sized(record.bottle || record.box || ''), secondaryImage: record.bottle ? sized(record.box || '') : '' };
    return { image: sized(record.box || record.bottle || ''), secondaryImage: record.box ? sized(record.bottle || '') : '' };
  };

  document.addEventListener('error', (event) => {
    const image = event.target;
    if (!(image instanceof HTMLImageElement)) return;
    const handle = image.dataset.fallbackHandle;
    if (!handle || image.dataset.fallbackTried === 'true') return;
    image.dataset.fallbackTried = 'true';
    const fallback = fallbackImageFor(handle);
    if (fallback) {
      image.removeAttribute('srcset');
      image.src = fallback;
    }
  }, true);

  /* Header and mobile navigation */
  const header = q('[data-site-header]');
  const headerHost = header?.closest('.shopify-section') || header?.parentElement || null;
  headerHost?.classList.add('cc-sticky-header-host');
  const mobileMenu = q('[data-mobile-menu]');
  const menuButton = q('[data-menu-toggle]');

  /* the storefront header is deliberately geometry-static.
     Do not add scroll-state classes that can alter padding, backdrop, or layout. */
  function syncHeader() {
    if (!header) return;
    header.classList.remove('is-scrolled');
  }

  syncHeader();

  /* v2.16 — the ☰ menu opens and closes by animating its real height (plus
     a fade and a 6px drift of the links), so it glides open and shut instead
     of snapping. Reversible mid-animation; honours reduced motion. */
  const MOBILE_MENU_MS = 420;
  mobileMenu?.classList.add('cc-menu-js');
  const mobileMenuIsOpen = () => Boolean(mobileMenu && !mobileMenu.hidden && !mobileMenu.classList.contains('is-closing'));
  function finishMobileMenuMotion() {
    if (!mobileMenu) return;
    window.clearTimeout(mobileMenu._ccMenuTimer);
    mobileMenu._ccMenuTimer = 0;
    if (mobileMenu.classList.contains('is-closing')) mobileMenu.hidden = true;
    mobileMenu.classList.remove('is-animating', 'is-closing', 'is-collapsed');
    mobileMenu.style.height = '';
  }
  function setMobileMenuOpen(open, { immediate = false } = {}) {
    if (!mobileMenu) return;
    open = Boolean(open);
    menuButton?.setAttribute('aria-expanded', String(open));
    document.body.classList.toggle('menu-open', open);
    if (open === mobileMenuIsOpen()) return;
    const animate = !immediate && dropdownMotion();
    const startHeight = mobileMenu.hidden ? 0 : mobileMenu.getBoundingClientRect().height;
    window.clearTimeout(mobileMenu._ccMenuTimer);

    if (open) {
      mobileMenu.classList.remove('is-closing', 'is-collapsed', 'is-animating');
      mobileMenu.hidden = false;
      if (!animate) { finishMobileMenuMotion(); return; }
      mobileMenu.style.height = '';
      const endHeight = mobileMenu.getBoundingClientRect().height;
      mobileMenu.style.height = `${startHeight}px`;
      if (!startHeight) mobileMenu.classList.add('is-collapsed');
      void mobileMenu.offsetHeight;
      mobileMenu.classList.add('is-animating');
      window.requestAnimationFrame(() => {
        mobileMenu.classList.remove('is-collapsed');
        mobileMenu.style.height = `${endHeight}px`;
      });
    } else {
      if (!animate) { mobileMenu.classList.add('is-closing'); finishMobileMenuMotion(); return; }
      mobileMenu.classList.remove('is-collapsed');
      mobileMenu.style.height = `${startHeight}px`;
      void mobileMenu.offsetHeight;
      mobileMenu.classList.add('is-animating', 'is-closing');
      window.requestAnimationFrame(() => {
        mobileMenu.classList.add('is-collapsed');
        mobileMenu.style.height = '0px';
      });
    }
    mobileMenu._ccMenuTimer = window.setTimeout(finishMobileMenuMotion, MOBILE_MENU_MS + 60);
  }

  menuButton?.addEventListener('click', () => {
    setMobileMenuOpen(!mobileMenuIsOpen());
  });

  /* compact header search popup (phone + browser-zoom compact state). */
  const compactSearchToggle = q('[data-compact-search-toggle]');
  const compactSearchPanel = q('[data-compact-search-panel]');
  const compactSearchInput = q('[data-compact-search-input]');

  const setCompactSearchOpen = (open) => {
    if (!header || !compactSearchPanel || !compactSearchToggle) return;
    const isOpen = !compactSearchPanel.hidden && !compactSearchPanel.classList.contains('is-closing');
    if (Boolean(open) === isOpen) return;
    header.classList.toggle('cc-compact-search-open', Boolean(open));
    compactSearchToggle.setAttribute('aria-expanded', String(Boolean(open)));
    /* Same open/close motion + page blur as the cart, wishlist and contact dropdowns. */
    if (open) {
      closeHeaderDropdownsForSearch();
      showHeaderDrawer(compactSearchPanel);
    } else {
      hideHeaderDrawer(compactSearchPanel);
      const compactPredictivePanel = q('[data-predictive-search-panel]', compactSearchPanel);
      if (compactPredictivePanel) compactPredictivePanel.hidden = true;
    }
    if (open) {
      setMobileMenuOpen(false);
      requestAnimationFrame(() => compactSearchInput?.focus({ preventScroll: true }));
    }
  };

  compactSearchToggle?.addEventListener('click', (event) => {
    event.preventDefault();
    setCompactSearchOpen(!compactSearchPanel || compactSearchPanel.hidden || compactSearchPanel.classList.contains('is-closing'));
  });

  compactSearchPanel?.addEventListener('submit', (event) => {
    if (!compactSearchInput || compactSearchInput.value.trim() !== '') return;
    event.preventDefault();
    compactSearchInput.focus({ preventScroll: true });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && compactSearchPanel && !compactSearchPanel.hidden && !compactSearchPanel.classList.contains('is-closing')) {
      setCompactSearchOpen(false);
      compactSearchToggle?.focus({ preventScroll: true });
    }
  });

  document.addEventListener('pointerdown', (event) => {
    if (compactSearchPanel?.hasAttribute('hidden')) return;
    if (compactSearchPanel?.contains(event.target) || compactSearchToggle?.contains(event.target)) return;
    setCompactSearchOpen(false);
  }, { passive: true });

  window.addEventListener('resize', () => {
    if (window.innerWidth > 899) setCompactSearchOpen(false);
  }, { passive: true });

  function closeMobileMenuOnDesktop() {
    if (window.innerWidth <= 1023) return;
    setMobileMenuOpen(false, { immediate: true });
  }

  closeMobileMenuOnDesktop();
  window.addEventListener('resize', closeMobileMenuOnDesktop, { passive: true });

  /* Header drawer motion — shared by cart + wishlist.
     One reversible CSS transition owns the panel; JS waits for the real
     transform transition to finish instead of hiding on a fixed frame timer. */
  const HEADER_DRAWER_MOTION_MS = 600;
  const headerDrawerCloseWaits = new WeakMap();

  function clearHeaderDrawerCloseWait(panel) {
    const cleanup = headerDrawerCloseWaits.get(panel);
    if (cleanup) cleanup();
    headerDrawerCloseWaits.delete(panel);
  }

  function showHeaderDrawer(panel) {
    if (!panel) return;
    clearHeaderDrawerCloseWait(panel);
    panel.classList.remove('is-closing');
    panel.hidden = false;
    if (!dropdownMotion()) {
      panel.classList.remove('is-opening');
      return;
    }
    // Start from the closed visual state before the browser paints the panel.
    panel.classList.add('is-opening');
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        if (!panel.hidden && !panel.classList.contains('is-closing')) {
          panel.classList.remove('is-opening');
        }
      });
    });
  }

  function hideHeaderDrawer(panel, { immediate = false } = {}) {
    if (!panel) return;
    clearHeaderDrawerCloseWait(panel);
    panel.classList.remove('is-opening');
    if (panel.hidden) {
      panel.classList.remove('is-closing');
      return;
    }
    if (immediate || !dropdownMotion()) {
      panel.hidden = true;
      panel.classList.remove('is-closing');
      return;
    }

    panel.classList.add('is-closing');
    let settled = false;
    let fallbackTimer = 0;

    const finish = () => {
      if (settled) return;
      settled = true;
      panel.removeEventListener('transitionend', onTransitionEnd);
      if (fallbackTimer) window.clearTimeout(fallbackTimer);
      headerDrawerCloseWaits.delete(panel);
      // If the drawer was reopened mid-close, showHeaderDrawer already removed
      // is-closing, so never hide it here.
      if (!panel.classList.contains('is-closing')) return;
      panel.hidden = true;
      panel.classList.remove('is-closing');
    };
    const onTransitionEnd = (event) => {
      if (event.target === panel && event.propertyName === 'transform') finish();
    };

    panel.addEventListener('transitionend', onTransitionEnd);
    // Safety only for browsers that suppress transitionend; normal closing is
    // governed by the real transition completion above.
    fallbackTimer = window.setTimeout(finish, HEADER_DRAWER_MOTION_MS + 180);
    headerDrawerCloseWaits.set(panel, () => {
      settled = true;
      panel.removeEventListener('transitionend', onTransitionEnd);
      if (fallbackTimer) window.clearTimeout(fallbackTimer);
    });
  }

  /* Header contact drawers — same click/open/close motion contract as Cart + Wishlist. */
  const contactToggles = qa('[data-contact-toggle]');
  const contactPanels = qa('[data-contact-preview]');

  function closeContactDrawers({ except = null, immediate = false } = {}) {
    contactPanels.forEach((panel) => {
      if (panel === except) return;
      hideHeaderDrawer(panel, { immediate });
      const key = panel.dataset.contactPreview || '';
      q(`[data-contact-toggle="${key}"]`)?.setAttribute('aria-expanded', 'false');
    });
  }

  async function copyContactValue(value) {
    const text = String(value || '');
    if (!text) return false;
    try {
      if (navigator.clipboard?.writeText && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
        return true;
      }
    } catch (_) {}

    const helper = document.createElement('textarea');
    helper.value = text;
    helper.setAttribute('readonly', '');
    helper.style.position = 'fixed';
    helper.style.opacity = '0';
    helper.style.pointerEvents = 'none';
    document.body.appendChild(helper);
    helper.select();
    helper.setSelectionRange(0, helper.value.length);
    let copied = false;
    try { copied = document.execCommand('copy'); } catch (_) {}
    helper.remove();
    return copied;
  }

  contactToggles.forEach((toggle) => {
    toggle.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      const key = toggle.dataset.contactToggle || '';
      const panel = q(`[data-contact-preview="${key}"]`);
      if (!panel) return;
      const opening = Boolean(panel.hidden);

      if (!opening) {
        hideHeaderDrawer(panel);
        toggle.setAttribute('aria-expanded', 'false');
        return;
      }

      closeContactDrawers({ except: panel });
      const cart = q('[data-cart-preview]');
      const cartButton = q('[data-cart-toggle]');
      hideHeaderDrawer(cart);
      cartButton?.setAttribute('aria-expanded', 'false');
      header?.classList.remove('cart-drawer-open');

      const wishlist = q('[data-wishlist-preview]');
      const wishlistButton = q('[data-wishlist-header]');
      hideHeaderDrawer(wishlist);
      wishlistButton?.setAttribute('aria-expanded', 'false');

      showHeaderDrawer(panel);
      toggle.setAttribute('aria-expanded', 'true');
    });
  });

  document.addEventListener('click', async (event) => {
    const copyButton = event.target.closest('[data-contact-copy]');
    if (!copyButton) return;
    event.preventDefault();
    event.stopPropagation();

    const value = copyButton.dataset.contactCopy || '';
    const copied = await copyContactValue(value);
    const panel = copyButton.closest('[data-contact-preview]');
    const label = q('[data-contact-copy-label]', copyButton);
    const status = panel ? q('[data-contact-copy-status]', panel) : null;
    const footerBlock = copyButton.matches('[data-footer-contact-copy]') ? copyButton.closest('.footer-connect-block') : null;
    const footerStatus = footerBlock ? q('[data-footer-copy-status]', footerBlock) : null;
    if (label) label.textContent = copied ? 'COPIED' : 'TRY AGAIN';
    if (status) status.textContent = copied ? 'Copied to clipboard.' : 'Could not copy automatically.';
    if (footerStatus) {
      qa('[data-footer-contact-copy]', footerBlock).forEach((button) => {
        if (button === copyButton) return;
        window.clearTimeout(button._ccContactCopyTimer);
        button.classList.remove('is-copied');
        button.setAttribute('aria-label', button.dataset.footerCopyLabel || 'Copy contact detail');
      });
      window.clearTimeout(footerStatus._ccContactCopyTimer);
      footerStatus.textContent = copied ? 'Copied' : 'Could not copy automatically';
      footerStatus._ccContactCopyTimer = window.setTimeout(() => {
        footerStatus.textContent = '';
      }, 2200);
    }
    copyButton.classList.toggle('is-copied', copied);
    copyButton.setAttribute('aria-label', copied ? 'Copied to clipboard' : (copyButton.dataset.footerCopyLabel || copyButton.getAttribute('aria-label') || 'Copy contact detail'));

    /* a mouse click must not leave the copy control focused,
       otherwise the row's existing :focus-within hover wash can remain
       visible after the pointer leaves. The copied/check state is untouched. */
    if (typeof copyButton.blur === 'function') {
      window.requestAnimationFrame(() => copyButton.blur());
    }

    window.clearTimeout(copyButton._ccContactCopyTimer);
    copyButton._ccContactCopyTimer = window.setTimeout(() => {
      copyButton.classList.remove('is-copied');
      if (label) label.textContent = 'COPY';
      if (status) status.textContent = '';
      if (copyButton.dataset.footerCopyLabel) {
        copyButton.setAttribute('aria-label', copyButton.dataset.footerCopyLabel);
      } else if (copyButton.dataset.contactCopy && copyButton.dataset.contactCopy.includes('@')) {
        copyButton.setAttribute('aria-label', 'Copy support email');
      } else {
        copyButton.setAttribute('aria-label', 'Copy support phone number');
      }
    }, footerStatus ? (copied ? 1200 : 1500) : (copied ? 1500 : 2000));
  });

  /* response-time metadata uses a real pointer hover state.
     This avoids browser focus/click states latching the note after an
     Email/Phone link or COPY control is clicked. */
  qa('.cc301-support-card .cc301-support-main').forEach((main) => {
    const showMeta = () => {
      if (main.dataset.cc345MetaSuppressed === 'true') return;
      main.classList.add('cc345-meta-active');
    };
    const hideMeta = () => {
      main.classList.remove('cc345-meta-active');
    };

    main.addEventListener('pointerenter', showMeta);
    main.addEventListener('pointerleave', () => {
      hideMeta();
      delete main.dataset.cc345MetaSuppressed;
    });

    /* A click must never leave the optional note latched on.  Keep it
       suppressed until the pointer genuinely leaves, then the next hover
       can reveal it normally again. */
    main.addEventListener('click', () => {
      hideMeta();
      main.dataset.cc345MetaSuppressed = 'true';
    });
    main.addEventListener('blur', hideMeta);
  });

  qa('.cc301-support-card [data-contact-copy]').forEach((button) => {
    button.addEventListener('pointerenter', () => {
      const row = button.closest('.cc301-support-row');
      const main = row?.querySelector('.cc301-support-main');
      if (main) main.classList.remove('cc345-meta-active');
    });
    button.addEventListener('click', () => {
      const row = button.closest('.cc301-support-row');
      const main = row?.querySelector('.cc301-support-main');
      if (!main) return;
      main.classList.remove('cc345-meta-active');
      main.dataset.cc345MetaSuppressed = 'true';
    });
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest('.header-contact-wrap')) return;
    closeContactDrawers();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const hadOpenContact = contactPanels.some((panel) => !panel.hidden);
    if (!hadOpenContact) return;
    closeContactDrawers();
  });

  /* Shopify cart preview — cached and instant-opening for a faster header interaction. */
  const cartToggle = q('[data-cart-toggle]');
  const cartPanel = q('[data-cart-preview]');
  /* v2.16 cart store — one source of truth for the cart drawer, header count,
     subtotal, shipping bar and every Add To Cart button.

     Why: the old drawer fired overlapping /cart/change.js, /cart/add.js and
     /cart.js requests. Shopify answered them out of order, older answers
     overwrote newer ones, add.js line quantities were counted as deltas, and
     +/− were disabled while a request was in flight, so fast clicks were lost.

     How it works now:
     • Every request that reads or writes the cart runs through ONE serial
       queue, so Shopify's answers always arrive in the order they were asked.
     • +/− and the quantity box are optimistic and never disabled. Each line
       keeps only its latest wanted quantity; a burst of 10 clicks sends at
       most two requests for that line.
     • What the customer sees (cartCache) is always computed from the last
       confirmed Shopify cart plus the quantities still being sent, so the
       subtotal, line totals, item count and shipping bar always add up. */
  let cartServer = null;
  let cartServerAt = 0;
  let cartCache = null;
  let cartWarmSignature = '';
  const CART_CACHE_TTL = 15000;
  const cartLineTargets = new Map();
  const cartLineNotices = new Map();
  const cartJobs = [];
  let cartPumping = false;
  let cartRefreshJob = null;
  const cartRoot = () => window.CANADA_COLOGNE?.rootUrl || '/';
  const CART_JSON_HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json' };

  /* Stock limits for the lines in the cart, read from sections/cc-cart-stock
     (bundled into every cart request, so it costs no extra round trip on
     changes). variant id -> most that can be bought, or null = no limit.
     With this the drawer never shows more than Shopify will actually allow. */
  const CART_STOCK_SECTION = 'cc-cart-stock';
  const cartStock = new Map();

  function absorbCartStock(sections) {
    const html = sections?.[CART_STOCK_SECTION];
    if (typeof html !== 'string') return;
    const match = /data-cc-cart-stock[^>]*>([\s\S]*?)<\/script>/.exec(html);
    if (!match) return;
    try {
      const limits = JSON.parse(match[1].trim() || '{}');
      Object.entries(limits).forEach(([variantId, max]) => {
        cartStock.set(String(variantId), max === null ? null : Math.max(0, Number(max) || 0));
      });
    } catch (_) {}
  }

  /* Most this line can hold: variant stock minus any other lines of the same
     variant. null when unknown or not tracked. */
  function cartLineMax(key) {
    const item = cartServer?.items?.find((entry) => entry.key === key);
    if (!item) return null;
    const variantId = String(item.variant_id);
    if (!cartStock.has(variantId)) return null;
    const max = cartStock.get(variantId);
    if (max === null || !Number.isFinite(max)) return null;
    const others = (cartCache?.items || []).reduce((sum, entry) => (
      entry.key !== key && String(entry.variant_id) === variantId ? sum + Number(entry.quantity || 0) : sum
    ), 0);
    return Math.max(0, max - others);
  }

  function cartUnitPrice(item) {
    return Number(item?.final_price ?? item?.price ?? 0);
  }

  function deriveCartView() {
    if (!cartServer) return null;
    if (!cartLineTargets.size) return cartServer;
    let countDelta = 0;
    let totalDelta = 0;
    const items = [];
    (cartServer.items || []).forEach((item) => {
      if (!cartLineTargets.has(item.key)) {
        items.push(item);
        return;
      }
      const confirmed = Math.max(0, Number(item.quantity || 0));
      const wanted = cartLineTargets.get(item.key);
      const unit = cartUnitPrice(item);
      countDelta += wanted - confirmed;
      totalDelta += (wanted - confirmed) * unit;
      if (wanted > 0) {
        items.push({
          ...item,
          quantity: wanted,
          final_line_price: unit * wanted,
          line_price: Number(item.price ?? unit) * wanted,
          original_line_price: Number(item.original_price ?? item.price ?? unit) * wanted,
        });
      }
    });
    return {
      ...cartServer,
      items,
      item_count: Math.max(0, Number(cartServer.item_count || 0) + countDelta),
      total_price: Math.max(0, Math.round(Number(cartServer.total_price || 0) + totalDelta)),
    };
  }

  function commitCart() {
    cartCache = deriveCartView();
    paintCart();
  }

  function acceptServerCart(cart) {
    if (!cart || !Array.isArray(cart.items)) return;
    if (cart.sections) absorbCartStock(cart.sections);
    cartServer = cart;
    cartServerAt = Date.now();
    // A line removed elsewhere (another tab, checkout) has nothing left to send.
    const liveKeys = new Set(cart.items.map((item) => item.key));
    cartLineTargets.forEach((_, key) => { if (!liveKeys.has(key)) cartLineTargets.delete(key); });
    cartLineNotices.forEach((_, key) => { if (!liveKeys.has(key)) cartLineNotices.delete(key); });
    commitCart();
  }

  async function fetchServerCart() {
    const [response, stockResponse] = await Promise.all([
      fetch(`${cartRoot()}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' }),
      fetch(`${cartRoot()}?sections=${CART_STOCK_SECTION}`, { headers: { Accept: 'application/json' }, cache: 'no-store' }).catch(() => null),
    ]);
    if (!response.ok) throw new Error('Cart unavailable');
    if (stockResponse?.ok) {
      try { absorbCartStock(await stockResponse.json()); } catch (_) {}
    }
    const cart = await response.json();
    acceptServerCart(cart);
    return cart;
  }

  function enqueueCartJob(run) {
    return new Promise((resolve, reject) => {
      cartJobs.push({ run, resolve, reject });
      pumpCart();
    });
  }

  function settleCartLineTarget(key, sent) {
    if (!cartLineTargets.has(key)) return;
    const latest = cartLineTargets.get(key);
    cartLineTargets.delete(key);
    // Newer clicks arrived while this was in flight: send them next, after
    // other lines have had their turn.
    if (latest !== sent) cartLineTargets.set(key, latest);
  }

  async function sendCartLineTarget(key, target) {
    const confirmedItem = cartServer?.items?.find((item) => item.key === key);
    if (!confirmedItem) {
      cartLineTargets.delete(key);
      return;
    }
    if (Number(confirmedItem.quantity || 0) === target) {
      cartLineTargets.delete(key);
      return;
    }
    try {
      const response = await fetch(`${cartRoot()}cart/change.js`, {
        method: 'POST',
        headers: CART_JSON_HEADERS,
        body: JSON.stringify({ id: key, quantity: target, sections: CART_STOCK_SECTION }),
      });
      if (!response.ok) throw await shopifyRequestError(response, 'Could not update cart');
      settleCartLineTarget(key, target);
      const cart = await response.json();
      acceptServerCart(cart);
      const confirmed = cart.items?.find((item) => item.key === key);
      if (confirmed && target > Number(confirmed.quantity || 0) && !cartLineTargets.has(key)) {
        cartLineNotices.set(key, { message: 'Max Stock.', stock: true });
        commitCart();
      }
    } catch (error) {
      console.warn(error);
      const stockLimit = isStockError(error);
      const latest = cartLineTargets.get(key);
      // A stock error also rules out any larger quantity queued behind it.
      if (latest === target || (stockLimit && latest >= target)) cartLineTargets.delete(key);
      else settleCartLineTarget(key, target);
      cartLineNotices.set(key, stockLimit
        ? { message: 'Max Stock.', stock: true }
        : { message: 'Couldn’t update quantity. Please try again.', stock: false });
      try { await fetchServerCart(); } catch (_) { commitCart(); }
    }
  }

  function pumpCart() {
    if (cartPumping) return;
    cartPumping = true;
    // Start on a microtask so callers finish their own bookkeeping first.
    Promise.resolve().then(async () => {
      try {
        while (cartLineTargets.size || cartJobs.length) {
          if (cartLineTargets.size) {
            const [key, target] = cartLineTargets.entries().next().value;
            await sendCartLineTarget(key, target);
            continue;
          }
          const job = cartJobs.shift();
          try { job.resolve(await job.run()); }
          catch (error) { job.reject(error); }
        }
      } finally {
        cartPumping = false;
        if (cartLineTargets.size || cartJobs.length) pumpCart();
        else commitCart();
      }
    });
  }

  function getCart(force = false) {
    if (!force && cartCache && (Date.now() - cartServerAt) < CART_CACHE_TTL) return Promise.resolve(cartCache);
    if (cartRefreshJob) return cartRefreshJob;
    const job = enqueueCartJob(async () => {
      if (cartRefreshJob === job) cartRefreshJob = null;
      await fetchServerCart();
      return cartCache;
    });
    job.catch(() => {}).finally(() => { if (cartRefreshJob === job) cartRefreshJob = null; });
    cartRefreshJob = job;
    return job;
  }

  /* Every Add To Cart on the site goes through here. It resolves with Shopify's
     add.js payload only after the full cart has been re-read in queue order,
     so the drawer, subtotal and stock checks are exact the moment it opens. */
  function cartAdd(body) {
    return enqueueCartJob(async () => {
      const isForm = typeof FormData !== 'undefined' && body instanceof FormData;
      const requested = isForm
        ? [{ id: body.get('id'), quantity: body.get('quantity') || 1 }]
        : (Array.isArray(body?.items) ? body.items : [body]);
      const overStock = requested.some((entry) => {
        const variantId = String(entry?.id || '');
        if (!variantId || !cartStock.has(variantId)) return false;
        const max = cartStock.get(variantId);
        if (max === null) return false;
        return cartQuantityForVariant(cartCache, variantId) + Math.max(1, Number(entry.quantity) || 1) > max;
      });
      if (overStock) {
        const error = new Error('Max Stock.');
        error.status = 422;
        throw error;
      }
      const response = await fetch(`${cartRoot()}cart/add.js`, {
        method: 'POST',
        headers: isForm ? { Accept: 'application/json' } : CART_JSON_HEADERS,
        body: isForm ? body : JSON.stringify(body),
      });
      if (!response.ok) {
        const error = await shopifyRequestError(response, 'Could not add item');
        try { await fetchServerCart(); } catch (_) {}
        throw error;
      }
      const payload = await response.json();
      try { await fetchServerCart(); } catch (error) { console.warn(error); }
      return payload;
    });
  }

  let pendingCartDrawerNote = null;
  let cartDrawerNoteTimer = null;
  let cartDrawerNoteVersion = 0;
  let cartDrawerNoteSavingPromise = null;
  const CART_DISCOUNT_STORAGE_KEY = 'cc-cart-discount-code';

  function storedCartDiscountCode() {
    try { return String(window.sessionStorage.getItem(CART_DISCOUNT_STORAGE_KEY) || '').trim(); }
    catch (_) { return ''; }
  }

  function storeCartDiscountCode(code) {
    const clean = String(code || '').trim();
    try {
      if (clean) window.sessionStorage.setItem(CART_DISCOUNT_STORAGE_KEY, clean);
      else window.sessionStorage.removeItem(CART_DISCOUNT_STORAGE_KEY);
    } catch (_) {}
    return clean;
  }

  /* v2.15.672 — Discount code / Add an order note open by animating their own
     pixel height. The panels used to animate grid-template-rows 0fr -> 1fr,
     which phone browsers either snap outright or interpolate expensively, so
     the panel jumped while the text faded. Every browser interpolates a pixel
     height, and the height is released back to auto once the panel is open so
     the panel still grows with its content. */
  function setCartPreviewToolOpen(tool, open, { animate = false } = {}) {
    if (!tool) return;
    tool.classList.toggle('is-open', Boolean(open));
    const trigger = q('[data-cart-preview-tool-trigger]', tool);
    const panel = q('.cc226-cart-tool-panel', tool);
    trigger?.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel?.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (!panel) return;

    if (panel._ccToolHeightTimer) {
      window.clearTimeout(panel._ccToolHeightTimer);
      panel._ccToolHeightTimer = 0;
    }

    const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    if (!animate || reduceMotion || phoneDropdowns.matches) {
      panel.style.height = open ? 'auto' : '0px';
      return;
    }

    const inner = q('.cc226-cart-tool-inner', panel) || panel.firstElementChild;
    const startHeight = panel.getBoundingClientRect().height;
    const endHeight = open ? (inner ? inner.getBoundingClientRect().height : panel.scrollHeight) : 0;
    panel.style.height = `${startHeight}px`;
    void panel.offsetHeight;
    window.requestAnimationFrame(() => {
      panel.style.height = `${endHeight}px`;
    });
    panel._ccToolHeightTimer = window.setTimeout(() => {
      panel._ccToolHeightTimer = 0;
      if (tool.classList.contains('is-open')) panel.style.height = 'auto';
    }, 320);
  }

  async function saveCartDrawerNote(value, { immediateStatus = true } = {}) {
    const cleanValue = String(value ?? '');
    pendingCartDrawerNote = cleanValue;
    const version = ++cartDrawerNoteVersion;
    const status = q('[data-cart-preview-note-status]', cartPanel || document);
    if (immediateStatus && status) status.textContent = 'Saving…';

    // Runs in the cart queue so it can never overwrite a newer quantity change.
    const request = enqueueCartJob(async () => {
      const response = await fetch(`${cartRoot()}cart/update.js`, {
        method: 'POST',
        headers: CART_JSON_HEADERS,
        body: JSON.stringify({ note: cleanValue, sections: CART_STOCK_SECTION }),
      });
      if (!response.ok) throw await shopifyRequestError(response, 'Could not save order note');
      const cart = await response.json();
      acceptServerCart(cart);
      return cart;
    })
      .then((cart) => {
        if (version === cartDrawerNoteVersion) {
          pendingCartDrawerNote = null;
          const liveStatus = q('[data-cart-preview-note-status]', cartPanel || document);
          if (liveStatus) {
            liveStatus.textContent = 'Saved';
            window.setTimeout(() => {
              if (liveStatus.textContent === 'Saved') liveStatus.textContent = 'Order notes are saved with your order.';
            }, 1400);
          }
        }
        return cart;
      })
      .catch((error) => {
        console.warn(error);
        if (version === cartDrawerNoteVersion) {
          const liveStatus = q('[data-cart-preview-note-status]', cartPanel || document);
          if (liveStatus) liveStatus.textContent = 'Could not save. Try again.';
        }
        throw error;
      })
      .finally(() => {
        if (cartDrawerNoteSavingPromise === request) cartDrawerNoteSavingPromise = null;
      });

    cartDrawerNoteSavingPromise = request;
    return request;
  }

  function renderCart(cart) {
    cartWarmSignature = '';
    syncHeaderCount('[data-cart-count]', cart.item_count);
    if (!cartPanel) return;

    const openToolKeys = new Set(
      qa('[data-cart-preview-tool].is-open', cartPanel).map((tool) => tool.dataset.cartPreviewTool || '')
    );

    cartPanel.classList.toggle('is-empty-cart', !cart.item_count);
    if (!cart.item_count) {
      cartPanel.innerHTML = `<div class="cart-preview-head"><strong>YOUR CART</strong></div><div class="cc330-outer-scroll-shell"><div class="cc329-outer-scroll-viewport" data-outer-drawer-scroll><div class="cart-preview-empty"><strong>Your cart is empty.</strong><span>Add a fragrance to get started.</span></div></div></div>`;
      return;
    }

    const visibleItems = cart.items;
    const currency = window.CANADA_COLOGNE?.currency || 'CAD';
    const subtotal = currency === 'CAD' ? `${drawerMoney(cart.total_price)} CAD` : moneyWithCurrency(cart.total_price);
    const freeShippingThreshold = Number(window.CANADA_COLOGNE?.freeShippingThreshold || 0);
    const shippingRemaining = Math.max(0, freeShippingThreshold - Number(cart.total_price || 0));
    const shippingProgress = freeShippingThreshold > 0
      ? Math.min(100, Math.max(0, (Number(cart.total_price || 0) / freeShippingThreshold) * 100))
      : 100;
    const noteValue = pendingCartDrawerNote !== null ? pendingCartDrawerNote : (cart.note || '');
    const discountCode = storedCartDiscountCode();

    cartPanel.innerHTML = `
      <div class="cart-preview-head"><strong>YOUR CART</strong><span>${cart.item_count} item${cart.item_count === 1 ? '' : 's'}</span></div>
      <div class="cc330-outer-scroll-shell">
      <div class="cc329-outer-scroll-viewport" data-outer-drawer-scroll>
      <div class="cc324-drawer-scroll-shell" data-drawer-scroll-shell>
        <div class="cart-preview-items" data-drawer-scroll-region>
        ${visibleItems.map((item) => {
          const drawerHandle = canonicalProductHandle(item);
          const drawerMedia = catalogMediaFor(drawerHandle);
          const drawerPrimaryImage = drawerMedia.image || sizedShopifyImage(item.image) || fallbackImageFor(drawerHandle);
          const drawerSecondaryImage = drawerMedia.secondaryImage || '';
          const drawerHasSecondary = Boolean(drawerSecondaryImage && drawerSecondaryImage !== drawerPrimaryImage);
          return `
          <div class="cart-preview-item" data-cart-line-key="${escapeHtml(item.key || '')}" data-current-quantity="${item.quantity}">
            <a class="cc316-drawer-image-link" href="${escapeHtml(item.url)}" aria-label="View ${escapeHtml(item.product_title || '')}">
              <span class="cc316-drawer-image-stage${drawerHasSecondary ? ' has-secondary-image' : ''}">
                <img src="${escapeHtml(drawerPrimaryImage)}" data-fallback-handle="${escapeHtml(drawerHandle)}" alt="${escapeHtml(item.product_title || '')}" loading="lazy" decoding="async" class="cc316-drawer-image cc316-drawer-image-primary">
                ${drawerHasSecondary ? `<img src="${escapeHtml(drawerSecondaryImage)}" alt="${escapeHtml(item.product_title || '')} alternate view" loading="lazy" decoding="async" class="cc316-drawer-image cc316-drawer-image-secondary">` : ''}
              </span>
            </a>
            <div class="cart-preview-copy">
              ${item.vendor ? `<small class="cart-preview-vendor">${escapeHtml(item.vendor)}</small>` : ''}
              <a href="${escapeHtml(item.url)}">${escapeHtml(cleanProductTitle(item.product_title, item.vendor))}</a>
              ${item.variant_title && item.variant_title !== 'Default Title' ? `<small class="cart-preview-variant">${escapeHtml(item.variant_title)}</small>` : ''}
              <small class="cart-preview-unit-copy">${item.quantity} × ${drawerMoney(item.final_price ?? item.price ?? 0)}</small>
            </div>
            <div class="cart-preview-side">
              <strong class="cart-preview-line-price">${drawerMoney(item.final_line_price)}</strong>
              <div class="cart-preview-qty-controls" aria-label="Quantity controls for ${escapeHtml(item.product_title)}">
                <button type="button" data-cart-preview-qty data-cart-preview-minus data-key="${escapeHtml(item.key)}" data-quantity="${Math.max(0, item.quantity - 1)}" aria-label="${item.quantity === 1 ? 'Remove item' : 'Decrease quantity'}"><svg class="cc-qty-icon" viewBox="0 0 10 10" aria-hidden="true" focusable="false"><path d="M1.5 5h7"/></svg></button>
                <input type="number" class="cart-preview-qty-input" data-cart-preview-input data-key="${escapeHtml(item.key)}" value="${item.quantity}" min="0" inputmode="numeric" aria-label="Quantity ${item.quantity}">
                <button type="button" data-cart-preview-qty data-cart-preview-plus data-key="${escapeHtml(item.key)}" data-quantity="${item.quantity + 1}" aria-label="Increase quantity"><svg class="cc-qty-icon" viewBox="0 0 10 10" aria-hidden="true" focusable="false"><path d="M1.5 5h7M5 1.5v7"/></svg></button>
              </div>
            </div>
          </div>`;
        }).join('')}
        </div>
      </div>
      <div class="cart-preview-shipping-timer${shippingRemaining === 0 ? ' is-unlocked' : ''}" data-cart-preview-shipping>
        <div class="cart-preview-shipping-copy">
          <strong>${shippingRemaining === 0 ? 'Free shipping unlocked' : `${drawerMoney(shippingRemaining)} to free shipping`}</strong>
          <span>${Math.round(shippingProgress)}%</span>
        </div>
        <div class="cart-preview-shipping-track" aria-hidden="true"><i style="width:${shippingProgress.toFixed(2)}%"></i></div>
      </div>
      <div class="cart-preview-summary"><span>Subtotal</span><strong>${subtotal}</strong></div>
      <div class="cc226-cart-tax-note">Taxes calculated at checkout.</div>
      <div class="cc226-cart-tools">
        <div class="cc226-cart-tool" data-cart-preview-tool="discount">
          <button type="button" class="cc226-cart-tool-trigger" data-cart-preview-tool-trigger aria-expanded="false">
            <span>Discount code</span><i aria-hidden="true">+</i>
          </button>
          <div class="cc226-cart-tool-panel" aria-hidden="true"><div class="cc226-cart-tool-inner"><div class="cc226-cart-tool-content">
            <div class="cc226-discount-row">
              <input type="text" inputmode="text" autocomplete="off" placeholder="Enter discount code" aria-label="Discount code" data-cart-preview-discount-input value="${escapeHtml(discountCode)}">
              <button type="button" data-cart-preview-discount-apply>Apply</button>
            </div>
            <p class="cc226-tool-status" data-cart-preview-discount-status aria-live="polite">${discountCode ? 'Ready for checkout.' : 'Discounts are confirmed by Shopify at checkout.'}</p>
          </div></div></div>
        </div>
        <div class="cc226-cart-tool" data-cart-preview-tool="note">
          <button type="button" class="cc226-cart-tool-trigger" data-cart-preview-tool-trigger aria-expanded="false">
            <span>Add an order note</span><i aria-hidden="true">+</i>
          </button>
          <div class="cc226-cart-tool-panel" aria-hidden="true"><div class="cc226-cart-tool-inner"><div class="cc226-cart-tool-content">
            <textarea rows="3" maxlength="500" placeholder="Add a note for your order" aria-label="Order note" data-cart-preview-note>${escapeHtml(noteValue)}</textarea>
            <p class="cc226-tool-status" data-cart-preview-note-status aria-live="polite">Order notes are saved with your order.</p>
          </div></div></div>
        </div>
      </div>
      <div class="cart-preview-actions cc226-cart-actions"><button class="button button-primary cc226-checkout-button" type="button" data-cart-preview-checkout>Checkout</button></div>
      <div class="cc226-checkout-note">Secure Shopify checkout</div>
      </div>
      </div>`;

    openToolKeys.forEach((key) => setCartPreviewToolOpen(q(`[data-cart-preview-tool="${key}"]`, cartPanel), true));
    visibleItems.forEach(paintCartRow);
    cartPanel.dataset.cartRenderedAt = String(cartServerAt || Date.now());
  }

  async function refreshCart(openAfter = false, force = false) {
    try {
      const cart = await getCart(force);
      renderCart(cart);
      if (openAfter && cartPanel) {
        showHeaderDrawer(cartPanel);
        cartToggle?.setAttribute('aria-expanded', 'true');
      }
      return cart;
    } catch (error) {
      console.warn(error);
      return null;
    }
  }


  function openCartImmediately() {
    if (!cartPanel) return;
    closeContactDrawers();
    hideHeaderDrawer(q('[data-wishlist-preview]'));
    q('[data-wishlist-header]')?.setAttribute('aria-expanded', 'false');
    if (cartCache) renderCart(cartCache);
    else cartPanel.innerHTML = '<div class="drawer-loading" aria-live="polite">Updating cart…</div>';
    showHeaderDrawer(cartPanel);
    cartToggle?.setAttribute('aria-expanded', 'true');
    setCartDrawerOpenState(true);
  }

  function cartRowForKey(key) {
    return qa('[data-cart-line-key]', cartPanel || document).find((row) => row.dataset.cartLineKey === key) || null;
  }

  function clampCartDrawerScroll() {
    const clamp = () => {
      [q('[data-drawer-scroll-region]', cartPanel || document), q('[data-outer-drawer-scroll]', cartPanel || document)].forEach((scroller) => {
        if (!scroller) return;
        const max = Math.max(0, scroller.scrollHeight - scroller.clientHeight);
        if (scroller.scrollTop > max) scroller.scrollTop = max;
      });
    };
    clamp();
    window.requestAnimationFrame(clamp);
  }

  function paintCartRow(item) {
    if (!item?.key) return;
    const row = cartRowForKey(item.key);
    if (!row) return;
    const quantity = Math.max(0, Number(item.quantity || 0));
    const notice = cartLineNotices.get(item.key) || null;
    const quantityInput = q('[data-cart-preview-input]', row);
    const minus = q('[data-cart-preview-minus]', row);
    const plus = q('[data-cart-preview-plus]', row);
    const unitCopy = q('.cart-preview-unit-copy', row);
    const linePrice = q('.cart-preview-line-price', row);

    row.dataset.currentQuantity = String(quantity);
    row.toggleAttribute('aria-busy', cartLineTargets.has(item.key));
    if (quantityInput) {
      quantityInput.disabled = false;
      quantityInput.removeAttribute('aria-disabled');
      // Never overwrite a number the customer is still typing.
      if (document.activeElement !== quantityInput) quantityInput.value = String(quantity);
      quantityInput.setAttribute('aria-label', `Quantity ${quantity}`);
    }
    if (minus) {
      minus.disabled = false;
      minus.removeAttribute('aria-disabled');
      minus.dataset.quantity = String(Math.max(0, quantity - 1));
      minus.setAttribute('aria-label', quantity === 1 ? 'Remove item' : 'Decrease quantity');
    }
    if (plus) {
      const max = cartLineMax(item.key);
      const blocked = Boolean(notice?.stock) || (max !== null && quantity >= max);
      plus.dataset.quantity = String(quantity + 1);
      plus.disabled = blocked;
      if (blocked) {
        plus.dataset.stockBlocked = 'true';
        plus.setAttribute('aria-disabled', 'true');
        plus.title = 'Max Stock.';
      } else {
        delete plus.dataset.stockBlocked;
        plus.removeAttribute('aria-disabled');
        plus.removeAttribute('title');
      }
    }
    if (unitCopy) {
      /* Notices reuse the unit-price line so row height never changes. */
      unitCopy.textContent = notice ? notice.message : `${quantity} × ${drawerMoney(cartUnitPrice(item))}`;
      unitCopy.classList.toggle('is-stock-limit', Boolean(notice));
      if (notice) {
        unitCopy.setAttribute('role', 'status');
        unitCopy.setAttribute('aria-live', 'polite');
      } else {
        unitCopy.removeAttribute('role');
        unitCopy.removeAttribute('aria-live');
      }
    }
    row.classList.toggle('has-stock-limit-notice', Boolean(notice));
    if (linePrice) linePrice.textContent = drawerMoney(item.final_line_price ?? (cartUnitPrice(item) * quantity));
  }

  /* Bring the drawer in line with cartCache. Quantity changes and removals are
     patched in place (no flash, scroll kept); only a new line or the empty /
     not-empty boundary rebuilds the drawer. */
  function paintCart() {
    const cart = cartCache;
    if (!cart) return;
    syncHeaderCount('[data-cart-count]', cart.item_count);
    syncWishlistCartStates();
    if (!cartPanel) return;

    const items = cart.items || [];
    const rows = qa('[data-cart-line-key]', cartPanel);
    const rowKeys = new Set(rows.map((row) => row.dataset.cartLineKey));
    const rendered = Boolean(q('.cart-preview-head', cartPanel));
    const drawnEmpty = cartPanel.classList.contains('is-empty-cart');
    const needsFullRender = !rendered
      || (!items.length) !== drawnEmpty
      || (items.length && !q('.cart-preview-summary', cartPanel))
      || items.some((item) => !rowKeys.has(item.key));

    if (needsFullRender) {
      renderCart(cart);
      return;
    }

    const liveKeys = new Set(items.map((item) => item.key));
    let removed = false;
    rows.forEach((row) => {
      if (!liveKeys.has(row.dataset.cartLineKey)) {
        row.remove();
        removed = true;
      }
    });
    items.forEach(paintCartRow);
    syncCartPreviewMeta(cart, { updateShipping: true });
    if (removed) clampCartDrawerScroll();
  }

  function syncCartPreviewMeta(cart, { updateShipping = true } = {}) {
    if (!cart) return;
    syncHeaderCount('[data-cart-count]', cart.item_count);
    if (!cartPanel) return;

    const headCount = q('.cart-preview-head span', cartPanel);
    if (headCount) {
      /* Only show the count when there is something in the cart. */
      headCount.textContent = cart.item_count ? `${cart.item_count} item${cart.item_count === 1 ? '' : 's'}` : '';
      headCount.hidden = !cart.item_count;
    }

    const subtotal = q('.cart-preview-summary strong', cartPanel);
    if (subtotal) {
      const currency = window.CANADA_COLOGNE?.currency || 'CAD';
      subtotal.textContent = currency === 'CAD' ? `${drawerMoney(cart.total_price)} CAD` : moneyWithCurrency(cart.total_price);
    }

    if (updateShipping) {
      const threshold = Number(window.CANADA_COLOGNE?.freeShippingThreshold || 0);
      const remaining = Math.max(0, threshold - Number(cart.total_price || 0));
      const progress = threshold > 0 ? Math.min(100, Math.max(0, (Number(cart.total_price || 0) / threshold) * 100)) : 100;
      const shipping = q('[data-cart-preview-shipping]', cartPanel);
      if (shipping) {
        shipping.classList.toggle('is-unlocked', remaining === 0);
        const copy = q('.cart-preview-shipping-copy strong', shipping);
        const percent = q('.cart-preview-shipping-copy span', shipping);
        const bar = q('.cart-preview-shipping-track i', shipping);
        if (copy) copy.textContent = remaining === 0 ? 'Free shipping unlocked' : `${drawerMoney(remaining)} to free shipping`;
        if (percent) percent.textContent = `${Math.round(progress)}%`;
        if (bar) bar.style.width = `${progress.toFixed(2)}%`;
      }
    }
  }

  function currentCartLineQuantity(key) {
    const item = cartCache?.items?.find((entry) => entry.key === key);
    return Math.max(0, Number(item?.quantity || 0));
  }

  function changeCartLine(key, quantity) {
    if (!key || !cartServer) return Promise.resolve();
    if (!cartServer.items?.some((item) => item.key === key)) return Promise.resolve();
    const current = currentCartLineQuantity(key);
    let target = Math.max(0, Math.floor(Number(quantity) || 0));
    if (target === current) return Promise.resolve();

    let reachedMax = false;
    if (target > current) {
      if (cartLineNotices.get(key)?.stock) return Promise.resolve();
      const max = cartLineMax(key);
      if (max !== null && target >= max) {
        reachedMax = true;
        target = Math.max(current, max);
      }
    }
    cartLineNotices.delete(key);
    if (reachedMax) cartLineNotices.set(key, { message: 'Max Stock.', stock: true });
    if (target === current) {
      commitCart();
      return Promise.resolve();
    }

    cartLineTargets.set(key, target);
    commitCart();
    pumpCart();
    return Promise.resolve();
  }

  document.addEventListener('click', (event) => {
    const quantityButton = event.target.closest('[data-cart-preview-qty]');
    if (!quantityButton) return;
    event.preventDefault();
    event.stopPropagation();
    if (quantityButton.disabled) return;
    const key = quantityButton.dataset.key;
    const current = currentCartLineQuantity(key);
    const step = quantityButton.hasAttribute('data-cart-preview-plus') ? 1 : -1;
    changeCartLine(key, current + step);
  });

  function commitCartPreviewInput(input) {
    if (!input) return;
    const key = input.dataset.key;
    if (!key) return;
    const current = currentCartLineQuantity(key);
    const raw = String(input.value ?? '').trim();
    if (!raw) {
      input.value = String(current);
      return;
    }
    const parsed = Number.parseInt(raw, 10);
    if (!Number.isFinite(parsed)) {
      input.value = String(current);
      return;
    }
    const target = Math.max(0, parsed);
    input.value = String(target);
    if (target === current) return;
    changeCartLine(key, target);
  }

  document.addEventListener('change', (event) => {
    const input = event.target.closest('[data-cart-preview-input]');
    if (!input) return;
    event.stopPropagation();
    commitCartPreviewInput(input);
  });

  document.addEventListener('keydown', (event) => {
    const input = event.target.closest('[data-cart-preview-input]');
    if (!input) return;
    if (event.key === 'Enter') {
      event.preventDefault();
      input.blur();
    }
  });

  document.addEventListener('blur', (event) => {
    const input = event.target.closest('[data-cart-preview-input]');
    if (!input) return;
    const key = input.dataset.key;
    const current = currentCartLineQuantity(key);
    if (!String(input.value ?? '').trim()) input.value = String(current);
  }, true);

  const setCartDrawerOpenState = (open) => {
    header?.classList.toggle('cart-drawer-open', Boolean(open));
  };

  cartToggle?.addEventListener('click', (event) => {
    event.stopPropagation();
    const opening = Boolean(cartPanel?.hidden);
    if (!opening) {
      hideHeaderDrawer(cartPanel);
      cartToggle.setAttribute('aria-expanded', 'false');
      setCartDrawerOpenState(false);
      return;
    }
    hideHeaderDrawer(q('[data-wishlist-preview]'));
    q('[data-wishlist-header]')?.setAttribute('aria-expanded', 'false');
    closeContactDrawers();
    showHeaderDrawer(cartPanel);
    cartToggle.setAttribute('aria-expanded', 'true');
    setCartDrawerOpenState(true);
    if (cartCache) {
      if (!cartPanel.dataset.cartRenderedAt) renderCart(cartCache);
    } else {
      cartPanel.innerHTML = '<div class="drawer-loading" aria-live="polite">Loading cart…</div>';
      refreshCart(false, true);
    }
  });

  function openCartDrawerFromUrlMarker() {
    try {
      const url = new URL(window.location.href);
      if (url.searchParams.get('cart') !== 'open') return;
      url.searchParams.delete('cart');
      window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
      hideHeaderDrawer(q('[data-wishlist-preview]'));
      q('[data-wishlist-header]')?.setAttribute('aria-expanded', 'false');
      closeContactDrawers();
      if (cartPanel) {
        showHeaderDrawer(cartPanel);
        cartToggle?.setAttribute('aria-expanded', 'true');
        setCartDrawerOpenState(true);
        cartPanel.innerHTML = '<div class="drawer-loading" aria-live="polite">Loading cart…</div>';
        refreshCart(false, true);
      }
    } catch (_) {}
  }
  openCartDrawerFromUrlMarker();

  document.addEventListener('click', async (event) => {
    const toolTrigger = event.target.closest('[data-cart-preview-tool-trigger]');
    if (toolTrigger && cartPanel?.contains(toolTrigger)) {
      event.preventDefault();
      event.stopPropagation();
      const tool = toolTrigger.closest('[data-cart-preview-tool]');
      setCartPreviewToolOpen(tool, !tool?.classList.contains('is-open'), { animate: true });
      return;
    }

    const discountApply = event.target.closest('[data-cart-preview-discount-apply]');
    if (discountApply && cartPanel?.contains(discountApply)) {
      event.preventDefault();
      event.stopPropagation();
      const input = q('[data-cart-preview-discount-input]', cartPanel);
      const status = q('[data-cart-preview-discount-status]', cartPanel);
      const code = String(input?.value || '').trim();
      if (!code) {
        storeCartDiscountCode('');
        if (status) status.textContent = 'Enter a discount code first.';
        input?.focus();
        return;
      }
      storeCartDiscountCode(code);
      if (status) status.textContent = 'Ready for checkout.';
      discountApply.textContent = 'Saved';
      window.setTimeout(() => { if (discountApply.isConnected) discountApply.textContent = 'Apply'; }, 1000);
      return;
    }

    const checkout = event.target.closest('[data-cart-preview-checkout]');
    if (checkout && cartPanel?.contains(checkout)) {
      event.preventDefault();
      event.stopPropagation();
      checkout.disabled = true;
      checkout.textContent = 'Opening checkout…';
      window.clearTimeout(cartDrawerNoteTimer);
      const note = q('[data-cart-preview-note]', cartPanel);
      try {
        if (note && String(note.value) !== String(cartCache?.note || '')) {
          await saveCartDrawerNote(note.value, { immediateStatus: false });
        } else if (cartDrawerNoteSavingPromise) {
          await cartDrawerNoteSavingPromise;
        }
      } catch (_) {
        checkout.disabled = false;
        checkout.textContent = 'Checkout';
        return;
      }
      const rootUrl = window.CANADA_COLOGNE?.rootUrl || '/';
      const discountInput = q('[data-cart-preview-discount-input]', cartPanel);
      const code = storeCartDiscountCode(discountInput?.value || storedCartDiscountCode());
      if (code) {
        window.location.assign(`${rootUrl}discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(`${rootUrl}checkout`)}`);
      } else {
        window.location.assign(`${rootUrl}checkout`);
      }
      return;
    }
  });

  document.addEventListener('input', (event) => {
    const note = event.target.closest('[data-cart-preview-note]');
    if (!note || !cartPanel?.contains(note)) return;
    pendingCartDrawerNote = note.value;
    window.clearTimeout(cartDrawerNoteTimer);
    const status = q('[data-cart-preview-note-status]', cartPanel);
    if (status) status.textContent = '';
    cartDrawerNoteTimer = window.setTimeout(() => {
      saveCartDrawerNote(note.value).catch(() => {});
    }, 700);
  });

  document.addEventListener('blur', (event) => {
    const note = event.target.closest('[data-cart-preview-note]');
    if (!note || !cartPanel?.contains(note)) return;
    window.clearTimeout(cartDrawerNoteTimer);
    if (String(note.value) !== String(cartCache?.note || '')) saveCartDrawerNote(note.value).catch(() => {});
  }, true);

  document.addEventListener('keydown', (event) => {
    const discountInput = event.target.closest('[data-cart-preview-discount-input]');
    if (!discountInput || !cartPanel?.contains(discountInput) || event.key !== 'Enter') return;
    event.preventDefault();
    q('[data-cart-preview-discount-apply]', cartPanel)?.click();
  });

  document.addEventListener('click', (event) => {
    if (!cartPanel || cartPanel.hidden) return;

    /* use the event's ORIGINAL composed path for outside-click
       detection. During an optimistic cart removal the clicked row is removed
       synchronously before this document listener runs. event.target.closest()
       can therefore lose the .header-cart-wrap ancestor and falsely classify
       the remove click as an outside click, closing the whole drawer.

       composedPath() is captured from the dispatch path, so it remains correct
       even if the row was removed/re-rendered earlier in the same click. */
    const path = typeof event.composedPath === 'function' ? event.composedPath() : [];
    const beganInsideCart = path.some((node) => {
      if (node === cartPanel || node === cartToggle) return true;
      return node instanceof Element && node.classList?.contains('header-cart-wrap');
    });

    if (!beganInsideCart) {
      hideHeaderDrawer(cartPanel);
      cartToggle?.setAttribute('aria-expanded', 'false');
      setCartDrawerOpenState(false);
    }
  });

  /* Pre-warm and pre-render the hidden cart immediately so the first open is instant. */
  const warmCart = () => getCart(false).then((cart) => {
    if (cartPanel?.hidden) {
      const signature = JSON.stringify([
        cart, pendingCartDrawerNote, storedCartDiscountCode(),
        window.CANADA_COLOGNE?.currency, window.CANADA_COLOGNE?.freeShippingThreshold,
      ]);
      if (signature !== cartWarmSignature) {
        renderCart(cart);
        cartWarmSignature = signature;
      }
    }
    return cart;
  }).catch(() => null);
  window.setTimeout(warmCart, 0);

  /* Back/forward cache and returning to the tab can show a cart changed
     elsewhere (checkout, another tab) — re-read it through the queue. */
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) getCart(true).catch(() => {});
  });
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') getCart(false).catch(() => {});
  });
  cartToggle?.addEventListener('pointerenter', warmCart, { passive: true });
  cartToggle?.addEventListener('focus', warmCart, { passive: true });

  /* Wishlist — local, compact header drawer. No wishlist page route. */
  const WISHLIST_DATA_KEY = 'cc-wishlist-items-v2';
  const wishlistToggle = q('[data-wishlist-header]');
  const wishlistPanel = q('[data-wishlist-preview]');

  function readWishlist() {
    try {
      return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]').filter(Boolean);
    } catch (_) {
      return [];
    }
  }

  function readWishlistData() {
    try {
      const value = JSON.parse(localStorage.getItem(WISHLIST_DATA_KEY) || '{}');
      return value && typeof value === 'object' && !Array.isArray(value) ? value : {};
    } catch (_) {
      return {};
    }
  }

  function writeWishlistData(data) {
    try { localStorage.setItem(WISHLIST_DATA_KEY, JSON.stringify(data || {})); } catch (_) {}
  }

  function wishlistItemFromButton(button) {
    const handle = button?.dataset.productHandle || '';
    if (!handle) return null;
    return {
      handle,
      title: button.dataset.productTitle || handle.replace(/-/g, ' '),
      vendor: button.dataset.productVendor || '',
      url: button.dataset.productUrl || `/products/${handle}`,
      image: button.dataset.productImage || fallbackImageFor(handle),
      price: button.dataset.productPrice || '',
      variantId: button.dataset.productVariantId || '',
      available: button.dataset.productAvailable !== 'false',
    };
  }

  function writeWishlist(list, nextData = null) {
    const unique = Array.from(new Set(list.filter(Boolean)));
    try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(unique)); } catch (_) {}
    if (nextData) writeWishlistData(nextData);
    syncWishlist();
  }

  function syncWishlist(root = document) {
    const list = readWishlist();
    const handles = new Set(list);
    qa('[data-wishlist-button]', root).forEach((button) => {
      const active = handles.has(button.dataset.productHandle);
      button.classList.toggle('is-active', active);
      const pressed = String(active);
      if (button.getAttribute('aria-pressed') !== pressed) button.setAttribute('aria-pressed', pressed);
      const title = button.dataset.productTitle || 'this fragrance';
      const tooltip = q('.listing-action-tooltip', button);
      const tooltipText = active ? 'Saved' : 'Wishlist';
      if (tooltip && tooltip.textContent !== tooltipText) tooltip.textContent = tooltipText;
      const buttonTitle = active ? 'Saved to wishlist' : 'Wishlist';
      if (button.title !== buttonTitle) button.title = buttonTitle;
      const label = active ? `Remove ${title} from wishlist` : `Add ${title} to wishlist`;
      if (button.getAttribute('aria-label') !== label) button.setAttribute('aria-label', label);
    });
    syncHeaderCount('[data-wishlist-count]', list.length);
  }

  /* Momentary "Saved" confirmation on the clicked heart only. Separate from
     the persistent is-active (stays saved) state so the tooltip flashes and
     fades like the Share/Add To Cart tooltips instead of sticking forever.
     Duration is the visible HOLD; the fade-out itself is CSS-driven
     (--cc-tooltip-fade-out) and runs after this class is removed. */
  function flashWishlistJustSaved(button, duration = 1250) {
    if (!button) return;
    if (button._ccWishlistSavedTimer) window.clearTimeout(button._ccWishlistSavedTimer);
    button.classList.add('is-just-saved');
    button._ccWishlistSavedTimer = window.setTimeout(() => {
      button.classList.remove('is-just-saved');
      button._ccWishlistSavedTimer = null;
    }, duration);
  }

  function clearWishlistJustSaved(button) {
    if (!button) return;
    if (button._ccWishlistSavedTimer) {
      window.clearTimeout(button._ccWishlistSavedTimer);
      button._ccWishlistSavedTimer = null;
    }
    button.classList.remove('is-just-saved');
  }

  function wishlistActionIconMarkup(state = 'available') {
    if (state === 'adding') return '<span class="listing-action-spinner" aria-hidden="true"></span>';
    if (state === 'added' || state === 'in-cart') {
      return '<svg viewBox="0 -0.15 24 24" aria-hidden="true"><path d="m5 12.5 4.2 4.2L19 7"/></svg>';
    }
    if (state === 'max-stock') {
      return '<svg class="cc-stock-bag-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18M16 10a4 4 0 0 1-8 0"/></svg>';
    }
    if (state === 'sold-out') {
      return '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="8"/><path d="m7.2 7.2 9.6 9.6"/></svg>';
    }
    if (state === 'retry') {
      return '<svg viewBox="0.1 -0.07 24 24" aria-hidden="true"><path d="M19 7v5h-5"/><path d="M18.2 12a6.5 6.5 0 1 1-1.4-4.1L19 10"/></svg>';
    }
    return '<svg viewBox="0 -0.85 24 24" aria-hidden="true"><path d="M6.5 8.2h11l-.8 10.3H7.3L6.5 8.2Z"/><path d="M9 8.2V6.8a3 3 0 0 1 6 0v1.4M12 11v4M10 13h4"/></svg>';
  }

  function wishlistActionContents(label, state) {
    return `<span class="wishlist-row-add-tooltip" data-wishlist-add-tooltip aria-hidden="true">${escapeHtml(label)}</span><span class="wishlist-row-add-icon" data-wishlist-add-icon>${wishlistActionIconMarkup(state)}</span>`;
  }

  function setWishlistQuickAddState(button, state, label) {
    if (!button) return;
    button.classList.remove('is-available', 'is-adding', 'is-success', 'is-added-flash', 'is-stock-limit', 'is-sold-out', 'is-retry');
    if (state === 'adding') button.classList.add('is-adding');
    else if (state === 'added') button.classList.add('is-success', 'is-added-flash');
    else if (state === 'in-cart') button.classList.add('is-success');
    else if (state === 'max-stock') button.classList.add('is-stock-limit');
    else if (state === 'sold-out') button.classList.add('is-sold-out');
    else if (state === 'retry') button.classList.add('is-available', 'is-retry');
    else button.classList.add('is-available');
    button.dataset.wishlistState = state;
    const tooltip = q('[data-wishlist-add-tooltip]', button);
    const icon = q('[data-wishlist-add-icon]', button);
    if (tooltip && icon) {
      tooltip.textContent = label;
      icon.innerHTML = wishlistActionIconMarkup(state);
    } else {
      button.innerHTML = wishlistActionContents(label, state);
    }
    if (state === 'adding') button.setAttribute('aria-busy', 'true');
    else button.removeAttribute('aria-busy');
    button.title = label;
    const productTitle = button.dataset.productTitle || '';
    button.setAttribute('aria-label', productTitle ? `${label}: ${productTitle}` : label);
  }

  function renderWishlist() {
    if (!wishlistPanel) return;
    const list = readWishlist();
    const data = readWishlistData();
    wishlistPanel.classList.toggle('cc351-wishlist-empty', !list.length);
    if (!list.length) {
      wishlistPanel.innerHTML = `<div class="wishlist-preview-head"><strong>YOUR WISHLIST</strong></div><div class="cc330-outer-scroll-shell"><div class="cc329-outer-scroll-viewport" data-outer-drawer-scroll><div class="wishlist-preview-empty"><strong>Your wishlist is empty.</strong><span>Tap a heart to save a fragrance.</span></div></div></div>`;
      return;
    }
    wishlistPanel.innerHTML = `
      <div class="wishlist-preview-head"><strong>YOUR WISHLIST</strong><span>${list.length} item${list.length === 1 ? '' : 's'}</span></div>
      <div class="cc330-outer-scroll-shell">
      <div class="cc329-outer-scroll-viewport" data-outer-drawer-scroll>
      <div class="cc324-drawer-scroll-shell" data-drawer-scroll-shell>
        <div class="wishlist-preview-items" data-drawer-scroll-region>
        ${list.map((handle) => {
          const item = data[handle] || { handle, title: handle.replace(/-/g, ' '), url: `/products/${handle}`, image: fallbackImageFor(handle), price: '', vendor: '', variantId: '', available: true };
          const title = escapeHtml(cleanProductTitle(item.title || handle.replace(/-/g, ' '), item.vendor));
          const url = escapeHtml(item.url || `/products/${handle}`);
          const wishlistInCart = item.variantId && cartQuantityForVariant(cartCache, item.variantId) > 0;
          const wishlistActionLabel = wishlistInCart ? 'In Cart' : 'Add to Cart';
          const wishlistActionState = wishlistInCart ? 'in-cart' : 'available';
          const quickAdd = item.variantId && item.available !== false
            ? `<button type="button" class="wishlist-row-add ${wishlistInCart ? 'is-success' : 'is-available'}" data-wishlist-quick-add data-wishlist-state="${wishlistActionState}" data-product-title="${title}" data-variant-id="${escapeHtml(item.variantId)}" title="${wishlistActionLabel}" aria-label="${wishlistActionLabel}: ${title}">${wishlistActionContents(wishlistActionLabel, wishlistActionState)}</button>`
            : `<a class="wishlist-row-add wishlist-row-view" href="${url}" title="View" aria-label="View ${title}"><span class="wishlist-row-add-tooltip" aria-hidden="true">View</span><span class="wishlist-row-add-icon"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 17 17 7M10 7h7v7"/></svg></span></a>`;
          const wishlistMedia = catalogMediaFor(handle);
          const wishlistPrimaryImage = wishlistMedia.image || sizedShopifyImage(item.image) || fallbackImageFor(handle);
          const wishlistSecondaryImage = wishlistMedia.secondaryImage || '';
          const wishlistHasSecondary = Boolean(wishlistSecondaryImage && wishlistSecondaryImage !== wishlistPrimaryImage);
          return `<div class="wishlist-preview-item" data-wishlist-row="${escapeHtml(handle)}">
            <a class="wishlist-row-image cc316-drawer-image-link" href="${url}" aria-label="View ${title}"><span class="cc316-drawer-image-stage${wishlistHasSecondary ? ' has-secondary-image' : ''}"><img src="${escapeHtml(wishlistPrimaryImage)}" data-fallback-handle="${escapeHtml(handle)}" alt="${title}" loading="lazy" decoding="async" class="cc316-drawer-image cc316-drawer-image-primary">${wishlistHasSecondary ? `<img src="${escapeHtml(wishlistSecondaryImage)}" alt="${title} alternate view" loading="lazy" decoding="async" class="cc316-drawer-image cc316-drawer-image-secondary">` : ''}</span></a>
            <div class="wishlist-row-copy"><small>${escapeHtml(item.vendor || '')}</small><a href="${url}">${title}</a>${item.price ? `<strong>${escapeHtml(item.price)}</strong>` : ''}</div>
            <div class="wishlist-row-actions">${quickAdd}<button type="button" class="wishlist-row-remove" data-wishlist-remove data-handle="${escapeHtml(handle)}" aria-label="Remove ${title} from wishlist">×</button></div>
          </div>`;
        }).join('')}
        </div>
      </div>
      </div>
      </div>`;
    applyWishlistAddStates();
  }

  /* Wishlist Add To Cart feedback is kept per variant, not per button, so a
     row that is re-drawn (remove, heart toggle, hydration) mid-add keeps its
     Adding… / Added / Max Stock state and the result lands on the live button.
     Rows without a live state simply mirror the cart: In Cart or Add to Cart. */
  const wishlistAddStates = new Map();

  function wishlistAddButtonsFor(variantId) {
    return qa('[data-wishlist-quick-add]', wishlistPanel || document)
      .filter((button) => String(button.dataset.variantId) === String(variantId));
  }

  function paintWishlistAddButton(button, entry) {
    setWishlistQuickAddState(button, entry.state, entry.label);
    button.dataset.busy = entry.state === 'adding' ? 'true' : 'false';
    const soldOut = entry.state === 'sold-out';
    button.disabled = soldOut;
    if (soldOut) button.setAttribute('aria-disabled', 'true');
    else button.removeAttribute('aria-disabled');
  }

  function setWishlistVariantState(variantId, state, label) {
    const id = String(variantId);
    if (state) wishlistAddStates.set(id, { state, label });
    else wishlistAddStates.delete(id);
    if (state) wishlistAddButtonsFor(id).forEach((button) => paintWishlistAddButton(button, { state, label }));
    else syncWishlistCartStates();
  }

  function applyWishlistAddStates() {
    wishlistAddStates.forEach((entry, id) => {
      wishlistAddButtonsFor(id).forEach((button) => paintWishlistAddButton(button, entry));
    });
    syncWishlistCartStates();
  }

  function syncWishlistCartStates() {
    if (!wishlistPanel) return;
    qa('[data-wishlist-quick-add]', wishlistPanel).forEach((button) => {
      const id = String(button.dataset.variantId || '');
      if (!id) return;
      const inCart = cartQuantityForVariant(cartCache, id) > 0;
      // Max Stock clears itself once that fragrance is no longer in the cart.
      if (!inCart && wishlistAddStates.get(id)?.state === 'max-stock') wishlistAddStates.delete(id);
      if (wishlistAddStates.has(id)) return;
      const state = inCart ? 'in-cart' : 'available';
      if (button.dataset.wishlistState === state) return;
      button.disabled = false;
      button.removeAttribute('aria-disabled');
      button.dataset.busy = 'false';
      setWishlistQuickAddState(button, state, inCart ? 'In Cart' : 'Add to Cart');
    });
  }

  /* Remove one wishlist row in place. The list is only redrawn when it becomes
     empty, so rapid removals never rebuild rows under the pointer. */
  function removeWishlistRow(handle) {
    const list = readWishlist().filter((item) => item !== handle);
    const data = readWishlistData();
    delete data[handle];
    writeWishlist(list, data);
    if (!wishlistPanel) return;
    const rows = qa('[data-wishlist-row]', wishlistPanel);
    const renderedHandles = rows.map((row) => row.dataset.wishlistRow);
    const inSync = rows.length === list.length + 1 && renderedHandles.includes(handle);
    if (!list.length || !inSync) {
      renderWishlist();
      return;
    }
    rows.find((row) => row.dataset.wishlistRow === handle)?.remove();
    const count = q('.wishlist-preview-head span', wishlistPanel);
    if (count) count.textContent = `${list.length} item${list.length === 1 ? '' : 's'}`;
    [q('[data-drawer-scroll-region]', wishlistPanel), q('[data-outer-drawer-scroll]', wishlistPanel)].forEach((scroller) => {
      if (!scroller) return;
      const max = Math.max(0, scroller.scrollHeight - scroller.clientHeight);
      if (scroller.scrollTop > max) scroller.scrollTop = max;
    });
  }

  let wishlistHydrationPromise = null;
  function hydrateMissingWishlistItems() {
    if (wishlistHydrationPromise) return wishlistHydrationPromise;
    const list = readWishlist();
    const data = readWishlistData();
    const missing = list.filter((handle) => !data[handle]?.variantId || !data[handle]?.title);
    if (!missing.length) return Promise.resolve();
    const rootUrl = window.CANADA_COLOGNE?.rootUrl || '/';
    const request = (async () => {
      const updates = [];
      const batchSize = 16;
      for (let start = 0; start < missing.length; start += batchSize) {
        const batch = await Promise.all(missing.slice(start, start + batchSize).map(async (handle) => {
          try {
            const response = await fetch(`${rootUrl}products/${encodeURIComponent(handle)}.js`, { headers: { Accept: 'application/json' } });
            if (!response.ok) return null;
            const product = await response.json();
            const savedVariantId = data[handle]?.variantId || '';
            const variant = product.variants?.find((entry) => String(entry.id) === String(savedVariantId)) || product.variants?.find((entry) => entry.available) || product.variants?.[0];
            return [handle, {
              handle,
              title: product.title || handle.replace(/-/g, ' '),
              vendor: product.vendor || '',
              url: product.url || `${rootUrl}products/${handle}`,
              image: catalogMediaFor(handle).image || product.featured_image || fallbackImageFor(handle),
              price: variant?.price ? moneyWithCurrency(variant.price) : '',
              variantId: variant?.id || '',
              available: Boolean(variant?.available),
            }];
          } catch (_) { return null; }
        }));
        updates.push(...batch);
      }
      // A shopper can save/remove products while these requests are in flight.
      // Merge into current storage and preserve any record changed since we read it.
      const currentData = readWishlistData();
      const currentHandles = new Set(readWishlist());
      let changed = false;
      updates.forEach((entry) => {
        if (!entry) return;
        const [handle, item] = entry;
        if (!currentHandles.has(handle) || JSON.stringify(currentData[handle]) !== JSON.stringify(data[handle])) return;
        currentData[handle] = item;
        changed = true;
      });
      if (changed) {
        writeWishlistData(currentData);
        if (wishlistPanel && !wishlistPanel.hidden) renderWishlist();
      }
    })().finally(() => {
      if (wishlistHydrationPromise === request) wishlistHydrationPromise = null;
    });
    wishlistHydrationPromise = request;
    return request;
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-wishlist-button]');
    if (!button) return;
    event.preventDefault();
    if (event.detail > 0) window.requestAnimationFrame(() => button.blur());
    const handle = button.dataset.productHandle;
    const list = readWishlist();
    const data = readWishlistData();
    const wasActive = list.includes(handle);
    if (wasActive) {
      delete data[handle];
      writeWishlist(list.filter((item) => item !== handle), data);
      clearWishlistJustSaved(button);
    } else {
      const item = wishlistItemFromButton(button);
      if (item) data[handle] = item;
      writeWishlist([...list, handle], data);
      flashWishlistJustSaved(button);
    }
    if (wishlistPanel && !wishlistPanel.hidden) renderWishlist();
  });

  wishlistToggle?.addEventListener('click', (event) => {
    event.stopPropagation();
    const opening = Boolean(wishlistPanel?.hidden);
    if (!opening) {
      hideHeaderDrawer(wishlistPanel);
      wishlistToggle.setAttribute('aria-expanded', 'false');
      return;
    }
    hideHeaderDrawer(cartPanel);
    cartToggle?.setAttribute('aria-expanded', 'false');
    setCartDrawerOpenState(false);
    closeContactDrawers();
    renderWishlist();
    showHeaderDrawer(wishlistPanel);
    wishlistToggle.setAttribute('aria-expanded', 'true');
    hydrateMissingWishlistItems();
  });

  document.addEventListener('click', (event) => {
    const remove = event.target.closest('[data-wishlist-remove]');
    if (remove) {
      event.preventDefault();
      event.stopPropagation();
      removeWishlistRow(remove.dataset.handle);
      return;
    }
    const add = event.target.closest('[data-wishlist-quick-add]');
    if (add) {
      event.preventDefault();
      event.stopPropagation();
      const variantId = Number(add.dataset.variantId || 0);
      const live = wishlistAddStates.get(String(variantId))?.state;
      if (!variantId || add.disabled || live === 'adding' || live === 'sold-out') return;
      setWishlistVariantState(variantId, 'adding', 'Adding…');
      cartAdd({ items: [{ id: variantId, quantity: 1 }] }).then(() => {
        setWishlistVariantState(variantId, 'added', 'Added');
        window.setTimeout(() => {
          if (wishlistAddStates.get(String(variantId))?.state === 'added') setWishlistVariantState(variantId, null);
        }, 900);
      }).catch((error) => {
        console.warn(error);
        if (isSoldOutError(error)) {
          setWishlistVariantState(variantId, 'sold-out', 'Sold Out');
        } else if (isStockError(error)) {
          /* Keep the red max-stock state visible until the customer acts again. */
          setWishlistVariantState(variantId, 'max-stock', 'Max Stock');
        } else {
          setWishlistVariantState(variantId, 'retry', 'Try Again');
          window.setTimeout(() => {
            if (wishlistAddStates.get(String(variantId))?.state === 'retry') setWishlistVariantState(variantId, null);
          }, 1500);
        }
      });
      return;
    }
    if (wishlistPanel && !wishlistPanel.hidden && !event.target.closest('.header-wishlist-wrap')) {
      hideHeaderDrawer(wishlistPanel);
      wishlistToggle?.setAttribute('aria-expanded', 'false');
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    if (cartPanel && !cartPanel.hidden) {
      hideHeaderDrawer(cartPanel);
      cartToggle?.setAttribute('aria-expanded', 'false');
      setCartDrawerOpenState(false);
    }
    if (wishlistPanel && !wishlistPanel.hidden) {
      hideHeaderDrawer(wishlistPanel);
      wishlistToggle?.setAttribute('aria-expanded', 'false');
    }
  });

  syncWishlist();
  window.addEventListener('storage', (event) => {
    if (event.key !== null && event.key !== WISHLIST_KEY && event.key !== WISHLIST_DATA_KEY) return;
    syncWishlist();
    if (wishlistPanel && !wishlistPanel.hidden) renderWishlist();
  });

  function cartQuantityForVariant(cart, variantId) {
    return (cart?.items || []).reduce((sum, item) => sum + (Number(item.variant_id) === Number(variantId) ? Number(item.quantity || 0) : 0), 0);
  }

  function syncProductAvailabilityLayout(form, available) {
    if (!form) return;
    const isAvailable = Boolean(available);
    form.dataset.productAvailable = String(isAvailable);
    const purchaseMeta = q('[data-purchase-meta]', form);
    const quantityInput = q('input[name="quantity"]', form);
    const dynamicCheckout = q('.simple-dynamic-checkout', form);
    if (purchaseMeta) purchaseMeta.hidden = !isAvailable;
    if (quantityInput) quantityInput.disabled = !isAvailable;
    if (dynamicCheckout) dynamicCheckout.hidden = !isAvailable;
  }

  qa('[data-ajax-cart-form][data-product-available]').forEach((form) => {
    syncProductAvailabilityLayout(form, form.dataset.productAvailable === 'true');
  });

  /* Product-page Add To Cart states: a spinner while adding, a tick once added.
     The label is rebuilt each time, so its fade-in plays on every change. */
  const ADD_STATE_ICONS = {
    adding: '<span class="cc-btn-spinner" aria-hidden="true"></span>',
    added: '<svg class="cc-btn-check" viewBox="0 -0.15 24 24" aria-hidden="true"><path d="m5 12.5 4.2 4.2L19 7"/></svg>',
    limit: '<svg class="cc-btn-alert" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18M16 10a4 4 0 0 1-8 0"/></svg>',
    retry: '<svg class="cc-btn-alert" viewBox="0 0 24 24" aria-hidden="true"><path d="M20 11a8 8 0 1 0-2.3 5.7"/><path d="M20 4v7h-7"/></svg>',
  };
  function setAddButtonState(button, state, text) {
    if (!button) return;
    const label = document.createElement('span');
    label.setAttribute('data-add-label', '');
    label.className = 'cc-btn-state';
    label.innerHTML = `${ADD_STATE_ICONS[state] || ''}<span>${escapeHtml(text)}</span>`;
    button.replaceChildren(label);
  }
  /* "Maximum In Cart" / "Try Again": the button turns red with a short shake,
     holds the message, then fades back to its normal label. */
  function flashAddButtonError(button, text, restore, holdMs = 1500, icon = 'limit') {
    if (!button) return;
    window.clearTimeout(button._ccAddStateTimer);
    button.classList.remove('is-adding', 'is-added', 'is-limit-flash');
    void button.offsetWidth; // restart the flick animation on repeat clicks
    button.classList.add('is-limit', 'is-limit-flash');
    setAddButtonState(button, icon, text);
    button._ccAddStateTimer = window.setTimeout(() => {
      button.classList.remove('is-limit', 'is-limit-flash');
      setAddButtonState(button, 'idle', restore);
    }, holdMs);
  }

  /* Cart forms and product controls */
  qa('[data-ajax-cart-form]').forEach((form) => form.addEventListener('submit', async (event) => {
    event.preventDefault();
    const button = q('[data-add-button]', form);
    if (button?.disabled || form.dataset.cartRequestPending === 'true') return;
    // A second click during "Adding…"/"Added!" must still restore the real label.
    const currentLabel = (button?.textContent || '').trim();
    const original = /^(Adding|Added|Maximum In Cart|Try Again)/.test(currentLabel) ? 'Add To Cart' : currentLabel;
    const formData = new FormData(form);
    const variantId = Number(formData.get('id') || 0);
    const requestedQuantity = Math.max(1, Number(formData.get('quantity') || 1));
    const stockMax = Number(button?.dataset.stockMax || NaN);

    if (Number.isFinite(stockMax)) {
      if (stockMax <= 0) {
        if (button) { button.textContent = 'Sold Out'; button.disabled = true; }
        syncProductAvailabilityLayout(form, false);
        return;
      }
      // Never hold the click waiting for a cart preflight request. Use the warm cache
      // when available; Shopify remains the source of truth for the POST below.
      if (cartCache && cartQuantityForVariant(cartCache, variantId) + requestedQuantity > stockMax) {
        flashAddButtonError(button, 'Maximum In Cart', original);
        return;
      }
    }

    form.dataset.cartRequestPending = 'true';
    if (button) {
      window.clearTimeout(button._ccAddStateTimer);
      button.classList.remove('is-added');
      button.classList.add('is-adding');
      setAddButtonState(button, 'adding', 'Adding…');
      button.setAttribute('aria-busy', 'true');
    }
    try {
      await cartAdd(formData);
      if (button) {
        button.classList.remove('is-adding');
        button.classList.add('is-added');
        setAddButtonState(button, 'added', 'Added!');
      }
      openCartImmediately();
      // Hold the green long enough for the slow colour change to be seen.
      if (button) {
        button._ccAddStateTimer = window.setTimeout(() => {
          button.classList.remove('is-added');
          setAddButtonState(button, 'idle', original);
        }, 1800);
      }
    } catch (error) {
      console.error(error);
      const stockLimit = isStockError(error);
      const soldOut = isSoldOutError(error);
      if (button) {
        button.classList.remove('is-adding', 'is-added');
        if (!soldOut) flashAddButtonError(button, stockLimit ? 'Maximum In Cart' : 'Try Again', original, 1500, stockLimit ? 'limit' : 'retry');
        else button.textContent = 'Sold Out';
        if (soldOut) {
          button.disabled = true;
          syncProductAvailabilityLayout(form, false);
          const stock = q('[data-stock-label]', form.closest('.product-summary'));
          if (stock) {
            stock.classList.add('is-out');
            stock.classList.remove('is-low');
            stock.innerHTML = '<span class="cc570-stock-dot" aria-hidden="true"></span><span data-stock-text>Out of stock</span>';
          }
        }
      }
    } finally {
      delete form.dataset.cartRequestPending;
      button?.removeAttribute('aria-busy');
    }
  }));

  const pickupRequests = new WeakMap();
  async function refreshPickupAvailability(root, variantId) {
    const container = q('[data-pickup-availability]', root);
    if (!container || !variantId) return;
    const previous = pickupRequests.get(container);
    const variant = String(variantId);
    if (previous?.variant === variant && previous.pending) return;
    previous?.controller.abort();
    const request = { variant, controller: new AbortController(), pending: true };
    pickupRequests.set(container, request);
    try {
      const base = window.CANADA_COLOGNE?.rootUrl || '/';
      const response = await fetch(`${base}variants/${variantId}/?section_id=pickup-availability`, { signal: request.controller.signal });
      if (!response.ok) return;
      const text = await response.text();
      if (pickupRequests.get(container) !== request || !container.isConnected) return;
      const doc = new DOMParser().parseFromString(text, 'text/html');
      const fresh = q('[data-pickup-availability-content]', doc);
      if (fresh) container.innerHTML = fresh.outerHTML;
    } catch (error) {
      if (error.name !== 'AbortError') console.warn(error);
    } finally {
      if (pickupRequests.get(container) === request) pickupRequests.delete(container);
    }
  }

  qa('[data-variant-select]').forEach((select) => select.addEventListener('change', () => {
    const option = select.selectedOptions[0];
    const root = select.closest('.product-summary');
    // v2.15.536: target the actual visible price block specifically.
    // The wishlist button also carries data-product-price as metadata.
    const price = q('.cc401-buy-price-block[data-product-price]', root);
    const button = q('[data-add-button]', root);
    const stock = q('[data-stock-label]', root);
    const dynamicCheckout = q('.simple-dynamic-checkout', root);
    const productForm = q('[data-ajax-cart-form]', root);
    const wishlistButton = q('[data-wishlist-button]', root);
    const available = option.dataset.available === 'true';
    syncProductAvailabilityLayout(productForm, available);
    if (price) {
      const variantCompare = Number(option.dataset.compare || 0);
      const officialRetail = Number(option.dataset.officialRetail || 0);
      const current = Number(option.dataset.price || 0);
      const compare = officialRetail > current ? officialRetail : variantCompare;
      const saving = compare > current ? Math.round(((compare - current) / compare) * 100) : 0;
      price.innerHTML = `${compare > current ? `<p class="cc-retail-line">Retail - <del>${money(compare)}</del><span class="cc-retail-line__sep" aria-hidden="true">·</span><span class="cc-retail-line__save">Save - <strong>${money(compare - current)}</strong></span></p>` : ''}<div class="simple-product-price-line cc133-price-line cc400-joma-price-line cc401-buy-price-line"><strong>${moneyWithCurrency(current)}</strong><span class="simple-sale-badge">${saving ? `${saving}% OFF` : 'SALE'}</span></div>`;
    }
    if (button) {
      button.disabled = !available;
      button.textContent = available ? 'Add To Cart' : 'Sold Out';
      button.dataset.stockMax = option.dataset.stockMax || '';
    }
    const quantityInput = q('input[name="quantity"]', root);
    const stockMax = Number(option.dataset.stockMax || NaN);
    if (quantityInput) {
      if (Number.isFinite(stockMax)) quantityInput.max = String(Math.max(1, stockMax));
      else quantityInput.removeAttribute('max');
      if (Number.isFinite(stockMax) && Number(quantityInput.value || 1) > stockMax) quantityInput.value = Math.max(1, stockMax);
    }
    if (stock) {
      const lowStock = available && Number.isFinite(stockMax) && stockMax > 0 && stockMax < 5;
      stock.classList.toggle('is-out', !available);
      stock.classList.toggle('is-low', lowStock);
      stock.innerHTML = `<span class="cc570-stock-dot" aria-hidden="true"></span><span data-stock-text>${available ? (lowStock ? 'Low Stock' : 'In Stock') : 'Out of stock'}</span>`;
    }
    if (dynamicCheckout) dynamicCheckout.hidden = !available;
    if (wishlistButton) {
      wishlistButton.dataset.productVariantId = select.value;
      wishlistButton.dataset.productAvailable = available ? 'true' : 'false';
      wishlistButton.dataset.productPrice = moneyWithCurrency(Number(option.dataset.price || 0));
    }
    // v2.15.537: data-image is present only for explicitly approved custom variant media.
    // Generic Shopify variant featured images no longer override the approved product gallery.
    const variantImage = option.dataset.image || '';
    const variantSecondaryImage = option.dataset.secondaryImage || '';
    const pageRoot = root?.closest('.simple-product-page') || document;
    const isUnifiedCdnim = pageRoot?.dataset?.productHandle === 'armaf-club-de-nuit-intense-man-4-piece-gift-set';
    if (isUnifiedCdnim) {
      const selectedText = `${option.dataset.formatTitle || option.textContent || ''}`.toLowerCase();
      const role = selectedText.includes('gift set') ? 'gift' : '105-primary';
      const targetThumb = q(`[data-gallery-thumb][data-gallery-role="${role}"]`, pageRoot);
      if (targetThumb) selectGalleryThumb(targetThumb, { fade: true });
    } else if (variantImage) {
      const mainImage = q('[data-gallery-main] .simple-product-main-image', pageRoot);
      const lightboxImage = q('[data-lightbox-image]', pageRoot);
      if (mainImage) fadeGalleryImage(mainImage, variantImage);
      if (lightboxImage) lightboxImage.src = variantImage;

      const thumbs = qa('[data-gallery-thumb]', pageRoot);
      if (thumbs[0]) {
        thumbs[0].dataset.image = variantImage;
        const thumbImage = q('img', thumbs[0]);
        if (thumbImage) thumbImage.src = variantImage;
        thumbs[0].hidden = false;
        thumbs[0].classList.add('is-active');
      }
      if (thumbs[1]) {
        if (variantSecondaryImage) {
          thumbs[1].dataset.image = variantSecondaryImage;
          const thumbImage = q('img', thumbs[1]);
          if (thumbImage) thumbImage.src = variantSecondaryImage;
          thumbs[1].hidden = false;
        } else {
          thumbs[1].hidden = true;
          thumbs[1].classList.remove('is-active');
        }
      }
    }
    refreshPickupAvailability(root, select.value);
  }));

  qa('[data-qty-minus]').forEach((button) => button.addEventListener('click', () => {
    const input = q('input[name="quantity"]', button.closest('.quantity-control'));
    if (input) input.value = Math.max(1, Number(input.value || 1) - 1);
  }));
  qa('[data-qty-plus]').forEach((button) => button.addEventListener('click', () => {
    const input = q('input[name="quantity"]', button.closest('.quantity-control'));
    if (!input) return;
    const max = Number(input.max || 99);
    input.value = Math.min(Number.isFinite(max) ? max : 99, Number(input.value || 1) + 1);
  }));

  function listingQuickAddIconHost(button) {
    return q('[data-card-add-icon]', button);
  }

  function listingQuickAddIconMarkup(state = 'available') {
    if (state === 'adding') return '<span class="listing-action-spinner" aria-hidden="true"></span>';
    if (state === 'success') return '<svg class="listing-action-success-icon" viewBox="0 -0.15 24 24" aria-hidden="true"><path d="m5 12.5 4.2 4.2L19 7"/></svg>';
    if (state === 'max-stock') return '<svg class="listing-action-stock-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18M16 10a4 4 0 0 1-8 0"/></svg>';
    if (state === 'sold-out') return '<svg class="listing-action-soldout-icon" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="8"/><path d="m7.2 7.2 9.6 9.6"/></svg>';
    if (state === 'retry') return '<svg class="listing-action-retry-icon" viewBox="0.1 -0.07 24 24" aria-hidden="true"><path d="M19 7v5h-5"/><path d="M18.2 12a6.5 6.5 0 1 1-1.4-4.1L19 10"/></svg>';
    return '<svg viewBox="0 -0.85 24 24" aria-hidden="true"><path d="M6.5 8.2h11l-.8 10.3H7.3L6.5 8.2Z"/><path d="M9 8.2V6.8a3 3 0 0 1 6 0v1.4M12 11v4M10 13h4"/></svg>';
  }

  function rememberListingQuickAddIcon(button) {
    const host = listingQuickAddIconHost(button);
    if (host && !button._ccOriginalActionMarkup) button._ccOriginalActionMarkup = host.innerHTML;
    return host;
  }

  function setListingQuickAddIcon(button, state = 'available') {
    const host = rememberListingQuickAddIcon(button);
    if (!host) return;
    host.innerHTML = state === 'available' && button._ccOriginalActionMarkup
      ? button._ccOriginalActionMarkup
      : listingQuickAddIconMarkup(state);
  }

  function clearListingStockTimers(button) {
    if (!button) return;
    ['_ccStockRestoreTimer', '_ccActionSuccessTimer', '_ccActionRestoreTimer', '_ccRetryRestoreTimer'].forEach((key) => {
      if (button[key]) window.clearTimeout(button[key]);
      button[key] = null;
    });
  }

  function showListingStockLimit(button, { label = null, tooltip = null, originalLabel = 'Add To Cart', originalTooltip = 'Add To Cart', duration = 1650 } = {}) {
    if (!button) return;
    rememberListingQuickAddIcon(button);
    clearListingStockTimers(button);

    /* v2.15.669: on a phone shelf card there is no room beside the button for
       the long wording, and a tooltip that is moved or truncated looks broken.
       Shorten the message itself instead — it is used for the tooltip, the
       button label, the title and the aria-label alike. */
    const message = ccStockLimitMessage();
    if (!button._ccOriginalAriaLabel) button._ccOriginalAriaLabel = button.getAttribute('aria-label') || originalTooltip;
    button.classList.remove('is-adding', 'is-success', 'is-retry', 'is-sold-out', 'is-icon-swapping');
    button.classList.add('is-stock-limit');
    button.dataset.stockBlocked = 'true';
    button.removeAttribute('aria-busy');
    button.setAttribute('aria-disabled', 'true');
    button.setAttribute('aria-label', message);
    button.title = message;
    if (label) label.textContent = message;
    if (tooltip) tooltip.textContent = message;
    setListingQuickAddIcon(button, 'max-stock');

    button._ccStockRestoreTimer = window.setTimeout(() => {
      button.classList.remove('is-stock-limit');
      button.removeAttribute('aria-disabled');
      button.setAttribute('aria-label', button._ccOriginalAriaLabel || originalTooltip);
      button.title = originalTooltip;
      if (label) label.textContent = originalLabel;
      if (tooltip) tooltip.textContent = originalTooltip;
      delete button.dataset.stockBlocked;
      setListingQuickAddIcon(button, 'available');
    }, duration);
  }

  function showListingRetry(button, { label = null, tooltip = null, originalLabel = 'Add To Cart', originalTooltip = 'Add To Cart', duration = 1500 } = {}) {
    if (!button) return;
    rememberListingQuickAddIcon(button);
    clearListingStockTimers(button);
    button.classList.remove('is-adding', 'is-success', 'is-stock-limit', 'is-sold-out', 'is-icon-swapping');
    button.classList.add('is-retry');
    if (label) label.textContent = 'Try Again';
    if (tooltip) tooltip.textContent = 'Try Again';
    button.title = 'Try Again';
    setListingQuickAddIcon(button, 'retry');
    button._ccRetryRestoreTimer = window.setTimeout(() => {
      button.classList.remove('is-retry');
      if (label) label.textContent = originalLabel;
      if (tooltip) tooltip.textContent = originalTooltip;
      button.title = originalTooltip;
      setListingQuickAddIcon(button, 'available');
    }, duration);
  }

  function setListingSoldOut(button, { label = null, tooltip = null } = {}) {
    if (!button) return;
    rememberListingQuickAddIcon(button);
    clearListingStockTimers(button);
    button.classList.remove('is-adding', 'is-success', 'is-stock-limit', 'is-retry', 'is-icon-swapping');
    button.classList.add('is-sold-out');
    button.disabled = true;
    button.setAttribute('aria-disabled', 'true');
    button.setAttribute('aria-label', 'Unavailable');
    button.title = 'Unavailable';
    if (label) label.textContent = 'Unavailable';
    if (tooltip) tooltip.textContent = 'Unavailable';
    setListingQuickAddIcon(button, 'sold-out');
  }

  function flashListingActionSuccess(button, label = 'Done', duration = 1250, restoreTooltipText = null) {
    if (!button) return;
    clearListingStockTimers(button);
    button.classList.remove('is-adding', 'is-stock-limit', 'is-retry', 'is-sold-out', 'is-icon-swapping');
    delete button.dataset.stockBlocked;
    const tooltip = q('.listing-action-tooltip', button);
    const addHost = listingQuickAddIconHost(button);
    const directHost = addHost ? null : q('[data-listing-action-icon]', button);
    if (addHost) rememberListingQuickAddIcon(button);
    if (directHost && !button._ccOriginalActionMarkup) button._ccOriginalActionMarkup = directHost.innerHTML;
    const previousTooltip = restoreTooltipText ?? tooltip?.textContent ?? '';

    if (tooltip) tooltip.textContent = label;
    button.classList.add('is-success');
    if (addHost) {
      setListingQuickAddIcon(button, 'success');
    } else if (directHost) {
      directHost.innerHTML = '<svg class="listing-action-success-icon" viewBox="0 -0.15 24 24" aria-hidden="true"><path d="m5 12.5 4.2 4.2L19 7"/></svg>';
    }

    button._ccActionSuccessTimer = window.setTimeout(() => {
      button.classList.remove('is-success');
      if (addHost) {
        setListingQuickAddIcon(button, 'available');
      } else if (directHost && button._ccOriginalActionMarkup) {
        directHost.innerHTML = button._ccOriginalActionMarkup;
      }
      if (tooltip && previousTooltip) tooltip.textContent = previousTooltip;
    }, duration);
  }

  /* v2.15.667: navigator.clipboard.writeText is refused outright in plenty of
     desktop setups ("Write permission denied"), and the old catch swallowed
     that, so the Share button looked dead. This synchronous fallback runs
     inside the click gesture and needs no permission. */
  function ccCopyLinkFallback(text) {
    try {
      const field = document.createElement('textarea');
      field.value = text;
      field.setAttribute('readonly', '');
      field.style.cssText = 'position:fixed;top:0;left:-9999px;opacity:0';
      document.body.appendChild(field);
      const selection = document.getSelection();
      const previous = selection && selection.rangeCount ? selection.getRangeAt(0) : null;
      field.select();
      field.setSelectionRange(0, field.value.length);
      const copied = document.execCommand('copy');
      field.remove();
      if (previous && selection) {
        selection.removeAllRanges();
        selection.addRange(previous);
      }
      return copied;
    } catch (_) {
      return false;
    }
  }

  /* One wording for the stock cap, the same at every width. */
  function ccStockLimitMessage() {
    return 'Max Stock';
  }

  async function shareFromButton(button) {
    const data = { title: button.dataset.title || document.title, url: button.dataset.url || location.href };
    if (navigator.share) {
      /* the checkmark used to wait for the native share sheet to be dismissed,
         so a tap looked like nothing had happened. Confirm the tap first — the
         same instant feedback the copy path gives — then open the sheet. */
      flashListingActionSuccess(button, 'Shared');
      try { await navigator.share(data); } catch (_) { /* user cancelled */ }
      return;
    }
    if (ccCopyLinkFallback(data.url)) {
      flashListingActionSuccess(button, 'Copied');
      return;
    }
    try {
      await navigator.clipboard.writeText(data.url);
      flashListingActionSuccess(button, 'Copied');
    } catch (_) {
      /* never fail silently: the shopper still gets an answer. */
      flashListingActionSuccess(button, 'Copy Failed');
    }
  }

  document.addEventListener('click', (event) => {
    const shareButton = event.target.closest('[data-share-button], [data-card-share]');
    if (!shareButton) return;
    event.preventDefault();
    if (event.detail > 0) window.requestAnimationFrame(() => shareButton.blur());
    shareFromButton(shareButton);
  });

  /* Pointer exit always returns a listing card to its normal hidden rail state. */
  document.addEventListener('pointerout', (event) => {
    const card = event.target.closest?.('.full-bottle-strip-card');
    if (!card || card.contains(event.relatedTarget)) return;
    qa('.listing-hover-toolbar button:focus', card).forEach((control) => control.blur());
  });

  /* v0.5.22 listing-card quick add. Delegated so recommendations also work. */
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-card-quick-add]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    if (event.detail > 0) window.requestAnimationFrame(() => button.blur());
    if (button.disabled || button.dataset.busy === 'true' || button.dataset.stockBlocked === 'true') return;

    const variantId = Number(button.dataset.variantId || 0);
    if (!variantId) return;
    const stockMax = Number(button.dataset.stockMax || NaN);

    const label = q('[data-card-add-label]', button);
    const tooltip = q('[data-card-add-tooltip]', button);
    const originalLabel = label?.textContent || 'Add To Cart';
    const originalTooltip = tooltip?.textContent || 'Add To Cart';

    if (Number.isFinite(stockMax)) {
      if (stockMax <= 0) {
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
        if (label) label.textContent = 'Unavailable';
        if (tooltip) tooltip.textContent = 'Unavailable';
        return;
      }
      if (cartCache && cartQuantityForVariant(cartCache, variantId) >= stockMax) {
        showListingStockLimit(button, { label, tooltip, originalLabel, originalTooltip });
        return;
      }
    }

    button.dataset.busy = 'true';
    button.setAttribute('aria-busy', 'true');
    clearListingStockTimers(button);
    delete button.dataset.stockBlocked;
    // Immediate feedback: amber means Shopify is still confirming inventory;
    // green is reserved for a confirmed add.
    button.classList.remove('is-stock-limit', 'is-success', 'is-retry', 'is-sold-out');
    rememberListingQuickAddIcon(button);
    button.classList.add('is-adding');
    setListingQuickAddIcon(button, 'adding');
    if (label) label.textContent = 'Adding…';
    if (tooltip) tooltip.textContent = 'Adding…';
    button.title = 'Adding To Cart';

    try {
      await cartAdd({ items: [{ id: variantId, quantity: 1 }] });

      if (label) label.textContent = 'Added';
      if (tooltip) tooltip.textContent = 'Added';
      button.title = 'Added To Cart';
      button.classList.remove('is-adding');
      flashListingActionSuccess(button, 'Added', 1100, originalTooltip);
      openCartImmediately();

      window.setTimeout(() => {
        if (label) label.textContent = originalLabel;
        if (tooltip) tooltip.textContent = originalTooltip;
        button.title = originalTooltip;
        button.dataset.busy = 'false';
        button.removeAttribute('aria-busy');
      }, 1320);
    } catch (error) {
      button.classList.remove('is-adding');
      button.classList.remove('is-success');
      const stockLimit = isStockError(error);
      const soldOut = isSoldOutError(error);
      const message = soldOut ? 'Sold Out' : (stockLimit ? ccStockLimitMessage() : 'Try Again');
      if (label) label.textContent = message;
      if (tooltip) tooltip.textContent = message;
      button.dataset.busy = 'false';
      button.removeAttribute('aria-busy');
      if (stockLimit && !soldOut) {
        showListingStockLimit(button, { label, tooltip, originalLabel, originalTooltip });
      } else if (soldOut) {
        setListingSoldOut(button, { label, tooltip });
      } else {
        showListingRetry(button, { label, tooltip, originalLabel, originalTooltip });
      }
      console.error(error);
    }
  });

  /* Performance: this runs on scroll. Writing a custom property on <html>
     forces a full-page style recalculation, so the value is written only when
     it actually changes, and only onto the elements that read it (sidebar and
     scrim). <html> still receives the initial value for first paint. */
  let ccFilterDrawerRootSet = false;
  const syncFilterDrawerGeometry = () => {
    const sidebar = q('[data-filter-sidebar]');
    if (!sidebar) return;
    const visibleHeader = q('[data-site-header]');
    const headerBottom = visibleHeader ? Math.max(0, Math.ceil(visibleHeader.getBoundingClientRect().bottom)) : 0;
    const value = `${headerBottom}px`;
    if (!ccFilterDrawerRootSet) {
      ccFilterDrawerRootSet = true;
      document.documentElement.style.setProperty('--cc-filter-drawer-top', value);
    }
    [sidebar, ...qa('.cc139-filter-scrim')].forEach((element) => {
      if (element.style.getPropertyValue('--cc-filter-drawer-top') !== value) {
        element.style.setProperty('--cc-filter-drawer-top', value);
      }
    });
  };

  qa('[data-filter-toggle]').forEach((button) => button.addEventListener('click', () => {
    const sidebar = q('[data-filter-sidebar]');
    if (!sidebar) return;
    const opening = !sidebar.classList.contains('is-open');
    if (opening) syncFilterDrawerGeometry();
    sidebar.classList.toggle('is-open', opening);
    button.setAttribute('aria-expanded', String(opening));
  }));
  qa('[data-filter-close]').forEach((button) => button.addEventListener('click', () => {
    q('[data-filter-sidebar]')?.classList.remove('is-open');
    qa('[data-filter-toggle]').forEach((toggle) => toggle.setAttribute('aria-expanded', 'false'));
  }));

  /* v2.16 — the clicked Category / Brand row takes the selected style the
     moment it is clicked (same 0.2s colour transition as the Help / Company
     rail), while the next catalogue page loads behind the view transition.
     If the shopper comes back with Back, the page's real selection returns. */
  const FILTER_ROW_SELECTOR = '.cc-catalog .cc-sidebar :is(.source-v0514-category-list, .source-v0514-brand-list) a[href]';
  document.addEventListener('click', (event) => {
    const row = event.target.closest(FILTER_ROW_SELECTOR);
    if (!row || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    // Remember the page's own selection (including brand rows marked by script) once.
    qa(FILTER_ROW_SELECTOR).forEach((other) => {
      if (!other.dataset.ccServerActive) other.dataset.ccServerActive = other.classList.contains('is-active') ? 'true' : 'false';
    });
    qa(FILTER_ROW_SELECTOR).forEach((other) => other.classList.toggle('is-active', other === row));
  });
  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    qa(FILTER_ROW_SELECTOR).forEach((row) => {
      if (row.dataset.ccServerActive) row.classList.toggle('is-active', row.dataset.ccServerActive === 'true');
    });
  });

  let ccFilterGeometryFrame = 0;
  const requestFilterGeometrySync = () => {
    const sidebar = q('[data-filter-sidebar]');
    if (!sidebar || ccFilterGeometryFrame) return;
    ccFilterGeometryFrame = window.requestAnimationFrame(() => {
      ccFilterGeometryFrame = 0;
      syncFilterDrawerGeometry();
    });
  };
  syncFilterDrawerGeometry();
  window.addEventListener('resize', requestFilterGeometrySync, { passive: true });
  /* v103: on phones the drawer's top is measured when it opens (and the page is
     held still while it is open), so scrolling no longer re-positions it. The
     desktop sticky rail still follows the header as it scrolls away. */
  const ccFilterDrawerMode = window.matchMedia('(max-width: 899px)');
  window.addEventListener('scroll', () => {
    if (!ccFilterDrawerMode.matches) requestFilterGeometrySync();
  }, { passive: true });

  qa('[data-product-recommendations]').forEach(async (element) => {
    if (element.dataset.recommendationsPerformed === 'true') return;
    try {
      const response = await fetch(element.dataset.url);
      if (!response.ok || !element.isConnected) return;
      const text = await response.text();
      const documentFragment = new DOMParser().parseFromString(text, 'text/html');
      const fresh = documentFragment.querySelector('[data-product-recommendations]');
      if (fresh?.dataset.recommendationsPerformed === 'true') {
        element.innerHTML = fresh.innerHTML;
        element.dataset.recommendationsPerformed = 'true';
        initReveal(element);
        syncWishlist(element);
        window.requestAnimationFrame(() => syncShelfArrowCenters(element));
        element.dispatchEvent(new CustomEvent('cc:listings-updated', { bubbles: true }));
      }
    } catch (error) { console.warn(error); }
  });

  const RECENT_KEY = 'cc-recent-products-v2';
  const LEGACY_RECENT_KEY = 'cc-recent-products-v1';
  const LEGACY_TESTER_CANONICAL = {
    'afnan-9pm-elixir-tester': 'afnan-9pm-elixir',
  };

  const recentDisplayTitle = (rawTitle = '', vendor = '') => {
    let title = String(rawTitle || '').trim();
    title = title
      .replace(/\b\d+(?:\.\d+)?\s*ml\b/gi, ' ')
      .replace(/\b(?:Eau de Parfum|Extrait de Parfum|Eau de Toilette|Tester Bottle|Tester|4-Piece Gift Set|4pc Gift Set|Gift Set)\b/gi, ' ')
      .replace(/\s{2,}/g, ' ')
      .trim();
    const vendorText = String(vendor || '').trim();
    if (vendorText && title.toLowerCase().startsWith(`${vendorText.toLowerCase()} `)) {
      title = title.slice(vendorText.length).trim();
    }
    return title || String(rawTitle || 'Fragrance').trim();
  };

  const canonicalizeRecentItem = (raw = {}) => {
    const item = { ...raw };
    const mappedHandle = LEGACY_TESTER_CANONICAL[String(item.handle || '').toLowerCase()];
    if (mappedHandle) {
      item.handle = mappedHandle;
      item.url = `/products/${mappedHandle}`;
      item.metaReady = false;
      item.pricingReady = false;
      item.isTester = false;
      item.testerAvailable = true;
    }
    return item;
  };

  const recentIdentityKey = (item = {}) => {
    const canonical = canonicalizeRecentItem(item);
    const vendor = String(canonical.vendor || '').toLowerCase().trim();
    const title = recentDisplayTitle(canonical.title || '', canonical.vendor || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
    return `${vendor}::${title || canonical.handle || ''}`;
  };

  const dedupeRecentItems = (items = []) => {
    const groups = new Map();
    items.filter(Boolean).map(canonicalizeRecentItem).forEach((item) => {
      const key = recentIdentityKey(item);
      if (!key || key.endsWith('::')) return;
      const existing = groups.get(key);
      if (!existing) {
        groups.set(key, item);
        return;
      }
      const score = (entry) => {
        let value = 0;
        if (entry.testerAvailable) value += 40;
        if (!entry.isTester) value += 20;
        if (entry.available !== false) value += 10;
        if (entry.metaReady) value += 2;
        return value;
      };
      const keep = score(item) > score(existing) ? item : existing;
      const other = keep === item ? existing : item;
      groups.set(key, {
        ...keep,
        testerAvailable: Boolean(keep.testerAvailable || other.testerAvailable || keep.isTester || other.isTester),
        isTester: false,
      });
    });
    return Array.from(groups.values());
  };

  async function hydrateRecentItem(item) {
    if (!item?.handle) return item;
    if (item.metaReady && item.pricingReady && item.galleryReady && !item.testerAvailable && !item.isTester) return item;
    try {
      const response = await fetch(`${item.url || `/products/${item.handle}`}.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) return item;
      const product = await response.json();
      const availableVariants = Array.isArray(product.variants) ? product.variants.filter((entry) => entry.available) : [];
      // Decants are an add-on on the bottle page: price the card from the bottle.
      // A sold-out boxed bottle with its tester in stock is priced from the tester.
      const isBottle = (entry) => !/tester|decant/i.test(String(entry.title || ''));
      const isTesterVariant = (entry) => /tester/i.test(String(entry.title || ''));
      const variant = availableVariants.find(isBottle) || availableVariants.find(isTesterVariant) || (product.variants || []).find(isBottle) || availableVariants[0] || product.variants?.[0];
      const currentPriceCents = Number(variant?.price || 0);
      const comparePriceCents = Number(variant?.compare_at_price || 0);
      const savingPercent = comparePriceCents > currentPriceCents && currentPriceCents >= 0
        ? Math.round(((comparePriceCents - currentPriceCents) * 100) / comparePriceCents)
        : 0;
      const tags = Array.isArray(product.tags)
        ? product.tags.map((tag) => String(tag).toLowerCase())
        : String(product.tags || '').split(',').map((tag) => tag.trim().toLowerCase()).filter(Boolean);
      const titleLower = String(product.title || item.title || '').toLowerCase();
      const isGiftSet = tags.includes('gift set') || titleLower.includes('gift set');
      const isBundle = tags.includes('bundle') || titleLower.includes('bundle');
      const isTester = tags.includes('tester') || titleLower.includes('tester');
      const testerAvailable = Boolean(product.variants?.some((entry) => entry.available && String(entry.title || '').toLowerCase().includes('tester')));
      return {
        ...item,
        variantId: item.variantId || variant?.id || '',
        available: item.available !== undefined ? item.available : Boolean(variant?.available),
        image: catalogMediaFor(item.handle).image || (Array.isArray(product.images) && product.images[0]) || product.featured_image || item.image || fallbackImageFor(item.handle),
        secondaryImage: catalogMediaMap().get(String(item.handle || '').toLowerCase())?.single1
          ? (catalogMediaFor(item.handle).secondaryImage || '')
          : (catalogMediaFor(item.handle).secondaryImage || (Array.isArray(product.images) && product.images[1]) || ''),
        galleryReady: true,
        title: recentDisplayTitle(product.title || item.title, product.vendor || item.vendor),
        vendor: product.vendor || item.vendor || '',
        price: currentPriceCents ? moneyWithCurrency(currentPriceCents) : item.price || '',
        comparePrice: savingPercent > 0 ? drawerMoney(comparePriceCents) : '',
        savingPercent,
        pricingReady: true,
        isGiftSet,
        isBundle,
        isTester,
        testerAvailable,
        metaReady: true,
      };
    } catch (_) {
      return item;
    }
  }

  function recentCardMarkup(item) {
    const handle = escapeHtml(item.handle || '');
    const title = escapeHtml(item.title || 'Fragrance');
    const vendor = escapeHtml(item.vendor || '');
    const url = escapeHtml(item.url || `/products/${item.handle}`);
    const image = escapeHtml(sizedShopifyImage(item.image) || fallbackImageFor(item.handle));
    const secondaryImage = escapeHtml(sizedShopifyImage(item.secondaryImage || ''));
    const hasSecondaryImage = Boolean(secondaryImage);
    const price = escapeHtml(item.price || '');
    const comparePrice = escapeHtml(item.comparePrice || '');
    const savingPercent = Math.max(0, Number(item.savingPercent || 0));
    const priceMarkup = `${savingPercent > 0 && comparePrice ? `<del>${comparePrice}</del>` : ''}<strong>${price}</strong><em>${savingPercent > 0 ? `${savingPercent}% OFF` : 'SALE'}</em>`;
    const canQuickAdd = item.variantId && item.available !== false;
    const thirdAction = canQuickAdd
      ? `<button type="button" class="listing-hover-add" data-card-quick-add data-variant-id="${escapeHtml(item.variantId)}" aria-label="Add ${title} to cart" title="Add To Cart"><span class="listing-action-tooltip" aria-hidden="true" data-card-add-tooltip>Add To Cart</span><span class="listing-hover-add-icon listing-action-icon" aria-hidden="true" data-card-add-icon><svg viewBox="0 -0.85 24 24"><path d="M6.5 8.2h11l-.8 10.3H7.3L6.5 8.2Z"/><path d="M9 8.2V6.8a3 3 0 0 1 6 0v1.4M12 11v4M10 13h4"/></svg></span><span class="listing-hover-add-label" data-card-add-label>Add To Cart</span></button>`
      : `<a class="listing-hover-add" href="${url}" aria-label="View ${title}" title="View Product"><span class="listing-action-tooltip" aria-hidden="true">View Product</span><span class="listing-hover-add-icon listing-action-icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none"><path d="M5 12h14M13 6l6 6-6 6"/></svg></span><span class="listing-hover-add-label">View Product</span></a>`;

    return `<article class="full-bottle-strip-card recent-product-card" data-product-card data-product-handle="${handle}" data-product-vendor="${vendor}" data-product-display-title="${title}" data-product-is-bundle="${item.isBundle ? 'true' : 'false'}" data-product-is-tester="${item.isTester ? 'true' : 'false'}" data-product-tester-available="${item.testerAvailable ? 'true' : 'false'}" data-product-available="${item.available === false ? 'false' : 'true'}">
      <div class="full-bottle-strip-visual">
        <div class="full-bottle-strip-image-shell">
          <a href="${url}" class="full-bottle-strip-image-link" aria-label="View ${title}"><div class="full-bottle-strip-image-stage${hasSecondaryImage ? ' has-secondary-image' : ''}"><img src="${image}" data-fallback-handle="${handle}" alt="${title}" loading="lazy" decoding="async" class="full-bottle-strip-image full-bottle-strip-image-primary">${hasSecondaryImage ? `<img src="${secondaryImage}" alt="${title} alternate view" loading="lazy" decoding="async" class="full-bottle-strip-image full-bottle-strip-image-secondary">` : ''}</div></a>
        </div>
          <div class="listing-hover-toolbar" data-card-toolbar aria-label="Product actions">
          <button type="button" class="listing-wishlist-button" data-wishlist-button data-product-handle="${handle}" data-product-title="${title}" data-product-vendor="${vendor}" data-product-url="${url}" data-product-image="${image}" data-product-price="${price}" data-product-variant-id="${escapeHtml(item.variantId || '')}" data-product-available="${item.available === false ? 'false' : 'true'}" aria-label="Add ${title} to wishlist" aria-pressed="false" title="Wishlist"><span class="listing-action-tooltip" aria-hidden="true">Wishlist</span><span class="listing-action-icon" data-listing-action-icon aria-hidden="true"><svg viewBox="0 0.173 24 24"><path d="M20.8 4.9a5.3 5.3 0 0 0-7.5 0L12 6.2l-1.3-1.3a5.3 5.3 0 0 0-7.5 7.5L12 21l8.8-8.6a5.3 5.3 0 0 0 0-7.5Z"/></svg></span></button>
          <button type="button" class="listing-share-button" data-card-share data-title="${title}" data-url="${escapeHtml(location.origin)}${url}${item.variantId ? `?variant=${escapeHtml(item.variantId)}` : ''}" aria-label="Share ${title}" title="Share"><span class="listing-action-tooltip" aria-hidden="true">Share</span><span class="listing-action-icon" data-listing-action-icon aria-hidden="true"><svg class="listing-share-glyph" viewBox="0 0 24 24"><circle cx="18" cy="5" r="2.5"/><circle cx="6" cy="12" r="2.5"/><circle cx="18" cy="19" r="2.5"/><path d="m8.2 10.8 7.5-4.4M8.2 13.2l7.5 4.4"/></svg></span></button>
          ${thirdAction}
          </div>
      </div>
      <a href="${url}" class="full-bottle-strip-body-link" aria-label="View ${title} details"><div class="full-bottle-strip-body"><p class="listing-product-brand">${vendor}</p><h3>${title}</h3><p class="full-bottle-strip-price">${priceMarkup}</p></div></a>
    </article>`;
  }

  async function initRecentlyViewed() {
    const current = q('[data-current-product]');
    const section = q('[data-recently-viewed-section]');
    if (!current || !section) return;
    let items = [];
    try {
      items = JSON.parse(localStorage.getItem(RECENT_KEY) || localStorage.getItem(LEGACY_RECENT_KEY) || '[]');
    } catch (_) { items = []; }
    items = dedupeRecentItems(Array.isArray(items) ? items : []);
    const currentIdentity = recentIdentityKey({ handle: current.dataset.handle, title: current.dataset.title, vendor: current.dataset.vendor });
    const previous = items.filter((item) => item?.handle && recentIdentityKey(item) !== currentIdentity);
    const limit = Math.max(2, Number(section.dataset.limit || 5));
    const grid = q('[data-recently-viewed-grid]', section);
    const newCurrent = {
      handle: current.dataset.handle,
      title: current.dataset.title,
      vendor: current.dataset.vendor,
      url: current.dataset.url,
      price: current.dataset.price,
      comparePrice: current.dataset.comparePrice || '',
      savingPercent: Number(current.dataset.savingPercent || 0),
      pricingReady: true,
      image: current.dataset.image,
      secondaryImage: current.dataset.secondaryImage || '',
      galleryReady: current.dataset.galleryReady === 'true',
      variantId: current.dataset.variantId || '',
      available: current.dataset.available === 'true',
      isGiftSet: current.dataset.isGiftSet === 'true',
      isBundle: current.dataset.isBundle === 'true',
      isTester: current.dataset.isTester === 'true',
      testerAvailable: current.dataset.testerAvailable === 'true',
      metaReady: true,
    };
    const stored = dedupeRecentItems([canonicalizeRecentItem(newCurrent), ...previous]).slice(0, 12);
    try {
      localStorage.setItem(RECENT_KEY, JSON.stringify(stored));
      localStorage.removeItem(LEGACY_RECENT_KEY);
    } catch (_) { /* Recently viewed still renders when browser storage is unavailable. */ }

    const displayBase = previous.length ? previous.slice(0, limit) : [canonicalizeRecentItem(newCurrent)];
    const hydratedItems = await Promise.all(displayBase.map((item) => hydrateRecentItem(canonicalizeRecentItem(item))));
    const officialMediaMap = catalogMediaMap();
    const galleryItems = hydratedItems.map((item) => {
      const itemHandle = String(item?.handle || '').toLowerCase();
      const itemTitle = String(item?.title || '').toLowerCase();
      const isDecantItem = itemHandle.startsWith('decant-') || itemTitle.startsWith('decant ');
      const record = officialMediaMap.get(itemHandle);
      if (!record || (record.decantOnly && !isDecantItem)) return item;

      let image = '';
      let secondaryImage = '';
      if (record.single1) {
        image = record.single1;
        secondaryImage = record.single2 || '';
      } else if (isDecantItem) {
        image = record.bottle || '';
        secondaryImage = record.box || '';
      } else {
        image = record.box || '';
        secondaryImage = record.bottle || '';
      }
      if (!image) return item;
      return { ...item, image, secondaryImage, galleryReady: true };
    });
    const displayItems = dedupeRecentItems(galleryItems)
      .filter((item) => !item.isTester || item.testerAvailable)
      .slice(0, limit);
    if (grid && displayItems.length) {
      grid.innerHTML = displayItems.map(recentCardMarkup).join('');
      section.hidden = false;
      syncWishlist(section);
      initReveal(section);
      window.requestAnimationFrame(() => syncShelfArrowCenters(section));
      section.dispatchEvent(new CustomEvent('cc:listings-updated', { bubbles: true }));
    }
  }

  /* Featured fragrance rotation: randomized Shopify collection pool + timer + mobile swipe. */
  function initHeroRotation(root = document) {
    root.querySelectorAll('[data-hero-rotation]').forEach((rotation) => {
      if (rotation.dataset.rotationReady) return;
      rotation.dataset.rotationReady = 'true';

      const pool = q('[data-hero-feature-pool]', rotation);
      const randomize = rotation.dataset.randomize === 'true';
      const visibleCount = Math.max(0, Number(rotation.dataset.visibleCount) || 0);

      if (randomize && !rotation.dataset.productsRandomized) {
        const rows = qa('[data-hero-feature-row]', rotation);
        if (rows.length > 1) {
          for (let i = rows.length - 1; i > 0; i -= 1) {
            const j = Math.floor(Math.random() * (i + 1));
            [rows[i], rows[j]] = [rows[j], rows[i]];
          }
          const initialPages = qa('[data-hero-page]', rotation);
          initialPages.forEach((page) => {
            qa('[data-hero-feature-row]', page).forEach((row) => row.remove());
          });
          rows.forEach((row, rowIndex) => {
            if (rowIndex < visibleCount && initialPages.length) {
              const pageIndex = Math.min(initialPages.length - 1, Math.floor(rowIndex / 5));
              row.dataset.featureIndex = String(rowIndex % 5);
              initialPages[pageIndex].appendChild(row);
            } else if (pool) {
              pool.appendChild(row);
            }
          });
        }
        rotation.dataset.productsRandomized = 'true';
      }

      const pages = qa('[data-hero-page]', rotation);
      const buttons = qa('[data-hero-page-button]', rotation);
      if (pages.length < 2) return;

      let index = Math.max(0, pages.findIndex((page) => page.classList.contains('is-active')));
      let timer = null;
      let touchStartX = null;
      let touchStartY = null;
      let swipeAxis = null;
      let swipeCommitted = false;
      let lastTouchX = 0;
      let lastTouchTime = 0;
      let touchVelocity = 0;
      const SWIPE_DISTANCE = 24;
      const interval = Math.max(7000, Number(rotation.dataset.speed) || 9000);
      const mobileSwipe = () => window.matchMedia('(max-width: 767px)').matches;
      const rotationInterval = () => mobileSwipe() ? Math.max(14000, interval) : interval;

      /* Switching pages is only a class change; the stylesheet runs the same
         fade, rise and staggered-row transition on every screen size. */
      const show = (next) => {
        index = (next + pages.length) % pages.length;
        pages.forEach((page, pageIndex) => {
          const active = pageIndex === index;
          page.classList.toggle('is-active', active);
          page.setAttribute('aria-hidden', String(!active));
        });
        buttons.forEach((button, buttonIndex) => {
          const active = buttonIndex === index;
          button.classList.toggle('is-active', active);
          if (active) button.setAttribute('aria-current', 'true');
          else button.removeAttribute('aria-current');
        });
      };

      const resetTouchState = () => {
        touchStartX = null;
        touchStartY = null;
        swipeAxis = null;
        swipeCommitted = false;
        touchVelocity = 0;
      };

      const stop = () => {
        if (timer) window.clearInterval(timer);
        timer = null;
      };
      const start = () => {
        if (!rotation.isConnected || !motionEnabled() || timer || document.hidden) return;
        timer = window.setInterval(() => {
          if (!rotation.isConnected) { cleanup(); return; }
          show(index + 1);
        }, rotationInterval());
      };

      buttons.forEach((button, buttonIndex) => button.addEventListener('click', () => {
        show(buttonIndex);
        stop();
        start();
      }));

      /* Phone swipe: the swipe only triggers the page change (desktop has no
         drag, so nothing follows the finger). It fires as soon as the gesture
         is clearly horizontal, without waiting for the finger to lift; a short
         quick flick is picked up on release. */
      rotation.addEventListener('touchstart', (event) => {
        if (!mobileSwipe() || !event.touches || event.touches.length !== 1) return;
        resetTouchState();
        touchStartX = event.touches[0].clientX;
        touchStartY = event.touches[0].clientY;
        lastTouchX = touchStartX;
        lastTouchTime = event.timeStamp || Date.now();
        stop();
      }, { passive: true });

      rotation.addEventListener('touchmove', (event) => {
        if (!mobileSwipe() || touchStartX === null || !event.touches || event.touches.length !== 1) return;
        const touch = event.touches[0];
        const dx = touch.clientX - touchStartX;
        const dy = touch.clientY - touchStartY;
        if (!swipeAxis) {
          if (Math.abs(dx) < 4 && Math.abs(dy) < 4) return;
          swipeAxis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        }
        if (swipeAxis !== 'x') return;
        const now = event.timeStamp || Date.now();
        const elapsed = now - lastTouchTime;
        if (elapsed > 0) touchVelocity = (touch.clientX - lastTouchX) / elapsed;
        lastTouchX = touch.clientX;
        lastTouchTime = now;
        if (!swipeCommitted && Math.abs(dx) >= SWIPE_DISTANCE) {
          swipeCommitted = true;
          show(index + (dx < 0 ? 1 : -1));
        }
      }, { passive: true });

      rotation.addEventListener('touchend', (event) => {
        const touch = event.changedTouches && event.changedTouches[0];
        if (mobileSwipe() && touch && touchStartX !== null && !swipeCommitted) {
          const dx = touch.clientX - touchStartX;
          const dy = touch.clientY - touchStartY;
          const horizontal = Math.abs(dx) > Math.abs(dy) * 1.05;
          const flick = Math.abs(touchVelocity) >= 0.24 && Math.abs(dx) >= 10;
          if (horizontal && (Math.abs(dx) >= SWIPE_DISTANCE || flick)) show(index + (dx < 0 ? 1 : -1));
        }
        resetTouchState();
        start();
      }, { passive: true });

      rotation.addEventListener('touchcancel', () => {
        resetTouchState();
        start();
      }, { passive: true });

      rotation.addEventListener('mouseenter', stop);
      rotation.addEventListener('mouseleave', start);
      rotation.addEventListener('focusin', stop);
      rotation.addEventListener('focusout', start);
      const onVisibilityChange = () => { stop(); start(); };
      const onSectionUnload = (event) => {
        if (event.target.contains(rotation)) cleanup();
      };
      const cleanup = () => {
        stop();
        document.removeEventListener('visibilitychange', onVisibilityChange);
        document.removeEventListener('shopify:section:unload', onSectionUnload);
        reduceMotion.removeEventListener?.('change', onVisibilityChange);
      };
      document.addEventListener('visibilitychange', onVisibilityChange);
      document.addEventListener('shopify:section:unload', onSectionUnload);
      reduceMotion.addEventListener?.('change', onVisibilityChange);

      show(index);
      start();
    });
  }

  /* Scroll reveal: mirrors source ScrollReveal component, GPU-only transforms. */
  let revealObserver;
  function initReveal(root = document) {
    const selectors = [
      '.product-section-heading', '.full-bottle-strip-card', '.why-heading', '.why-card',
      '.restock-section-inner', '.footer-brand', '.footer-column', '.footer-bottom',
      '.collection-hero', '.collection-toolbar', '.main-product', '.product-recommendations',
      '.search-page > *', '.contact-page > *', '.page-main > *', '.cart-page > *',
    ];
    const elements = qa(selectors.join(','), root).filter((element) => !element.dataset.revealReady);
    if (!elements.length) return;

    elements.forEach((element, elementIndex) => {
      element.dataset.revealReady = 'true';
      element.classList.add('cc-source-reveal');
      element.style.setProperty('--cc-reveal-delay', `${Math.min((elementIndex % 5) * 35, 60)}ms`);
      if (element.matches('.full-bottle-strip-card, .why-card')) element.classList.add('reveal-scale');
    });

    /* v95: catalogue results (Shop All, a brand, a category, search) arrive one by
       one in reading order - a domino across the first rows, then row by row
       (left to right) as the shopper scrolls. */
    /* v103: on phones only the first two rows play the domino; the listings
       further down are already in place when the shopper scrolls to them, so a
       fast swipe never shows empty gaps or cards sliding up into place. */
    const phoneCatalogue = window.matchMedia('(max-width: 767px)').matches;
    const instantReveal = new Set();
    qa('.cc-catalog .basic-product-grid', root).forEach((grid) => {
      const columns = Math.max(1, getComputedStyle(grid).gridTemplateColumns.split(' ').filter(Boolean).length);
      Array.from(grid.children).forEach((card, cardIndex) => {
        if (!card.classList.contains('cc-source-reveal')) return;
        const row = Math.floor(cardIndex / columns);
        const step = row < 2 ? cardIndex : cardIndex % columns;
        card.style.setProperty('--cc-reveal-delay', `${Math.min(step * 70, 700)}ms`);
        if (phoneCatalogue && row >= 2) instantReveal.add(card);
      });
    });

    if (!motionEnabled()) {
      elements.forEach((element) => element.classList.add('is-visible'));
      return;
    }

    if (!revealObserver) {
      revealObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
          /* v78: when a product shelf comes into view, every listing in it is
             revealed together. The listings on the next pages used to start their
             reveal only once paged to, and the arrows (which line up with the
             listing photos) followed that motion - dipping down, then easing back. */
          const shelfRow = entry.target.closest?.('[data-cc246-row], [data-shelf-row], [data-cc-deals-track]');
          if (shelfRow) {
            shelfRow.querySelectorAll(':scope > .cc-source-reveal:not(.is-visible)').forEach((card) => {
              card.classList.add('is-visible');
              observer.unobserve(card);
            });
          }
        });
      }, { threshold: 0.06, rootMargin: '0px 0px -24px 0px' });
    }
    elements.forEach((element) => {
      if (instantReveal.has(element)) {
        element.style.setProperty('--cc-reveal-delay', '0ms');
        element.classList.add('cc-reveal-instant', 'is-visible');
      } else {
        revealObserver.observe(element);
      }
    });
  }

  function initAnimatedProductAccordions(root = document) {
    qa('.simple-product-accordions details', root).forEach((details) => {
      if (details.dataset.accordionReady === 'true') return;
      details.dataset.accordionReady = 'true';
      details.removeAttribute('open');
      const summary = q('summary', details);
      const panel = q('.simple-accordion-panel', details) || q(':scope > div', details);
      if (!summary || !panel) return;
      summary.setAttribute('aria-expanded', 'false');

      summary.addEventListener('click', (event) => {
        event.preventDefault();
        if (details.dataset.animating === 'true') return;
        details.dataset.animating = 'true';
        const opening = !details.open;
        const duration = dropdownMotion() ? 260 : 0;

        if (opening) {
          details.open = true;
          summary.setAttribute('aria-expanded', 'true');
          panel.style.overflow = 'hidden';
          const targetHeight = panel.scrollHeight;
          const animation = panel.animate(
            [{ height: '0px', opacity: 0, transform: 'translateY(-4px)' }, { height: `${targetHeight}px`, opacity: 1, transform: 'translateY(0)' }],
            { duration, easing: 'cubic-bezier(.16,1,.3,1)' },
          );
          animation.onfinish = () => {
            panel.style.overflow = '';
            details.dataset.animating = 'false';
          };
          animation.oncancel = () => { details.dataset.animating = 'false'; };
        } else {
          summary.setAttribute('aria-expanded', 'false');
          panel.style.overflow = 'hidden';
          const startHeight = panel.getBoundingClientRect().height;
          const animation = panel.animate(
            [{ height: `${startHeight}px`, opacity: 1, transform: 'translateY(0)' }, { height: '0px', opacity: 0, transform: 'translateY(-4px)' }],
            { duration, easing: 'cubic-bezier(.4,0,.2,1)' },
          );
          animation.onfinish = () => {
            details.open = false;
            panel.style.overflow = '';
            details.dataset.animating = 'false';
          };
          animation.oncancel = () => { details.dataset.animating = 'false'; };
        }
      });
    });
  }


  /* Live Shopify predictive search for both the desktop and compact header
     forms. Results are rendered by Liquid so prices, product URLs and the
     theme's official primary/secondary imagery remain authoritative. */
  const predictiveSearchCache = new Map();
  const predictiveSearchForms = new Set();

  function closePredictiveSearch(form, { clearActive = true } = {}) {
    if (!form) return;
    const input = q('[data-predictive-search-input]', form);
    const panel = q('[data-predictive-search-panel]', form);
    if (form._ccPredictiveTimer) window.clearTimeout(form._ccPredictiveTimer);
    form._ccPredictiveController?.abort();
    form._ccPredictiveController = null;
    form.classList.remove('is-predictive-loading', 'is-predictive-open');
    form.setAttribute('aria-expanded', 'false');
    input?.setAttribute('aria-expanded', 'false');
    if (clearActive) input?.removeAttribute('aria-activedescendant');
    if (!panel) return;
    if (form.matches('[data-compact-search-panel]')) panel.hidden = true;
    else hideHeaderDrawer(panel);
  }

  /* Close cart / wishlist / contact before a search dropdown opens. */
  function closeHeaderDropdownsForSearch() {
    hideHeaderDrawer(cartPanel, { immediate: true });
    cartToggle?.setAttribute('aria-expanded', 'false');
    setCartDrawerOpenState(false);
    hideHeaderDrawer(wishlistPanel, { immediate: true });
    wishlistToggle?.setAttribute('aria-expanded', 'false');
    closeContactDrawers({ immediate: true });
  }

  function closeOtherPredictiveSearch(currentForm = null) {
    predictiveSearchForms.forEach((form) => {
      if (form !== currentForm) closePredictiveSearch(form);
    });
  }

  function preparePredictiveResults(form, panel) {
    const items = qa('[data-predictive-result]', panel);
    items.forEach((item, index) => {
      item.id = `${panel.id || 'PredictiveSearch'}-Result-${index + 1}`;
      item.dataset.predictiveResultIndex = String(index);
      item.setAttribute('aria-selected', 'false');
    });
    form.dataset.predictiveResultCount = String(items.length);
  }

  function normalizePredictiveText(value = '') {
    return String(value)
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLocaleLowerCase()
      .replace(/[^a-z0-9]+/g, ' ')
      .trim()
      .replace(/\s+/g, ' ');
  }

  function filterAndRankPredictiveResults(panel, query) {
    const list = q('[data-ccs-list]', panel);
    if (!list) return;
    const phrase = normalizePredictiveText(query);
    const tokens = phrase.split(' ').filter(Boolean);
    const ranked = qa('[data-predictive-result]', list).map((item, originalIndex) => {
      const title = normalizePredictiveText(item.dataset.productTitle || q('.ccs-title', item)?.textContent || '');
      const vendor = normalizePredictiveText(item.dataset.productVendor || q('.ccs-brand', item)?.textContent || '');
      const searchable = `${title} ${vendor}`.trim();
      /* Shopify already matched these products (it understands partial words
         like "perfum"), so rank them rather than dropping any. */
      let score = tokens.every((token) => searchable.includes(token)) ? 100 : 0;
      if (title === phrase) score += 1000;
      else if (title.startsWith(phrase)) score += 800;
      else if (title.includes(phrase)) score += 650;
      else if (searchable.includes(phrase)) score += 500;
      score += tokens.reduce((total, token) => total + (title.includes(token) ? 40 : 15), 0);
      if (item.dataset.productKind === 'full-bottle') score += 2;
      return { item, originalIndex, score };
    }).filter(Boolean).sort((a, b) => b.score - a.score || a.originalIndex - b.originalIndex);

    list.replaceChildren(...ranked.map(({ item }) => item));
    const count = ranked.length;
    if (!count) {
      list.replaceWith(Object.assign(document.createElement('div'), {
        className: 'ccs-empty',
        innerHTML: '<strong>No fragrances found</strong><span>Try another product name or brand.</span>',
      }));
    }
  }

  function openPredictiveSearch(form) {
    const input = q('[data-predictive-search-input]', form);
    const panel = q('[data-predictive-search-panel]', form);
    if (!input || !panel || !panel.innerHTML.trim()) return;
    closeOtherPredictiveSearch(form);
    closeHeaderDropdownsForSearch();
    if (form.matches('[data-compact-search-panel]')) panel.hidden = false;
    else if (panel.hidden || panel.classList.contains('is-closing')) showHeaderDrawer(panel);
    form.classList.add('is-predictive-open');
    form.setAttribute('aria-expanded', 'true');
    input.setAttribute('aria-expanded', 'true');
  }

  function setPredictiveActiveResult(form, nextIndex, { scroll = true } = {}) {
    const input = q('[data-predictive-search-input]', form);
    const panel = q('[data-predictive-search-panel]', form);
    const items = panel ? qa('[data-predictive-result]', panel) : [];
    if (!input || !items.length) return;
    const current = items.findIndex((item) => item.getAttribute('aria-selected') === 'true');
    let index = Number.isFinite(nextIndex) ? nextIndex : current;
    index = ((index % items.length) + items.length) % items.length;
    items.forEach((item, itemIndex) => item.setAttribute('aria-selected', itemIndex === index ? 'true' : 'false'));
    input.setAttribute('aria-activedescendant', items[index].id);
    if (scroll) items[index].scrollIntoView({ block: 'nearest' });
  }

  function predictiveLoadingMarkup() {
    return `<div class="ccs-results" data-predictive-search-results>
      <div class="ccs-body"><div class="ccs-card" aria-live="polite" aria-busy="true">
        ${Array.from({ length: 3 }, () => `<div class="ccs-row is-skeleton" aria-hidden="true"><span class="ccs-thumb"></span><span class="ccs-copy"><i></i><i></i><i></i></span></div>`).join('')}
      </div></div>
    </div>`;
  }

  async function requestPredictiveSearch(form, query) {
    const input = q('[data-predictive-search-input]', form);
    const panel = q('[data-predictive-search-panel]', form);
    if (!input || !panel) return;

    const normalized = query.trim().replace(/\s+/g, ' ');
    if (normalized.length < 2) {
      closePredictiveSearch(form);
      window.setTimeout(() => { if (panel.hidden) panel.innerHTML = ''; }, HEADER_DRAWER_MOTION_MS + 220);
      return;
    }

    const cacheKey = normalized.toLocaleLowerCase();
    const cached = predictiveSearchCache.get(cacheKey);
    if (cached) {
      panel.innerHTML = cached;
      filterAndRankPredictiveResults(panel, normalized);
      preparePredictiveResults(form, panel);
      openPredictiveSearch(form);
      return;
    }

    form._ccPredictiveController?.abort();
    const controller = new AbortController();
    form._ccPredictiveController = controller;
    form.classList.add('is-predictive-loading');
    panel.innerHTML = predictiveLoadingMarkup();
    openPredictiveSearch(form);

    const rootUrl = window.CANADA_COLOGNE?.rootUrl || '/';
    const endpoint = window.CANADA_COLOGNE?.predictiveSearchUrl || `${rootUrl}search/suggest`;
    const params = new URLSearchParams({
      q: normalized,
      'resources[type]': 'product',
      'resources[limit]': '10', /* 6 show at once; the rest scroll */
      'resources[options][fields]': 'title,vendor,variants.title',
      'resources[options][unavailable_products]': 'last',
      section_id: 'predictive-search',
    });

    try {
      const response = await fetch(`${endpoint}?${params.toString()}`, {
        signal: controller.signal,
        headers: { Accept: 'text/html' },
      });
      if (!response.ok) throw new Error('Predictive search unavailable');
      const responseText = await response.text();
      if (controller.signal.aborted || input.value.trim().replace(/\s+/g, ' ') !== normalized) return;

      const responseDocument = new DOMParser().parseFromString(responseText, 'text/html');
      const results = responseDocument.querySelector('[data-predictive-search-results]');
      if (!results) throw new Error('Predictive search returned no results markup');
      const html = results.outerHTML;
      predictiveSearchCache.set(cacheKey, html);
      panel.innerHTML = html;
      filterAndRankPredictiveResults(panel, normalized);
      preparePredictiveResults(form, panel);
      openPredictiveSearch(form);
    } catch (error) {
      if (error.name === 'AbortError') return;
      console.warn(error);
      panel.innerHTML = '<div class="ccs-results" role="status"><div class="ccs-body"><div class="ccs-card"><div class="ccs-empty"><strong>Search is temporarily unavailable</strong><span>Press Enter to view the full search page.</span></div></div></div></div>';
      openPredictiveSearch(form);
    } finally {
      if (form._ccPredictiveController === controller) form._ccPredictiveController = null;
      form.classList.remove('is-predictive-loading');
    }
  }

  function initPredictiveSearch(root = document) {
    qa('[data-predictive-search-form]', root).forEach((form) => {
      if (form.dataset.predictiveSearchReady === 'true') return;
      const input = q('[data-predictive-search-input]', form);
      const panel = q('[data-predictive-search-panel]', form);
      if (!input || !panel) return;
      form.dataset.predictiveSearchReady = 'true';
      predictiveSearchForms.add(form);

      input.addEventListener('input', () => {
        window.clearTimeout(form._ccPredictiveTimer);
        input.removeAttribute('aria-activedescendant');
        form._ccPredictiveTimer = window.setTimeout(() => requestPredictiveSearch(form, input.value), 140);
      });

      input.addEventListener('focus', () => {
        const normalized = input.value.trim().replace(/\s+/g, ' ');
        if (normalized.length < 2) return;
        if (panel.innerHTML.trim()) openPredictiveSearch(form);
        else requestPredictiveSearch(form, normalized);
      });

      input.addEventListener('keydown', (event) => {
        const items = qa('[data-predictive-result]', panel);
        if (event.key === 'Escape') {
          if (panel.hidden) return;
          event.preventDefault();
          closePredictiveSearch(form);
          return;
        }
        if (!items.length || !['ArrowDown', 'ArrowUp', 'Enter'].includes(event.key)) return;
        const current = items.findIndex((item) => item.getAttribute('aria-selected') === 'true');
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          if (panel.hidden) openPredictiveSearch(form);
          form.dataset.predictiveActiveSource = 'keyboard';
          setPredictiveActiveResult(form, current + 1);
        } else if (event.key === 'ArrowUp') {
          event.preventDefault();
          if (panel.hidden) openPredictiveSearch(form);
          form.dataset.predictiveActiveSource = 'keyboard';
          setPredictiveActiveResult(form, current < 0 ? items.length - 1 : current - 1);
        } else if (event.key === 'Enter' && current >= 0) {
          event.preventDefault();
          items[current].click();
        }
      });

      panel.addEventListener('pointermove', (event) => {
        const item = event.target.closest('[data-predictive-result]');
        if (!item || !panel.contains(item)) return;
        if (item.getAttribute('aria-selected') === 'true' && form.dataset.predictiveActiveSource === 'pointer') return;
        const items = qa('[data-predictive-result]', panel);
        form.dataset.predictiveActiveSource = 'pointer';
        setPredictiveActiveResult(form, items.indexOf(item), { scroll: false });
      }, { passive: true });

      panel.addEventListener('pointerleave', () => {
        if (form.dataset.predictiveActiveSource !== 'pointer') return;
        qa('[data-predictive-result]', panel).forEach((item) => item.setAttribute('aria-selected', 'false'));
        input.removeAttribute('aria-activedescendant');
        delete form.dataset.predictiveActiveSource;
      }, { passive: true });
    });
  }

  document.addEventListener('pointerdown', (event) => {
    predictiveSearchForms.forEach((form) => {
      if (!form.contains(event.target)) closePredictiveSearch(form);
    });
  }, { passive: true });

  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-contact-toggle], [data-wishlist-header], [data-cart-toggle]')) return;
    closeOtherPredictiveSearch();
  });

    /* keep the approved left-aligned brand visible at
     every browser zoom level. The CSS offset is preserved whenever it fits;
     only clipping is corrected. */
  function keepCanadaCologneLogoVisible(root = document) {
    const header = root.matches && root.matches('.source-v0514-header')
      ? root
      : q('.source-v0514-header', root);
    const lockup = header ? q('.cc98-lockup', header) : null;
    if (!lockup) return;

    /* no runtime margin/position correction. A runtime nudge can
       differ between templates or after layout settles; keep CSS geometry exact. */
    lockup.style.removeProperty('margin-left');
    lockup.style.removeProperty('left');
  }

  function initAll(root = document) {
    keepCanadaCologneLogoVisible(root);
    initPredictiveSearch(root);
    initHeroRotation(root);
    initAnimatedProductAccordions(root);
    initReveal(root);
    syncWishlist(root);
  }

  /* no resize-time header geometry correction. */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initRecentlyViewed();
      initAll(document);
    }, { once: true });
  } else {
    initRecentlyViewed();
    initAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:section:reorder', () => initAll(document));

  /* =========================================================
     Canada Cologne v2.15.668 — PDP FIVE-CARD LOCK + TRUE HOMEPAGE 8-UP
     ---------------------------------------------------------
     You May Also Like / Recently Viewed use one deterministic resting-position
     controller. Wide PDP shelves are locked to exactly five complete cards,
     so a resting shelf never exposes a clipped sixth card at either edge.

     Arrow navigation:
       - YMAL advances one complete visible page.
       - Recently Viewed keeps the approved one-card-at-a-time behavior.
     Wide desktop uses discrete arrows to guarantee a clean five-card viewport.
     Responsive touch scrolling remains available below the desktop breakpoint
     and settles to the nearest exact card start when the gesture ends.
   ========================================================= */
  const cc666ShelfState = new WeakMap();

  const cc666ShelfCards = (row) => Array.from(row?.querySelectorAll?.(':scope > [data-product-card]') || [])
    .filter((card) => !card.hidden && getComputedStyle(card).display !== 'none');

  const cc666ShelfGap = (row) => {
    const style = getComputedStyle(row);
    return Number.parseFloat(style.columnGap || style.gap || '0') || 0;
  };

  const cc666ShelfVisibleCount = (row) => {
    const cards = cc666ShelfCards(row);
    if (!cards.length) return 1;

    /* v2.15.668 desktop contract: exactly five complete cards. Keeping this
       explicit here prevents rounding differences from changing YMAL page size. */
    if (window.matchMedia?.('(min-width: 901px)')?.matches) {
      return Math.min(cards.length, 5);
    }

    const style = getComputedStyle(row);
    const padLeft = Number.parseFloat(style.paddingLeft || '0') || 0;
    const padRight = Number.parseFloat(style.paddingRight || '0') || 0;
    const usable = Math.max(1, row.clientWidth - padLeft - padRight);
    const cardWidth = cards[0].getBoundingClientRect().width || 1;
    const gap = cc666ShelfGap(row);
    return Math.max(1, Math.min(cards.length, Math.round((usable + gap) / (cardWidth + gap))));
  };

  const cc666ShelfMaxStart = (row) => {
    const cards = cc666ShelfCards(row);
    return Math.max(0, cards.length - cc666ShelfVisibleCount(row));
  };

  const cc666ShelfOffsetForIndex = (row, requestedIndex) => {
    const cards = cc666ShelfCards(row);
    if (!cards.length) return { index:0, left:0 };
    const index = Math.max(0, Math.min(cc666ShelfMaxStart(row), requestedIndex));
    const firstLeft = cards[0].offsetLeft || 0;
    const targetLeft = cards[index]?.offsetLeft ?? firstLeft;
    const maxLeft = Math.max(0, row.scrollWidth - row.clientWidth);
    return { index, left:Math.max(0, Math.min(maxLeft, targetLeft - firstLeft)) };
  };

  const cc666ShelfNearestIndex = (row) => {
    const cards = cc666ShelfCards(row);
    if (!cards.length) return 0;
    const firstLeft = cards[0].offsetLeft || 0;
    const current = row.scrollLeft;
    let bestIndex = 0;
    let bestDistance = Infinity;
    const maxStart = cc666ShelfMaxStart(row);
    for (let i = 0; i <= maxStart; i += 1) {
      const left = Math.max(0, (cards[i]?.offsetLeft || firstLeft) - firstLeft);
      const distance = Math.abs(left - current);
      if (distance < bestDistance) {
        bestDistance = distance;
        bestIndex = i;
      }
    }
    return bestIndex;
  };

  const cc666UpdateShelfControls = (wrap, row, index) => {
    const prev = wrap?.querySelector('[data-shelf-prev]');
    const next = wrap?.querySelector('[data-shelf-next]');
    const maxStart = cc666ShelfMaxStart(row);
    if (prev) prev.disabled = index <= 0;
    if (next) next.disabled = index >= maxStart;
    wrap.dataset.cc666ShelfIndex = String(index);
  };

  const cc666ClearShelfVisualState = (wrap, row) => {
    if (!wrap || !row) return;
    wrap.classList.remove(
      'cc666-shelf-transitioning',
      'cc666-shelf-next',
      'cc666-shelf-prev',
      'cc666-shelf-user-scrolling'
    );
    row.classList.remove('cc666-shelf-fade-out');
  };

  const cc666ShelfGoTo = (wrap, requestedIndex, { animate = true, direction = 0 } = {}) => {
    const row = wrap?.querySelector('[data-shelf-row]');
    if (!row) return;
    const state = cc666ShelfState.get(row) || {};
    cc666ShelfState.set(row, state);

    if (state.transitionTimer) window.clearTimeout(state.transitionTimer);
    if (state.cleanupTimer) window.clearTimeout(state.cleanupTimer);
    if (state.scrollTimer) window.clearTimeout(state.scrollTimer);

    const target = cc666ShelfOffsetForIndex(row, requestedIndex);
    const currentIndex = Number.parseInt(wrap.dataset.cc666ShelfIndex || '', 10);
    const resolvedCurrent = Number.isFinite(currentIndex) ? currentIndex : cc666ShelfNearestIndex(row);
    const resolvedDirection = direction || Math.sign(target.index - resolvedCurrent) || 1;

    cc666UpdateShelfControls(wrap, row, target.index);

    const applyPosition = () => {
      state.programmatic = true;
      row.scrollLeft = target.left;
      state.lastLeft = target.left;
      requestAnimationFrame(() => {
        state.programmatic = false;
        delete wrap.dataset.cc608ShelfArrowLocked;
        syncShelfArrowCenters(wrap.closest('.source-product-shelf') || document, true);
      });
    };

    if (!animate || !motionEnabled() || Math.abs(row.scrollLeft - target.left) < 0.75) {
      cc666ClearShelfVisualState(wrap, row);
      applyPosition();
      return;
    }

    cc666ClearShelfVisualState(wrap, row);
    wrap.classList.add('cc666-shelf-transitioning', resolvedDirection > 0 ? 'cc666-shelf-next' : 'cc666-shelf-prev');
    row.classList.add('cc666-shelf-fade-out');

    /* Short exit, exact hidden snap, long organic entrance. No card ever visibly
       travels through an invalid half-card resting position. */
    state.transitionTimer = window.setTimeout(() => {
      applyPosition();
      requestAnimationFrame(() => requestAnimationFrame(() => {
        row.classList.remove('cc666-shelf-fade-out');
      }));
      state.cleanupTimer = window.setTimeout(() => {
        cc666ClearShelfVisualState(wrap, row);
        delete wrap.dataset.cc608ShelfArrowLocked;
        syncShelfArrowCenters(wrap.closest('.source-product-shelf') || document, true);
      }, 560);
    }, 240);
  };

  const cc666SettleUserShelfScroll = (wrap, row) => {
    const state = cc666ShelfState.get(row) || {};
    if (state.programmatic) return;
    const targetIndex = cc666ShelfNearestIndex(row);
    /* Phones: the finger (plus CSS scroll-snap) owns the position. Just keep the
       arrows' enabled state in sync - no fade, no programmatic re-snap. */
    if (window.matchMedia?.('(max-width: 640px)').matches) {
      cc666ClearShelfVisualState(wrap, row);
      cc666UpdateShelfControls(wrap, row, targetIndex);
      return;
    }
    const currentStored = Number.parseInt(wrap.dataset.cc666ShelfIndex || '', 10);
    const direction = Number.isFinite(currentStored) ? Math.sign(targetIndex - currentStored) : Math.sign(state.lastDirection || 1);
    cc666ShelfGoTo(wrap, targetIndex, { animate:true, direction:direction || state.lastDirection || 1 });
  };

  const cc666BindShelf = (wrap) => {
    if (!wrap || wrap.dataset.cc666ShelfBound === 'true') return;
    const row = wrap.querySelector('[data-shelf-row]');
    if (!row) return;
    wrap.dataset.cc666ShelfBound = 'true';

    const state = { lastLeft:row.scrollLeft, lastDirection:1, programmatic:false, scrollTimer:0 };
    cc666ShelfState.set(row, state);

    const settle = () => {
      if (state.programmatic) return;
      window.clearTimeout(state.scrollTimer);
      state.scrollTimer = window.setTimeout(() => cc666SettleUserShelfScroll(wrap, row), 145);
    };

    row.addEventListener('scroll', () => {
      if (state.programmatic) return;
      const current = row.scrollLeft;
      if (Math.abs(current - state.lastLeft) > 0.5 && window.matchMedia?.('(max-width: 640px)').matches) {
        state.lastDirection = current > state.lastLeft ? 1 : -1;
        state.lastLeft = current;
      } else if (Math.abs(current - state.lastLeft) > 0.5) {
        state.lastDirection = current > state.lastLeft ? 1 : -1;
        wrap.classList.remove('cc666-shelf-next', 'cc666-shelf-prev');
        wrap.classList.add('cc666-shelf-user-scrolling', state.lastDirection > 0 ? 'cc666-shelf-next' : 'cc666-shelf-prev');
        state.lastLeft = current;
      }
      settle();
    }, { passive:true });

    if ('onscrollend' in window) {
      row.addEventListener('scrollend', () => {
        if (!state.programmatic) cc666SettleUserShelfScroll(wrap, row);
      }, { passive:true });
    }

    const initial = cc666ShelfNearestIndex(row);
    cc666UpdateShelfControls(wrap, row, initial);
  };

  const cc666InitShelves = (root = document) => {
    root.querySelectorAll?.('.source-shelf-wrap').forEach(cc666BindShelf);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => cc666InitShelves(document), { once:true });
  } else {
    cc666InitShelves(document);
  }
  document.addEventListener('shopify:section:load', (event) => cc666InitShelves(event.target));
  document.addEventListener('cc:listings-updated', (event) => {
    const shelf = event.target?.closest?.('.source-product-shelf') || event.target;
    cc666InitShelves(shelf || document);
    const wrap = shelf?.querySelector?.('.source-shelf-wrap');
    if (wrap) {
      const row = wrap.querySelector('[data-shelf-row]');
      if (row) {
        const index = cc666ShelfNearestIndex(row);
        cc666ShelfGoTo(wrap, index, { animate:false });
      }
    }
  });

  /* Card widths change at responsive breakpoints. Re-snap after resize so the
     first visible card remains exactly aligned to the new five/three/mobile grid. */
  let cc666ResizeTimer = 0;
  window.addEventListener('resize', () => {
    window.clearTimeout(cc666ResizeTimer);
    cc666ResizeTimer = window.setTimeout(() => {
      document.querySelectorAll('.source-product-shelf .source-shelf-wrap').forEach((wrap) => {
        const row = wrap.querySelector('[data-shelf-row]');
        if (!row) return;
        const index = cc666ShelfNearestIndex(row);
        cc666ShelfGoTo(wrap, index, { animate:false });
      });
    }, 140);
  }, { passive:true });

  /* Shared PDP shelf arrows use deterministic exact-card/page positions. */
  document.addEventListener('click', (event) => {
    const prev = event.target.closest('[data-shelf-prev]');
    const next = event.target.closest('[data-shelf-next]');
    const control = prev || next;
    if (!control) return;
    const wrap = control.closest('.source-shelf-wrap');
    const row = wrap?.querySelector('[data-shelf-row]');
    if (!wrap || !row) return;
    event.preventDefault();
    event.stopPropagation();

    const current = Number.parseInt(wrap.dataset.cc666ShelfIndex || '', 10);
    const index = Number.isFinite(current) ? current : cc666ShelfNearestIndex(row);
    /* v77: You May Also Like and Recently Viewed both move one full page per
       arrow, the same as New Arrivals / Best Sellers on the homepage. */
    const step = cc666ShelfVisibleCount(row);
    cc666ShelfGoTo(wrap, index + (next ? step : -step), { animate:true, direction:next ? 1 : -1 });
  });

  /* deterministic endpoint-outline geometry for PDP shelves.
     The hover outline is .full-bottle-strip-image-stage. Both arrows use the
     exact same side gap and exact final-hover outline center. */
  const cc614ShelfCurrentTranslateY = (element) => {
    if (!element) return 0;
    const transform = getComputedStyle(element).transform;
    if (!transform || transform === 'none') return 0;
    try {
      const matrix = new DOMMatrixReadOnly(transform);
      return Number.isFinite(matrix.m42) ? matrix.m42 : 0;
    } catch (_) {
      const match = transform.match(/^matrix\([^,]+,[^,]+,[^,]+,[^,]+,[^,]+,\s*([^\)]+)\)$/);
      return match ? (Number.parseFloat(match[1]) || 0) : 0;
    }
  };

  const cc614ShelfFinalStageCenterY = (stage) => {
    if (!stage) return NaN;
    const rect = stage.getBoundingClientRect();
    if (!(rect.height > 0)) return NaN;
    const shell = stage.closest('.full-bottle-strip-image-shell');
    const finalLift = Number.parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--cc290-card-hover-lift')) || -5;
    const currentLift = cc614ShelfCurrentTranslateY(shell);
    return rect.top + rect.height / 2 + (finalLift - currentLift);
  };

  const cc614ShelfEndpoints = (row) => {
    const cards = Array.from(row.querySelectorAll(':scope > [data-product-card]')).filter((card) => !card.hidden);
    if (!cards.length) return null;
    const rowRect = row.getBoundingClientRect();
    const visible = cards.filter((card) => {
      const r = card.getBoundingClientRect();
      return r.right > rowRect.left + 2 && r.left < rowRect.right - 2;
    });
    return { first: visible[0] || cards[0], last: visible[visible.length - 1] || cards[cards.length - 1] };
  };

  /* one native-anchor geometry contract for both PDP shelves.
     X is anchored to the stationary scroll row, while Y is anchored to the
     endpoint product VISUAL and offset to the final -5px hover position.
     This mirrors the proven homepage v2.15.625 architecture and removes the
     last separate pixel-measurement positioning path for YMAL / Recently Viewed. */
  let cc629ShelfAnchorSerial = 0;
  const cc629ShelfAnchorSupported = Boolean(
    window.CSS?.supports?.('anchor-name: --cc629-test') &&
    window.CSS?.supports?.('top: anchor(--cc629-test center)')
  );
  /* v2.15.673 — every shelf leaves the same gap between an arrow and the
     listing beside it. New Arrivals / Best Sellers already landed on this
     distance from their wrapper edge; Flash Sale and the product-page shelves
     now measure to the same number instead of to their own container. */
  const cc673ShelfArrowGap = () => Number.parseFloat(
    getComputedStyle(document.documentElement).getPropertyValue('--cc673-shelf-arrow-gap')
  ) || 21;

  /* =========================================================
     Canada Cologne v2.16.24 — cc700 shared shelf-arrow contract
     ---------------------------------------------------------
     "You May Also Like" and "Recently Viewed" now use the same arrow
     placement the homepage shelves (New Arrivals / Best Sellers) use.

     On phones and small tablets (<= 759px) both product-page shelves are the
     same full-bleed rail the homepage renders, so their arrows sit INSIDE the
     shelf wrapper at the homepage edge inset. Previously they were parked
     outside the scroll row, which pushed about half of each circle past the
     side of the screen.

     Above 759px the proven outside-the-row placement is kept, with a final
     safety clamp so an arrow can never be cut off by the viewport edge.
     ========================================================= */
  const cc700RailLayout = () => (window.matchMedia
    ? window.matchMedia('(max-width: 759px)').matches
    : window.innerWidth <= 759);
  /* Identical to the homepage's cc670HomeArrowEdge(). */
  const cc700ArrowEdge = () => (window.innerWidth <= 640 ? 10 : 12);
  const cc700ArrowSize = (button) => {
    const measured = button?.getBoundingClientRect?.().width;
    if (measured > 0) return measured;
    return Number.parseFloat(
      getComputedStyle(document.documentElement).getPropertyValue('--cc629-carousel-arrow-size')
    ) || 34;
  };
  /* Homepage geometry: the previous arrow sits one fixed inset from the
     leading edge of the wrapper, the next arrow the same inset from its
     trailing edge. The rail's own safe padding keeps the cards clear. */
  const cc700PlaceRailArrows = (prev, next, size) => {
    const edge = cc700ArrowEdge();
    prev.style.setProperty('left', `${edge}px`, 'important');
    prev.style.setProperty('right', 'auto', 'important');
    next.style.setProperty('left', `calc(100% - ${size}px - ${edge}px)`, 'important');
    next.style.setProperty('right', 'auto', 'important');
  };
  /* Desktop / large tablet safety net. Measured after the browser has applied
     the placement above, so it also catches anchor()-resolved coordinates. */
  const cc700ClampArrows = (wrap, prev, next, size) => {
    if (!wrap || !prev || !next) return;
    cancelAnimationFrame(wrap._cc700ClampRaf || 0);
    /* v78: clamp in the same frame the arrows are placed. Waiting one frame let
       the unclamped position paint first, so the arrows flicked sideways and back
       on every page change. */
    (() => {
      wrap._cc700ClampRaf = 0;
      const edge = cc700ArrowEdge();
      const limit = document.documentElement.clientWidth;
      const wrapRect = wrap.getBoundingClientRect();
      const prevRect = prev.getBoundingClientRect();
      const nextRect = next.getBoundingClientRect();
      if (prevRect.width > 0 && prevRect.left < edge - 0.5) {
        prev.style.setProperty('left', `${edge - wrapRect.left}px`, 'important');
        prev.style.setProperty('right', 'auto', 'important');
      }
      if (nextRect.width > 0 && nextRect.right > limit - edge + 0.5) {
        next.style.setProperty('left', `${limit - edge - size - wrapRect.left}px`, 'important');
        next.style.setProperty('right', 'auto', 'important');
      }
    })();
  };

  function syncShelfArrowCenters(root = document, force = false) {
    root.querySelectorAll?.('.source-shelf-wrap').forEach((wrap) => {
      if (!force && wrap.dataset.cc613ShelfArrowReady !== 'true') return;
      if (!force && wrap.dataset.cc608ShelfArrowLocked === 'true') return;
      const row = wrap.querySelector('[data-shelf-row]');
      const prev = wrap.querySelector('[data-shelf-prev]');
      const next = wrap.querySelector('[data-shelf-next]');
      if (!row || !prev || !next) return;

      const endpoints = cc614ShelfEndpoints(row);
      if (!endpoints) return;
      const firstVisual = endpoints.first?.querySelector('.full-bottle-strip-visual');
      const lastVisual = endpoints.last?.querySelector('.full-bottle-strip-visual');
      const firstStage = endpoints.first?.querySelector('.full-bottle-strip-image-stage');
      const lastStage = endpoints.last?.querySelector('.full-bottle-strip-image-stage');
      if (!firstVisual || !lastVisual || !firstStage || !lastStage) return;

      if (cc629ShelfAnchorSupported) {
        if (!wrap._cc629AnchorId) wrap._cc629AnchorId = ++cc629ShelfAnchorSerial;
        const id = wrap._cc629AnchorId;
        const rowAnchor = `--cc629-row-${id}`;
        const prevAnchor = `--cc629-prev-y-${id}`;
        const nextAnchor = `--cc629-next-y-${id}`;

        if (wrap._cc629PrevVisual && wrap._cc629PrevVisual !== firstVisual) {
          if (wrap._cc629PrevVisual.style.getPropertyValue('anchor-name').trim() === prevAnchor) {
            wrap._cc629PrevVisual.style.removeProperty('anchor-name');
          }
        }
        if (wrap._cc629NextVisual && wrap._cc629NextVisual !== lastVisual) {
          if (wrap._cc629NextVisual.style.getPropertyValue('anchor-name').trim() === nextAnchor) {
            wrap._cc629NextVisual.style.removeProperty('anchor-name');
          }
        }
        wrap._cc629PrevVisual = firstVisual;
        wrap._cc629NextVisual = lastVisual;

        row.style.setProperty('anchor-name', rowAnchor);
        firstVisual.style.setProperty('anchor-name', prevAnchor);
        lastVisual.style.setProperty('anchor-name', nextAnchor);

        /* no shadow proxies. Endpoint cards render their own
           normal hover shadow inside the shared real safety gutter. */

        const finalLift = Number.parseFloat(
          getComputedStyle(document.documentElement).getPropertyValue('--cc290-card-hover-lift')
        ) || -5;
        /* The row carries its own padding, so the arrow only has to make up the
           difference between that padding and the shared gap. */
        const cc673RowStyle = getComputedStyle(row);
        const cc673PadLeft = Number.parseFloat(cc673RowStyle.paddingLeft) || 0;
        const cc673PadRight = Number.parseFloat(cc673RowStyle.paddingRight) || 0;
        const outsideGap = Math.max(0, cc673ShelfArrowGap() - cc673PadLeft);
        const outsideGapRight = Math.max(0, cc673ShelfArrowGap() - cc673PadRight);

        [prev, next].forEach((button) => {
          button.style.setProperty('position', 'absolute', 'important');
          button.style.setProperty('display', 'grid', 'important');
          button.style.setProperty('place-items', 'center', 'important');
          button.style.setProperty('bottom', 'auto', 'important');
          button.style.setProperty('right', 'auto', 'important');
          button.style.setProperty('transform', 'translate3d(0,-50%,0)', 'important');
          button.style.setProperty('transition-property', 'box-shadow, background-color, border-color, color, opacity', 'important');
        });

        const arrowSize = cc700ArrowSize(prev);
        /* v2.16.24 — cc700: phone / small-tablet rails place their arrows
           inside the wrapper, exactly like the homepage shelves. */
        if (cc700RailLayout()) {
          cc700PlaceRailArrows(prev, next, arrowSize);
        } else {
          prev.style.setProperty('left', `calc(anchor(${rowAnchor} left) - ${outsideGap}px - ${arrowSize}px)`, 'important');
          next.style.setProperty('left', `calc(anchor(${rowAnchor} right) + ${outsideGapRight}px)`, 'important');
        }
        prev.style.setProperty('top', `calc(anchor(${prevAnchor} center) + ${finalLift}px)`, 'important');
        next.style.setProperty('top', `calc(anchor(${nextAnchor} center) + ${finalLift}px)`, 'important');
        /* Phones / small tablets: the one fixed arrow line (cc703). */
        window.CC703RailArrowTop?.apply(wrap);
        cc700ClampArrows(wrap, prev, next, arrowSize);

        prev.style.removeProperty('opacity');
        prev.style.removeProperty('pointer-events');
        next.style.removeProperty('opacity');
        next.style.removeProperty('pointer-events');
        wrap.dataset.cc608ShelfArrowLocked = 'true';
        wrap.dataset.cc629ShelfAnchored = 'true';
        return;
      }

      /* Browser fallback: preserve the proven v2.15.614 pixel geometry. */
      const wrapRect = wrap.getBoundingClientRect();
      const firstRect = firstStage.getBoundingClientRect();
      const lastRect = lastStage.getBoundingClientRect();
      if (!(firstRect.width > 0 && firstRect.height > 0 && lastRect.width > 0 && lastRect.height > 0)) return;
      const gap = cc673ShelfArrowGap();
      const prevWidth = cc700ArrowSize(prev);
      /* v2.16.24 — cc700: match the homepage's phone geometry here too. */
      const cc700Rail = cc700RailLayout();
      const cc700Edge = cc700ArrowEdge();
      const cc700Limit = document.documentElement.clientWidth;
      const prevTop = cc614ShelfFinalStageCenterY(firstStage) - wrapRect.top;
      const nextTop = cc614ShelfFinalStageCenterY(lastStage) - wrapRect.top;
      const prevLeft = cc700Rail
        ? cc700Edge
        : Math.max(
            cc700Edge - wrapRect.left,
            firstRect.left - wrapRect.left - prevWidth - gap
          );
      const nextLeft = cc700Rail
        ? (wrapRect.width - prevWidth - cc700Edge)
        : Math.min(
            cc700Limit - cc700Edge - prevWidth - wrapRect.left,
            lastRect.right - wrapRect.left + gap
          );
      if (Number.isFinite(prevTop)) prev.style.setProperty('top', `${prevTop}px`, 'important');
      if (Number.isFinite(nextTop)) next.style.setProperty('top', `${nextTop}px`, 'important');
      window.CC703RailArrowTop?.apply(wrap);
      if (Number.isFinite(prevLeft)) {
        prev.style.setProperty('left', `${prevLeft}px`, 'important');
        prev.style.setProperty('right', 'auto', 'important');
      }
      if (Number.isFinite(nextLeft)) {
        next.style.setProperty('left', `${nextLeft}px`, 'important');
        next.style.setProperty('right', 'auto', 'important');
      }
      wrap.dataset.cc608ShelfArrowLocked = 'true';
    });
  }

  /* first-render stability helpers. Never expose arrow geometry
     until endpoint images/fonts/layout have genuinely settled. */
  const cc615NextFrame = () => new Promise((resolve) => requestAnimationFrame(resolve));

  const cc615WaitForFonts = async () => {
    try { if (document.fonts?.ready) await document.fonts.ready; } catch (_) {}
  };

  const cc615DecodeImages = async (elements) => {
    const images = elements.flatMap((element) => Array.from(element?.querySelectorAll?.('img') || []));
    await Promise.all(images.map(async (img) => {
      try {
        if (!img.complete) {
          await new Promise((resolve) => {
            const done = () => resolve();
            img.addEventListener('load', done, { once:true });
            img.addEventListener('error', done, { once:true });
            window.setTimeout(done, 1500);
          });
        }
        if (typeof img.decode === 'function') await Promise.race([img.decode().catch(() => {}), new Promise((r) => setTimeout(r, 500))]);
      } catch (_) {}
    }));
  };

  const cc615RectSignature = (elements) => elements.map((el) => {
    const r = el?.getBoundingClientRect?.();
    if (!r) return null;
    return [r.left, r.top, r.width, r.height];
  });

  const cc615RectsStable = (a, b, tolerance = 0.12) => {
    if (!a || !b || a.length !== b.length) return false;
    for (let i = 0; i < a.length; i += 1) {
      if (!a[i] || !b[i]) return false;
      for (let j = 0; j < 4; j += 1) {
        if (!Number.isFinite(a[i][j]) || !Number.isFinite(b[i][j]) || Math.abs(a[i][j] - b[i][j]) > tolerance) return false;
      }
    }
    return true;
  };

  const cc615WaitForStableElements = async (elements, tokenCheck) => {
    await cc615WaitForFonts();
    await cc615DecodeImages(elements);
    let previous = null;
    let stableFrames = 0;
    for (let frame = 0; frame < 180; frame += 1) {
      await cc615NextFrame();
      if (tokenCheck && !tokenCheck()) return false;
      const current = cc615RectSignature(elements);
      const valid = current.every((v) => v && v[2] > 0 && v[3] > 0);
      if (valid && cc615RectsStable(previous, current)) stableFrames += 1;
      else stableFrames = 0;
      previous = current;
      if (stableFrames >= 6) return true;
    }
    return true;
  };

  const settleSourceShelfArrows = async (wrap) => {
    if (!wrap) return;
    const row = wrap.querySelector('[data-shelf-row]');
    const prev = wrap.querySelector('[data-shelf-prev]');
    const next = wrap.querySelector('[data-shelf-next]');
    if (!row || !prev || !next) return;

    const token = (wrap._cc613SettleToken || 0) + 1;
    wrap._cc613SettleToken = token;
    delete wrap.dataset.cc608ShelfArrowLocked;
    delete wrap.dataset.cc613ShelfArrowReady;

    /* Resolve the actual endpoint hover-outline boxes after dynamic RV/YMAL cards exist. */
    let endpoints = cc614ShelfEndpoints(row);
    if (!endpoints) return;
    let firstStage = endpoints.first?.querySelector('.full-bottle-strip-image-stage');
    let lastStage = endpoints.last?.querySelector('.full-bottle-strip-image-stage');
    if (!firstStage || !lastStage) return;

    const stillCurrent = () => wrap._cc613SettleToken === token;
    const stable = await cc615WaitForStableElements([firstStage, lastStage], stillCurrent);
    if (!stable || !stillCurrent()) return;

    /* Re-resolve after settling in case endpoint cards changed during dynamic render. */
    endpoints = cc614ShelfEndpoints(row);
    firstStage = endpoints?.first?.querySelector('.full-bottle-strip-image-stage');
    lastStage = endpoints?.last?.querySelector('.full-bottle-strip-image-stage');
    if (!firstStage || !lastStage || !stillCurrent()) return;

    delete wrap.dataset.cc608ShelfArrowLocked;
    syncShelfArrowCenters(wrap.closest('.source-product-shelf') || document, true);
    if (!stillCurrent()) return;
    wrap.dataset.cc613ShelfArrowReady = 'true';
  };

  const initSourceShelfArrowSettling = (root = document) => {
    root.querySelectorAll?.('.source-shelf-wrap').forEach((wrap) => settleSourceShelfArrows(wrap));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initSourceShelfArrowSettling(document), { once:true });
  } else {
    initSourceShelfArrowSettling(document);
  }
  window.addEventListener('load', () => initSourceShelfArrowSettling(document), { once:true });
  let cc613ResizeTimer = 0;
  window.addEventListener('resize', () => {
    window.clearTimeout(cc613ResizeTimer);
    cc613ResizeTimer = window.setTimeout(() => initSourceShelfArrowSettling(document), 140);
  }, { passive:true });
  document.addEventListener('shopify:section:load', (event) => initSourceShelfArrowSettling(event.target));
  document.addEventListener('cc:listings-updated', (event) => {
    const scope = event.target?.closest?.('.source-product-shelf') || event.target || document;
    initSourceShelfArrowSettling(scope);
  });

  /* arrows are static at the final-hover preview centre.
     No hover-follow RAF tracking is intentionally bound here. */

  const galleryThumbs = qa('[data-gallery-thumb]');
  const galleryWarmImages = [];
  const galleryFadeStates = new WeakMap();

  function getGalleryFadeState(image) {
    let state = galleryFadeStates.get(image);
    if (!state) {
      const current = normalizedImageUrl(image?.currentSrc || image?.src || '');
      state = {
        phase: 'idle',
        current,
        target: current,
        pendingSrc: '',
        pending: '',
        preloadId: 0,
        timer: 0
      };
      galleryFadeStates.set(image, state);
    }
    return state;
  }

  function getGalleryCrossfadeLayer(image) {
    const host = image?.closest('[data-gallery-main]');
    if (!host || !image) return null;
    let layer = q('.cc424-gallery-crossfade-image', host);
    if (!layer) {
      layer = image.cloneNode(false);
      layer.removeAttribute('id');
      layer.removeAttribute('srcset');
      layer.removeAttribute('sizes');
      layer.className = 'simple-product-main-image cc133-main-image cc424-gallery-crossfade-image';
      layer.setAttribute('aria-hidden', 'true');
      layer.decoding = 'async';
      layer.loading = 'eager';
      host.insertBefore(layer, image.nextSibling);
    }
    return layer;
  }

  function setGalleryLayersIdle(image, layer, src) {
    image.classList.add('cc424-no-transition');
    layer.classList.add('cc424-no-transition');
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.src = src;
    image.style.opacity = '1';
    layer.style.opacity = '0';
    void image.offsetWidth;
    image.classList.remove('cc424-no-transition');
    layer.classList.remove('cc424-no-transition');
  }

  function beginGalleryCrossfade(image, nextSrc) {
    const state = getGalleryFadeState(image);
    const next = normalizedImageUrl(nextSrc);
    if (!next) return;

    const layer = getGalleryCrossfadeLayer(image);
    if (!layer) {
      state.phase = 'idle';
      state.current = next;
      state.target = next;
      state.pending = '';
      state.pendingSrc = '';
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = nextSrc;
      return;
    }

    /* rapid-click stability.
       - During preload: only the newest request survives.
       - During the 650ms fade: never interrupt the active opacity transition;
         remember only the newest requested destination and run it afterwards.
       This keeps the visual fade exactly the same while preventing overlapping
       transitions, duplicate image loads, stale callbacks, and half-faded states. */
    if (state.phase === 'fading') {
      if (next === state.target) return;
      state.pending = next;
      state.pendingSrc = nextSrc;
      return;
    }

    if (state.phase === 'preloading') {
      if (next === state.target) return;
      state.preloadId += 1; // invalidate the previous preload callback
    } else if (next === state.current) {
      state.target = state.current;
      state.pending = '';
      state.pendingSrc = '';
      return;
    }

    state.phase = 'preloading';
    state.target = next;
    state.pending = '';
    state.pendingSrc = '';
    const preloadId = ++state.preloadId;

    const preload = new Image();
    preload.decoding = 'async';
    preload.src = nextSrc;

    const commit = () => {
      if (state.preloadId !== preloadId || state.phase !== 'preloading' || state.target !== next) return;
      /* Performance: decode the next photo off the main thread before the fade
         starts, so the swap never stalls a frame. The fade itself is unchanged. */
      if (!preload._ccDecoded && typeof preload.decode === 'function') {
        preload._ccDecoded = true;
        preload.decode().catch(() => {}).then(commit);
        return;
      }

      layer.removeAttribute('srcset');
      layer.removeAttribute('sizes');
      layer.src = nextSrc;
      layer.alt = image.alt || '';

      image.classList.add('cc424-no-transition');
      layer.classList.add('cc424-no-transition');
      image.style.opacity = '1';
      layer.style.opacity = '0';
      void layer.offsetWidth;
      image.classList.remove('cc424-no-transition');
      layer.classList.remove('cc424-no-transition');

      state.phase = 'fading';
      window.requestAnimationFrame(() => {
        if (state.phase !== 'fading' || state.target !== next) return;
        image.style.opacity = '0';
        layer.style.opacity = '1';
      });

      window.clearTimeout(state.timer);
      state.timer = window.setTimeout(() => {
        if (state.phase !== 'fading' || state.target !== next) return;

        setGalleryLayersIdle(image, layer, nextSrc);
        state.current = next;
        state.phase = 'idle';
        state.timer = 0;

        const queuedSrc = state.pendingSrc;
        const queued = state.pending;
        state.pendingSrc = '';
        state.pending = '';
        state.target = next;

        /* Coalesce a burst of clicks to the newest destination only. */
        if (queuedSrc && queued && queued !== state.current) {
          window.requestAnimationFrame(() => beginGalleryCrossfade(image, queuedSrc));
        }
      }, 650);
    };

    if (preload.complete && preload.naturalWidth > 0) commit();
    else {
      preload.addEventListener('load', commit, { once: true });
      preload.addEventListener('error', () => {
        if (state.preloadId !== preloadId) return;
        state.phase = 'idle';
        state.target = state.current;
      }, { once: true });
    }
  }

  function fadeGalleryImage(image, nextSrc) {
    if (!image || !nextSrc) return;
    beginGalleryCrossfade(image, nextSrc);
  }
  function selectGalleryThumb(button, { fade = true } = {}) {
    const pageRoot = button?.closest('.simple-product-page') || document;
    const image = q('.simple-product-main-image', pageRoot);
    if (!image || !button?.dataset.image) return;
    if (fade) fadeGalleryImage(image, button.dataset.image);
    else image.src = button.dataset.image;
    qa('[data-gallery-thumb]', pageRoot).forEach((thumb) => thumb.classList.toggle('is-active', thumb === button));
    const lightboxImage = q('[data-lightbox-image]');
    if (lightboxImage) lightboxImage.src = button.dataset.image;
  }
  galleryThumbs.forEach((button) => button.addEventListener('click', () => selectGalleryThumb(button)));
  /* Performance: once the page has loaded, fetch and decode every gallery photo
     in the background, so switching photos starts the fade straight away instead
     of waiting for a download. Skipped when the visitor has Data Saver on. */
  (() => {
    const urls = [...new Set(galleryThumbs.map((button) => button.dataset.image).filter(Boolean))];
    if (urls.length < 2 || navigator.connection?.saveData) return;
    const warm = () => urls.forEach((url) => {
      const img = new Image();
      img.decoding = 'async';
      img.src = url;
      img.decode?.().catch(() => {});
      galleryWarmImages.push(img);
    });
    const later = () => (window.requestIdleCallback ? window.requestIdleCallback(warm, { timeout: 2500 }) : window.setTimeout(warm, 600));
    if (document.readyState === 'complete') later();
    else window.addEventListener('load', later, { once: true });
  })();
  q('[data-gallery-prev]')?.addEventListener('click', () => {
    if (!galleryThumbs.length) return;
    const index = Math.max(0, galleryThumbs.findIndex((item) => item.classList.contains('is-active')));
    selectGalleryThumb(galleryThumbs[(index - 1 + galleryThumbs.length) % galleryThumbs.length]);
  });
  q('[data-gallery-next]')?.addEventListener('click', () => {
    if (!galleryThumbs.length) return;
    const index = Math.max(0, galleryThumbs.findIndex((item) => item.classList.contains('is-active')));
    selectGalleryThumb(galleryThumbs[(index + 1) % galleryThumbs.length]);
  });
  const lightbox = q('[data-product-lightbox]');
  const productGalleryMain = q('[data-gallery-main]');
  const productGalleryImage = q('.simple-product-main-image', productGalleryMain || document);

  /* portal the gallery directly under <body>.
     A fixed element can become trapped by transformed/contained Shopify section
     ancestors; moving the lightbox to body makes it genuinely viewport-fixed. */
  if (lightbox && lightbox.parentElement !== document.body) {
    document.body.appendChild(lightbox);
  }

  /* slower, damped cursor-follow magnification.
     Pointer coordinates are eased toward the target rather than snapping the
     transform origin on every mousemove, giving the product zoom a calmer,
     premium retail feel. */
  if (productGalleryMain && productGalleryImage) {
    const canHoverZoom = window.matchMedia?.('(hover: hover) and (pointer: fine)');
    let zoomTargetX = 50;
    let zoomTargetY = 50;
    let zoomCurrentX = 50;
    let zoomCurrentY = 50;
    let zoomFrame = 0;

    const paintHoverZoom = () => {
      zoomCurrentX += (zoomTargetX - zoomCurrentX) * 0.1;
      zoomCurrentY += (zoomTargetY - zoomCurrentY) * 0.1;
      productGalleryImage.style.setProperty('--cc179-zoom-x', `${zoomCurrentX.toFixed(2)}%`, 'important');
      productGalleryImage.style.setProperty('--cc179-zoom-y', `${zoomCurrentY.toFixed(2)}%`, 'important');
      if (Math.abs(zoomTargetX - zoomCurrentX) > 0.03 || Math.abs(zoomTargetY - zoomCurrentY) > 0.03) {
        zoomFrame = window.requestAnimationFrame(paintHoverZoom);
      } else {
        zoomFrame = 0;
      }
    };
    const scheduleHoverZoom = () => {
      if (!zoomFrame) zoomFrame = window.requestAnimationFrame(paintHoverZoom);
    };
    const setHoverTarget = (event) => {
      if (canHoverZoom && !canHoverZoom.matches) return;
      const rect = productGalleryMain.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      zoomTargetX = Math.max(0, Math.min(100, ((event.clientX - rect.left) / rect.width) * 100));
      zoomTargetY = Math.max(0, Math.min(100, ((event.clientY - rect.top) / rect.height) * 100));
      productGalleryMain.classList.add('is-hover-zooming');
      scheduleHoverZoom();
    };
    const resetHoverZoom = () => {
      productGalleryMain.classList.remove('is-hover-zooming');
      zoomTargetX = 50;
      zoomTargetY = 50;
      scheduleHoverZoom();
    };
    productGalleryMain.addEventListener('pointerenter', setHoverTarget);
    productGalleryMain.addEventListener('pointermove', setHoverTarget);
    productGalleryMain.addEventListener('pointerleave', resetHoverZoom);
    productGalleryImage.addEventListener('dragstart', (event) => event.preventDefault());
  }

  const lightboxThumbs = qa('[data-lightbox-thumb]', lightbox || document);
  const lightboxImage = q('[data-lightbox-image]', lightbox || document);
  let lightboxIndex = 0;

  function normalizedImageUrl(url = '') {
    try {
      const parsed = new URL(url, window.location.href);
      return `${parsed.origin}${parsed.pathname}`;
    } catch (_error) {
      return String(url).split('?')[0];
    }
  }

  function lightboxIndexForMainImage() {
    if (!productGalleryImage || !lightboxThumbs.length) return 0;
    const current = normalizedImageUrl(productGalleryImage.currentSrc || productGalleryImage.src);
    const exact = lightboxThumbs.findIndex((thumb) => normalizedImageUrl(thumb.dataset.image) === current);
    if (exact >= 0) return exact;
    const activeGalleryIndex = galleryThumbs.findIndex((thumb) => thumb.classList.contains('is-active'));
    return activeGalleryIndex >= 0 ? Math.min(activeGalleryIndex, lightboxThumbs.length - 1) : 0;
  }

  function showLightboxImage(index, { syncMain = false } = {}) {
    if (!lightboxThumbs.length || !lightboxImage) return;
    lightboxIndex = (index + lightboxThumbs.length) % lightboxThumbs.length;
    const thumb = lightboxThumbs[lightboxIndex];
    if (!thumb?.dataset.image) return;
    lightboxImage.src = thumb.dataset.image;
    lightboxThumbs.forEach((item, itemIndex) => item.classList.toggle('is-active', itemIndex === lightboxIndex));
    thumb.scrollIntoView?.({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    if (syncMain && galleryThumbs[lightboxIndex]) selectGalleryThumb(galleryThumbs[lightboxIndex]);
  }

  function openProductLightbox() {
    if (!lightbox) return;
    lightboxIndex = lightboxIndexForMainImage();
    if (lightboxThumbs.length) showLightboxImage(lightboxIndex);
    else if (productGalleryImage && lightboxImage) lightboxImage.src = productGalleryImage.currentSrc || productGalleryImage.src;
    productGalleryMain?.classList.remove('is-hover-zooming');
    lightbox.hidden = false;
    lightbox.setAttribute('aria-hidden', 'false');
    if (lightboxImage) {
      lightboxImage.style.width = '';
      lightboxImage.style.height = '';
      lightboxImage.style.maxWidth = '';
      lightboxImage.style.maxHeight = '';
      lightboxImage.style.transform = '';
    }
    document.documentElement.classList.add('cc181-lightbox-open');
    document.body.classList.add('cc180-lightbox-open', 'cc181-lightbox-open');
    document.body.style.overflow = 'hidden';
    q('[data-lightbox-close]', lightbox)?.focus?.({ preventScroll: true });
  }

  function closeLightbox() {
    if (!lightbox) return;
    lightbox.hidden = true;
    lightbox.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('cc181-lightbox-open');
    document.body.classList.remove('cc180-lightbox-open', 'cc181-lightbox-open');
    document.body.style.overflow = '';
  }

  q('[data-product-zoom]')?.addEventListener('click', (event) => {
    event.stopPropagation();
    openProductLightbox();
  });
  productGalleryImage?.addEventListener('click', openProductLightbox);
  lightboxThumbs.forEach((button, index) => button.addEventListener('click', () => showLightboxImage(index)));
  q('[data-lightbox-prev]', lightbox || document)?.addEventListener('click', () => showLightboxImage(lightboxIndex - 1));
  q('[data-lightbox-next]', lightbox || document)?.addEventListener('click', () => showLightboxImage(lightboxIndex + 1));
  q('[data-lightbox-close]', lightbox || document)?.addEventListener('click', closeLightbox);
  lightbox?.addEventListener('click', (event) => {
    if (event.target === lightbox) closeLightbox();
  });
  document.addEventListener('keydown', (event) => {
    if (!lightbox || lightbox.hidden) return;
    if (event.key === 'Escape') closeLightbox();
    if (event.key === 'ArrowLeft' && lightboxThumbs.length > 1) showLightboxImage(lightboxIndex - 1);
    if (event.key === 'ArrowRight' && lightboxThumbs.length > 1) showLightboxImage(lightboxIndex + 1);
  });

})();

/* catalogue filter typography + clear-state polish */
(() => {
  const initSourceShop = (root = document) => {
    const currentUrl = new URL(window.location.href);
    const query = currentUrl.searchParams.get('q') || '';

    const vendorFromUrl = (() => {
      const facet = currentUrl.searchParams.getAll('filter.p.vendor')
        .map((value) => String(value || '').trim())
        .find(Boolean);
      if (facet) return facet;
      const quoted = query.match(/(?:^|\s|AND\s+)vendor\s*:\s*["']([^"']+)["']/i);
      if (quoted?.[1]) return quoted[1].trim();
      const plain = query.match(/(?:^|\s|AND\s+)vendor\s*:\s*([^\s]+)/i);
      return plain?.[1] ? plain[1].trim() : '';
    })();

    root.querySelectorAll('[data-source-filter-accordion]').forEach((accordion) => {
      if (accordion.dataset.sourceReady === 'true') return;
      accordion.dataset.sourceReady = 'true';
      const trigger = accordion.querySelector('[data-source-filter-trigger]');
      if (!trigger) return;

      const isBrandSection = accordion.classList.contains('cc139-brands');
      const isCategorySection = accordion.classList.contains('cc139-categories');
      const isPriceSection = accordion.classList.contains('cc-price-filter');
      let hasActiveFilter = accordion.dataset.filterActive === 'true';

      if (isBrandSection) {
        hasActiveFilter = hasActiveFilter || !!vendorFromUrl;
        if (vendorFromUrl) {
          const rows = [...accordion.querySelectorAll('.source-v0514-brand-list a')];
          const selectedRow = rows.find((row) => {
            const label = row.querySelector('span:first-child')?.textContent?.trim() || row.textContent.trim();
            return label.localeCompare(vendorFromUrl, undefined, { sensitivity: 'accent' }) === 0;
          });
          if (selectedRow) selectedRow.classList.add('is-active');

          const side = trigger.querySelector('.cc-filter-trigger-side');
          if (side) {
            let selectedLabel = side.querySelector('.cc149-filter-selection');
            if (!selectedLabel) {
              selectedLabel = document.createElement('small');
              selectedLabel.className = 'cc149-filter-selection';
              side.insertBefore(selectedLabel, side.querySelector('svg'));
            }
            selectedLabel.textContent = vendorFromUrl;
          }
        }
      }
      if (isCategorySection) {
        const categoryQuery = /tag\s*:\s*["']?(?:new arrival|best seller|men|women|tester|gift set)["']?/i.test(query);
        hasActiveFilter = hasActiveFilter || categoryQuery;
      }
      if (isPriceSection) {
        const minPrice = currentUrl.searchParams.get('filter.v.price.gte');
        const maxPrice = currentUrl.searchParams.get('filter.v.price.lte');
        hasActiveFilter = hasActiveFilter || !!String(minPrice || '').trim() || !!String(maxPrice || '').trim();
      }

      // Active filters start open after navigation, but the shopper can freely close/reopen them.
      accordion.dataset.filterActive = hasActiveFilter ? 'true' : 'false';
      accordion.classList.toggle('is-open', hasActiveFilter);
      trigger.setAttribute('aria-expanded', hasActiveFilter ? 'true' : 'false');

      const revealSelectedBrand = () => {
        if (!isBrandSection || !accordion.classList.contains('is-open')) return;
        const list = accordion.querySelector('.source-v0514-brand-list');
        const selected = list?.querySelector('a.is-active');
        if (!list || !selected) return;
        requestAnimationFrame(() => {
          const target = selected.offsetTop - Math.max(0, (list.clientHeight - selected.offsetHeight) / 2);
          list.scrollTop = Math.max(0, target);
        });
      };
      revealSelectedBrand();

      trigger.addEventListener('click', () => {
        const open = accordion.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) revealSelectedBrand();
      });
    });

    // Keep Clear Filters tied to real active state, including vendor searches encoded in q=.
    root.querySelectorAll('[data-source-shop]').forEach((shopRoot) => {
      const clearWrap = shopRoot.querySelector('[data-clear-filters]');
      if (!clearWrap) return;
      const hasActiveAccordion = [...shopRoot.querySelectorAll('[data-source-filter-accordion]')].some((accordion) => accordion.dataset.filterActive === 'true');
      const hasVendor = !!vendorFromUrl;
      const hasCategory = /tag\s*:\s*["']?(?:new arrival|best seller|men|women|tester|gift set)["']?/i.test(query);
      const hasPrice = !!String(currentUrl.searchParams.get('filter.v.price.gte') || '').trim() || !!String(currentUrl.searchParams.get('filter.v.price.lte') || '').trim();
      clearWrap.hidden = !(hasActiveAccordion || hasVendor || hasCategory || hasPrice);
    });

    root.querySelectorAll('[data-source-sort]').forEach((details) => {
      if (details.dataset.sourceReady === 'true') return;
      details.dataset.sourceReady = 'true';

      /* keep <details> mounted while closing so Sort By can use
         the same reversible motion as the sidebar accordions. */
      const summary = details.querySelector(':scope > summary');
      let closeTimer = 0;
      details.classList.add('cc-sort-animated');
      if (details.open) details.classList.add('cc-sort-open');

      const closeSort = () => {
        window.clearTimeout(closeTimer);
        if (!details.open && !details.classList.contains('cc-sort-open')) return;
        details.classList.remove('cc-sort-open');
        details.classList.add('cc-sort-closing');
        closeTimer = window.setTimeout(() => {
          details.open = false;
          details.classList.remove('cc-sort-closing');
        }, window.matchMedia('(max-width: 767px)').matches ? 0 : 460);
      };

      summary?.addEventListener('click', (event) => {
        event.preventDefault();
        window.clearTimeout(closeTimer);

        if (details.classList.contains('cc-sort-open')) {
          closeSort();
          return;
        }

        details.open = true;
        details.classList.remove('cc-sort-closing');
        /* Two frames guarantee the browser paints the collapsed state first,
           giving opening and closing the same interpolation curve. */
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => details.classList.add('cc-sort-open'));
        });
      });

      /* Sort By behaves like a normal dropdown: clicking anywhere
         outside it closes through the same reversible animation instead of
         leaving the menu open until the trigger is clicked again. */
      document.addEventListener('pointerdown', (event) => {
        if (!details.open || details.contains(event.target)) return;
        closeSort();
      }, { passive: true });

      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || !details.open) return;
        closeSort();
        summary?.focus({ preventScroll: true });
      });

      details.querySelectorAll('[data-sort-value]').forEach((button) => {
        button.addEventListener('click', () => {
          const url = new URL(window.location.href);
          const value = button.dataset.sortValue || 'created-descending';
          /* v50: clean URLs - the collection's own default order needs no ?sort_by,
             and a new sort order always starts again from page 1. */
          if (details.dataset.defaultSort && value === details.dataset.defaultSort) url.searchParams.delete('sort_by');
          else url.searchParams.set('sort_by', value);
          url.searchParams.delete('page');
          window.location.href = url.toString();
        });
      });
    });

    root.querySelectorAll('[data-source-sort-mobile]').forEach((button) => {
      if (button.dataset.sourceReady === 'true') return;
      button.dataset.sourceReady = 'true';
      button.addEventListener('click', () => {
        const url = new URL(window.location.href);
        const current = url.searchParams.get('sort_by') || 'created-descending';
        const order = ['created-descending', 'price-ascending', 'price-descending'];
        const next = order[(Math.max(0, order.indexOf(current)) + 1) % order.length];
        const defaultSort = document.querySelector('[data-source-sort][data-default-sort]')?.dataset.defaultSort || '';
        if (defaultSort && next === defaultSort) url.searchParams.delete('sort_by');
        else url.searchParams.set('sort_by', next);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initSourceShop(), { once: true });
  else initSourceShop();
  document.addEventListener('shopify:section:load', (event) => initSourceShop(event.target));
})();

/* keep search in the actual search controls; never open a blank standalone search screen. */
(() => {
  const initHeaderSearch = (root = document) => {
    root.querySelectorAll('[data-header-search-form]').forEach((form) => {
      if (form.dataset.ccSearchReady === 'true') return;
      form.dataset.ccSearchReady = 'true';
      const input = form.querySelector('input[type="search"]');
      form.addEventListener('submit', (event) => {
        if (!input || input.value.trim() !== '') return;
        event.preventDefault();
        input.focus({ preventScroll: true });
      });
    });
  };
  document.addEventListener('DOMContentLoaded', () => initHeaderSearch(document));
  initHeaderSearch(document);
})();

/* =========================================================
   Featured Fragrances clean full title
   ========================================================= */
(() => {
  const concentrationPatterns = [
    /\beau\s+de\s+parfum\s+intense\b/gi,
    /\bextrait\s+de\s+parfum\b/gi,
    /\bparfum\s+extract\b/gi,
    /\beau\s+de\s+parfum\b/gi,
    /\beau\s+de\s+toilette\b/gi,
    /\beau\s+de\s+cologne\b/gi,
    /\bperfume\s+extract\b/gi,
    /\bextrait\b/gi,
    /\bedp\b/gi,
    /\bedt\b/gi,
    /\bedc\b/gi,
    /\bparfum\b/gi
  ];

  const setPatterns = [
    { pattern: /\b(\d+)\s*[- ]?(?:piece|pcs?|pc)\s+(?:gift\s+)?set\b/i, label: (match) => `${match[1]}-Piece Gift Set` },
    { pattern: /\b(\d+)\s*[- ]?(?:piece|pcs?|pc)\b/i, label: (match) => `${match[1]}-Piece Set` },
    { pattern: /\bgift\s+set\b/i, label: () => 'Gift Set' }
  ];

  const formatHeroProductTitle = (value = '') => {
    const original = String(value).replace(/\s+/g, ' ').trim();
    if (!original) return '';

    let detail = '';
    for (const item of setPatterns) {
      const match = original.match(item.pattern);
      if (match) {
        detail = item.label(match);
        break;
      }
    }

    let name = original;

    // Concentration is intentionally omitted from Featured Fragrances.
    concentrationPatterns.forEach((pattern) => {
      name = name.replace(pattern, ' ');
    });

    // Normalize meaningful set presentation into one clean phrase at the end.
    setPatterns.forEach(({ pattern }) => {
      name = name.replace(pattern, ' ');
    });

    // Keep bottle sizing/tester catalogue wording out of the homepage preview.
    name = name
      .replace(/\b(?:tester|tester\s+bottle)\b/gi, ' ')
      .replace(/\b\d+(?:\.\d+)?\s*(?:ml|cl|oz|fl\.?\s*oz)\b/gi, ' ')
      .replace(/\s+/g, ' ')
      .replace(/^[\s|·•/\\\-–—,:]+|[\s|·•/\\\-–—,:]+$/g, '')
      .trim();

    return [name || original, detail].filter(Boolean).join(' ');
  };

  const applyHeroProductTitles = (root = document) => {
    root.querySelectorAll?.('[data-hero-clean-product-title]').forEach((node) => {
      const source = node.getAttribute('data-title-source') || node.textContent || '';
      node.textContent = formatHeroProductTitle(source);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => applyHeroProductTitles(document), { once: true });
  } else {
    applyHeroProductTitles(document);
  }

  document.addEventListener('shopify:section:load', (event) => applyHeroProductTitles(event.target));
})();

/* =========================================================
   one perfume listing + tester availability
   ========================================================= */
(() => {
  const normalizeListingKey = (card) => {
    const vendor = String(card.dataset.productVendor || '').toLowerCase().trim();
    const source = String(card.dataset.productDisplayTitle || card.querySelector('.full-bottle-strip-body h3')?.textContent || '')
      .toLowerCase()
      .replace(/\btester(?:\s+bottle)?\b/g, ' ')
      .replace(/\b(?:eau\s+de\s+parfum|extrait\s+de\s+parfum|eau\s+de\s+toilette|eau\s+de\s+cologne|edp|edt|edc|parfum|extrait)\b/g, ' ')
      .replace(/\b\d+(?:\.\d+)?\s*(?:ml|cl|oz|fl\.?\s*oz)\b/g, ' ')
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
    return `${vendor}::${source}`;
  };

  const dedupeProductListings = (root = document) => {
    const listingSelector = '[data-product-grid], .source-v0514-grid, .source-product-row';
    const grids = root.matches?.(listingSelector)
      ? [root]
      : Array.from(root.querySelectorAll?.(listingSelector) || []);

    grids.forEach((grid) => {
      const cards = Array.from(grid.querySelectorAll(':scope > [data-product-card]'));
      const groups = new Map();
      cards.forEach((card) => {
        const key = normalizeListingKey(card);
        if (!key.endsWith('::')) {
          const group = groups.get(key) || [];
          group.push(card);
          groups.set(key, group);
        }
      });

      groups.forEach((group) => {
        if (!group.length) return;
        if (group.length === 1) {
          return;
        }
        // Only fold a standalone tester into its perfume. Two different
        // listings that read alike (The One EDP and EDT) both stay.
        if (!group.some((card) => card.dataset.productIsTester === 'true')) return;

        const score = (card) => {
          const available = card.dataset.productAvailable === 'true' ? 100 : 0;
          const nonTester = card.dataset.productIsTester === 'true' ? 0 : 20;
          return available + nonTester;
        };
        const keep = group.slice().sort((a, b) => score(b) - score(a))[0];
        group.forEach((card) => { if (card !== keep) card.remove(); });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => dedupeProductListings(document), { once: true });
  } else {
    dedupeProductListings(document);
  }
  document.addEventListener('shopify:section:load', (event) => dedupeProductListings(event.target));
  document.addEventListener('cc:listings-updated', (event) => dedupeProductListings(event.target));

  const observeDynamicListingGrid = (grid) => {
    if (!grid || grid.dataset.ccDedupeObserved) return;
    grid.dataset.ccDedupeObserved = 'true';
    const observer = new MutationObserver(() => dedupeProductListings(grid));
    observer.observe(grid, { childList: true });
  };
  document.querySelectorAll('[data-recommendation-grid], [data-recently-viewed-grid]').forEach(observeDynamicListingGrid);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll?.('[data-recommendation-grid], [data-recently-viewed-grid]').forEach(observeDynamicListingGrid);
  });
})();

/* =========================================================
   homepage shelf reveal compatibility helper
   - Retains only the still-used first-render arrow reveal support.
   - Obsolete data-home-shelf-* scroll carousel listeners were removed.
   ========================================================= */
(() => {
  const qsa = (root, selector) => Array.from(root.querySelectorAll?.(selector) || []);
  const getCards = (row) => qsa(row, ':scope > [data-product-card]').filter((card) => !card.hidden);

  const pageSize = (row) => {
    const raw = window.getComputedStyle(row).getPropertyValue('--cc245-page-size').trim();
    const parsed = Number.parseInt(raw, 10);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : 6;
  };

  /* guaranteed first-render reveal.
     v2.15.615 could keep arrows hidden forever when a stability attempt was
     cancelled/restarted by randomized-shelf mutations. This path waits for the
     final randomized DOM, fonts and endpoint images, performs one forced final
     geometry pass, then reveals the controls. Once revealed, ordinary carousel
     clicks never move them; only a real resize/zoom can remeasure geometry. */
  const cc616PrepareArrowReveal = async (wrap) => {
    if (!wrap || wrap.dataset.cc616ArrowVisible === 'true') return;
    const track = wrap.querySelector('[data-cc246-row]');
    if (!track) return;
    if (track.hasAttribute('data-random-home-shelf') && track.dataset.randomShelfReady !== 'true') return;

    const token = (wrap._cc616RevealToken || 0) + 1;
    wrap._cc616RevealToken = token;
    const current = () => wrap._cc616RevealToken === token;

    try { if (document.fonts?.ready) await Promise.race([document.fonts.ready, new Promise((r) => setTimeout(r, 350))]); } catch (_) {}
    if (!current()) return;

    const viewport = wrap.querySelector('[data-cc246-viewport]') || wrap;
    const cards = getCards(track);
    if (!cards.length) return;
    const viewportRect = viewport.getBoundingClientRect();
    let visible = cards.filter((card) => {
      const r = card.getBoundingClientRect();
      return r.right > viewportRect.left + 2 && r.left < viewportRect.right - 2;
    });
    if (!visible.length) {
      const count = pageSize(track);
      const page = Number.parseInt(wrap.dataset.cc246Page || '0', 10) || 0;
      const startIndex = Math.max(0, page * count);
      visible = cards.slice(startIndex, Math.min(cards.length, startIndex + count));
    }
    const firstStage = (visible[0] || cards[0])?.querySelector('.full-bottle-strip-image-stage');
    const lastStage = (visible[visible.length - 1] || cards[cards.length - 1])?.querySelector('.full-bottle-strip-image-stage');
    if (!firstStage || !lastStage) return;

    const endpointImages = [...firstStage.querySelectorAll('img'), ...lastStage.querySelectorAll('img')];
    await Promise.all(endpointImages.map(async (img) => {
      try {
        if (!img.complete) await Promise.race([
          new Promise((resolve) => { img.addEventListener('load', resolve, { once:true }); img.addEventListener('error', resolve, { once:true }); }),
          new Promise((resolve) => setTimeout(resolve, 450))
        ]);
        if (typeof img.decode === 'function') await Promise.race([img.decode().catch(() => {}), new Promise((resolve) => setTimeout(resolve, 250))]);
      } catch (_) {}
    }));
    if (!current()) return;

    await new Promise((resolve) => requestAnimationFrame(() => requestAnimationFrame(resolve)));
    if (!current()) return;

    /* v2.15.624: legacy reveal may update visibility flags only. Geometry is
       owned exclusively by the v2.15.624 settled initializer below. */
    wrap.dataset.cc612ArrowGeometrySettled = 'true';
    wrap.dataset.cc616ArrowVisible = 'true';
  };

  const cc616RevealAll = () => qsa(document, '[data-cc246-wrap]').forEach((wrap) => cc616PrepareArrowReveal(wrap));
  if (document.readyState === 'complete') cc616RevealAll();
  else window.addEventListener('load', cc616RevealAll, { once:true });
  document.addEventListener('cc:home-shelf-ready', (event) => {
    const wrap = event.target.closest?.('[data-cc246-wrap]');
    if (wrap) cc616PrepareArrowReveal(wrap);
  });
  /* Safety net: if a browser delays an image decode event, do one final reveal
     pass after initial layout rather than leaving controls invisible forever. */
  window.setTimeout(cc616RevealAll, 900);

})();

/* =========================================================
   paired random homepage shelves
   - 24 random eligible fragrances per shelf.
   - New Arrivals and Best Sellers never share a product on the same page load.
   - Tag labels remain presentation only; homepage selection is catalogue-random.
   ========================================================= */
(() => {
  const shuffle = (items) => {
    const list = items.slice();
    for (let i = list.length - 1; i > 0; i -= 1) {
      const j = Math.floor(Math.random() * (i + 1));
      [list[i], list[j]] = [list[j], list[i]];
    }
    return list;
  };

  const itemKey = (item, index) => {
    const card = item.matches?.('[data-product-card]') ? item : item.querySelector?.('[data-product-card]');
    return card?.dataset.productHandle || item.dataset.randomKey || `item-${index}`;
  };

  const currentlyVisibleKeys = (shelf) => new Set(
    Array.from(shelf.querySelectorAll(':scope > [data-random-shelf-item]'))
      .filter((item) => !item.hidden)
      .map((item, index) => itemKey(item, index))
  );

  function initRandomHomeShelves(root = document) {
    const scope = root === document ? document : document;
    const shelves = Array.from(scope.querySelectorAll('[data-random-home-shelf]'));
    if (!shelves.length) return;

    const used = new Set();

    /* Preserve already-initialized shelves when Shopify reloads only one section. */
    shelves.forEach((shelf) => {
      if (shelf.dataset.randomShelfReady === 'true') {
        currentlyVisibleKeys(shelf).forEach((key) => used.add(key));
      }
    });

    shelves.forEach((shelf) => {
      if (shelf.dataset.randomShelfReady === 'true') return;

      const items = Array.from(shelf.querySelectorAll(':scope > [data-random-shelf-item]'));
      const limit = Math.max(1, Number(shelf.dataset.randomLimit) || 24);
      if (!items.length) {
        shelf.dataset.randomShelfReady = 'true';
        shelf.classList.add('is-randomized');
        return;
      }

      const keyed = items.map((item, index) => ({ item, key: itemKey(item, index) }));
      const available = shuffle(keyed.filter((entry) => !used.has(entry.key)));
      const chosen = available.slice(0, Math.min(limit, available.length));

      /* v2.15.668: each standard homepage shelf must expose its full requested
         pool (24 products => exactly three 8-card desktop pages). Keep the
         no-overlap rule whenever possible, but if the eligible catalogue is
         temporarily smaller than two full disjoint pools, fill the remainder
         from unused-in-this-shelf candidates rather than silently producing a
         21/22/23-product shelf. */
      if (chosen.length < Math.min(limit, keyed.length)) {
        const alreadyChosen = new Set(chosen.map((entry) => entry.item));
        const fallback = shuffle(keyed.filter((entry) => !alreadyChosen.has(entry.item)));
        while (chosen.length < Math.min(limit, keyed.length) && fallback.length) {
          chosen.push(fallback.pop());
        }
      }

      const chosenSet = new Set(chosen.map((entry) => entry.item));

      items.forEach((item) => {
        if (chosenSet.has(item)) item.hidden = false;
        else item.remove();
      });
      chosen.forEach(({ item, key }) => {
        shelf.appendChild(item);
        used.add(key);
      });

      shelf.dataset.randomShelfReady = 'true';
      shelf.classList.add('is-randomized');
      shelf.dispatchEvent(new CustomEvent('cc:home-shelf-ready', { bubbles: true }));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initRandomHomeShelves(document), { once: true });
  } else {
    initRandomHomeShelves(document);
  }

  document.addEventListener('shopify:section:load', () => initRandomHomeShelves(document));
})();

/* full-bottle catalogue search guard.
   Category browsing is collection/tag based before pagination; free text search
   is restricted to Shopify product type "Full Bottle" before results render. */
(() => {
  const initFullBottleSearch = (root = document) => {
    root.querySelectorAll('[data-full-bottle-search]').forEach((form) => {
      if (form.dataset.ccFullBottleReady === 'true') return;
      form.dataset.ccFullBottleReady = 'true';
      const visible = form.querySelector('[data-full-bottle-search-input]');
      const hidden = form.querySelector('[data-full-bottle-query]');
      if (!visible || !hidden) return;
      form.addEventListener('submit', (event) => {
        const term = visible.value.trim();
        const productType = (form.dataset.searchProductType || 'Full Bottle').trim() || 'Full Bottle';
        const isUniversal = productType.toLowerCase() === 'universal';
        hidden.value = isUniversal ? term : (term ? `product_type:"${productType}" AND ${term}` : `product_type:"${productType}"`);
        visible.removeAttribute('name');
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initFullBottleSearch(document), { once: true });
  else initFullBottleSearch(document);
  document.addEventListener('shopify:section:load', (event) => initFullBottleSearch(event.target));
})();

/* Keep category and brand routes exclusive.
   v50: brands and categories are tag routes on the Shop collection
   (/collections/fragrances/brand-armaf, /collections/fragrances/men), built from
   window.CANADA_COLOGNE.shopUrl / shopTagUrl so they match the theme's links.
   Older vendor and search-style links are forwarded there. */
(() => {
  const cfg = window.CANADA_COLOGNE || {};
  if (!cfg.shopUrl || !cfg.shopTagUrl) return;
  const url = new URL(window.location.href);
  const query = String(url.searchParams.get('q') || '')
    .replace(/&quot;|&#34;/gi, '"')
    .replace(/\s+/g, ' ')
    .trim();
  const isSearch = /(?:^|\/)search\/?$/.test(url.pathname);
  const isCollection = /(?:^|\/)collections\//.test(url.pathname);
  if (!isSearch && !isCollection) return;
  const handleize = (value) => String(value || '').toLowerCase().replace(/['’]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  const routes = cfg.shopRoutes || {};
  const shopUrl = (tag) => new URL(tag ? String(routes[tag] || String(cfg.shopTagUrl).replace('cc-tag', tag)) : String(cfg.shopUrl), window.location.origin);
  const carry = (target) => {
    ['filter.v.price.gte', 'filter.v.price.lte'].forEach((key) => {
      const value = url.searchParams.get(key);
      if (value) target.searchParams.set(key, value);
    });
    const sort = url.searchParams.get('sort_by');
    if (sort === 'price-ascending' || sort === 'price-descending') target.searchParams.set('sort_by', sort);
    return target;
  };
  const go = (target) => { if (target.href !== url.href) window.location.replace(target.href); };

  const isVendorCollection = /(?:^|\/)collections\/vendors\/?$/.test(url.pathname);
  const vendorFromQuery = query.match(/vendor:\s*"([^"]+)"/i)?.[1]?.trim() || '';
  const isDecantSearch = isSearch && /product_type:\s*"decant"/i.test(query);
  const vendor = (url.searchParams.get('filter.p.vendor') || vendorFromQuery || (isVendorCollection && cfg.shopClean ? query : '')).trim();
  if (vendor && !isDecantSearch && (!isVendorCollection || cfg.shopClean)) {
    go(carry(shopUrl(handleize(vendor))));
    return;
  }
  if (!isSearch) return;

  const queryLower = query.toLowerCase();
  if (!queryLower.includes('product_type:"full bottle"')) return;

  const tagRoutes = [
    ['best seller', 'best-seller'],
    ['new arrival', 'new-arrival'],
    ['gift set', 'gift-set'],
    ['bundle', 'bundle'],
    ['tester', 'tester-available'],
    ['women', 'women'],
    ['tag:"men"', 'men'],
  ];
  const tagRoute = tagRoutes.find(([needle]) => queryLower.includes(needle))?.[1] || '';
  const recognizedOnly = query
    .replace(/product_type:\s*"full bottle"/ig, '')
    .replace(/\bAND\b/ig, ' ')
    .replace(/tag:\s*"(?:best seller|new arrival|gift set|bundle|tester|women|men)"/ig, '')
    .replace(/\s+/g, ' ')
    .trim() === '';
  if (!recognizedOnly) return;
  go(carry(shopUrl(tagRoute)));
})();

/* Catalogue reset/search guard.
   Search Catalogue is permanently visible. Legacy product-type baselines are
   removed from the customer-facing field, while universal catalogue searches
   submit only the words the customer entered. */
(() => {
  const decodeQuery = (value = '') => value
    .replace(/&amp;quot;/gi, '"')
    .replace(/&quot;|&#34;/gi, '"')
    .replace(/&amp;/gi, '&')
    .trim();

  const isBaselineFullBottleQuery = (value = '') =>
    decodeQuery(value).toLowerCase() === 'product_type:"full bottle"';
  const isBaselineDecantQuery = (value = '') =>
    decodeQuery(value).toLowerCase() === 'product_type:"decant"';

  const syncCatalogueBaselineState = (root = document) => {
    root.querySelectorAll('[data-catalog-tools]').forEach((tools) => {
      const visibleInput = tools.querySelector('[data-full-bottle-search-input]');
      if (!visibleInput) return;

      const params = new URLSearchParams(window.location.search);
      const q = decodeQuery(params.get('q') || '');
      if (!isBaselineFullBottleQuery(q) && !isBaselineDecantQuery(q)) return;

      visibleInput.value = '';
      const sidebar = tools.closest('[data-filter-sidebar]');
      const clearWrap = sidebar?.querySelector('[data-clear-filters]');
      const categoryGroup = sidebar?.querySelector('.cc139-categories');
      const categoryActive = categoryGroup?.dataset.filterActive === 'true';
      const brandGroup = sidebar?.querySelector('.cc139-brands');
      const brandActive = brandGroup?.dataset.filterActive === 'true';
      const priceGroup = sidebar?.querySelector('.cc-price-filter');
      const priceActive = priceGroup?.dataset.filterActive === 'true';
      if (clearWrap && !categoryActive && !brandActive && !priceActive) clearWrap.hidden = true;
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => syncCatalogueBaselineState(document), { once: true });
  else syncCatalogueBaselineState(document);
  document.addEventListener('shopify:section:load', (event) => syncCatalogueBaselineState(event.target));
})();

/*  */

/* unified search clear controls. */
(() => {
  const initSearchClears = (root = document) => {
    root.querySelectorAll('[data-search-clear]').forEach((button) => {
      if (button.dataset.ccClearReady === 'true') return;
      button.dataset.ccClearReady = 'true';

      const form = button.closest('form');
      const input = form && (form.querySelector('[data-full-bottle-search-input]') || form.querySelector('input[type="search"]'));
      if (!input) return;

      const sync = () => {
        const hasValue = input.value.trim().length > 0;
        button.hidden = !hasValue;
        if (form) form.classList.toggle('cc-search-has-value', hasValue);
      };

      input.addEventListener('input', sync, { passive: true });
      input.addEventListener('change', sync, { passive: true });

      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (button.animate) {
          button.animate([
            { transform: 'scale(1)' },
            { transform: 'scale(.86)' },
            { transform: 'scale(1)' }
          ], { duration: 220, easing: 'cubic-bezier(.2,.7,.2,1)' });
        }
        input.value = '';
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.focus({ preventScroll: true });
      });

      sync();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initSearchClears(document), { once: true });
  } else {
    initSearchClears(document);
  }
  document.addEventListener('shopify:section:load', (event) => initSearchClears(event.target));
})();

/*  */

/*  */

/* Decants baseline + strict displayed-price filter fix */

/* homepage-style recommendation/recently-viewed image treatment (JS behavior unchanged) */

/* universal homepage card visual treatment (CSS-only behavior standardization) */

/* =========================================================
   deterministic seven-up homepage shelves
   - Independent transform-based paging (no scrollLeft / scroll-snap conflicts).
   - Seven full-size cards on wide desktop.
   - Both shelves run the same one-time page intro sweep, then return to page 1.
   ========================================================= */
(() => {
  const qsa = (root, selector) => Array.from(root.querySelectorAll?.(selector) || []);
  const motionOK = () => !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  const getCards = (track) => qsa(track, ':scope > [data-product-card]').filter((card) => !card.hidden);
  const cc668IsStandardHomeShelf = (track) => Boolean(track?.closest?.('.product-section-home:not(.cc-hot-deals-section)'));
  const cc668IsEightUpDesktop = (track) => Boolean(
    cc668IsStandardHomeShelf(track) && window.matchMedia?.('(min-width: 1100px)').matches
  );
  const pageSize = (track) => {
    /* Do not let an older seven-up CSS variable leak back in at Shopify preview
       widths / browser zoom. The JS page step and the CSS card geometry must
       always agree: 8 cards per desktop page. */
    if (cc668IsEightUpDesktop(track)) return 8;
    const n = Number.parseInt(getComputedStyle(track).getPropertyValue('--cc246-page-size').trim(), 10);
    return Number.isFinite(n) && n > 0 ? n : 8;
  };
  const totalPages = (track) => Math.max(1, Math.ceil(getCards(track).length / pageSize(track)));
  /* exact page offsets for homepage shelves.
     Card width × count can accumulate fractional error at desktop sizes, which
     lets adjacent listings peek in at the left/right edge. Page transitions now
     lock to the real offsetLeft of the first card on each page so desktop
     shelves always show full cards only, never cut-off edge listings. */
  const pageOffset = (track, requestedPage) => {
    const cards = getCards(track);
    if (!cards.length) return 0;
    const pages = Math.max(1, Math.ceil(cards.length / pageSize(track)));
    const page = Math.max(0, Math.min(pages - 1, requestedPage));
    const startIndex = Math.max(0, Math.min(cards.length - 1, page * pageSize(track)));
    const firstLeft = cards[0].offsetLeft || 0;
    const targetLeft = cards[startIndex]?.offsetLeft ?? firstLeft;
    return Math.max(0, targetLeft - firstLeft);
  };

  /* Flash Sale phone carousel uses exact card offsets instead of
     the generic width+gap page estimate. This keeps arrows and swipes locked to
     one real listing per step even after mobile layout/font/image reflow. */
  /* v2.15.667: Flash Sale shows exactly one listing at every width, so the
     single-card path is no longer gated on the phone breakpoint. */
  /* v2.16 — the Flash Sale is single-card on phones only; wider screens use
     the normal rail (3 across on desktop, 2 on tablet) like release.css. */
  const cc646IsPhoneFlash = (wrap) => Boolean(
    wrap?.closest?.('.cc-hot-deals-section') && window.matchMedia?.('(max-width: 640px)').matches
  );
  /* one phone contract for every homepage shelf. */
  const cc649IsPhoneHome = (wrap) => Boolean(
    wrap?.closest?.('.product-section-home') &&
      window.matchMedia?.('(max-width: 640px)').matches
  );
  /* New Arrivals / Best Sellers keep the full 24-product
     randomized pool on desktop, but phone intentionally uses only the first 8
     randomized products. With a 2-up mobile page this creates exactly four
     complete pages (2+2+2+2) and can never end on a single orphan listing. */
  const cc652PhoneShelfCards = (wrap, track) => {
    const cards = getCards(track);
    if (!cc649IsPhoneHome(wrap) || cc646IsPhoneFlash(wrap)) return cards;
    return cards.slice(0, Math.min(8, cards.length));
  };
  /* Two-card phone page helper. v2.15.652 supplies an even 8-card mobile
     pool for New Arrivals / Best Sellers, so every page is a complete pair. */
  const cc650PhonePairStart = (cards, page) => {
    if (!cards?.length) return 0;
    return Math.max(0, Math.min(page * 2, Math.max(0, cards.length - 2)));
  };
  const cc646FlashCenterIndex = (track) => {
    const cards = getCards(track);
    const leadIndex = cards.findIndex((card) => card.dataset.productHandle === 'rasasi-afnan-fresh-duo-bundle');
    if (leadIndex >= 0) return leadIndex;
    const shiyaakaIndex = cards.findIndex((card) => card.dataset.productHandle === 'khadlaj-shiyaaka-trio-bundle');
    if (shiyaakaIndex >= 0) return shiyaakaIndex;
    return Math.max(0, Math.min(cards.length - 1, Math.floor(cards.length / 2)));
  };
  const cc670HomeArrowEdge = () => window.innerWidth <= 640 ? 10 : 12;

  const cc614HomeCurrentTranslateY = (element) => {
    if (!element) return 0;
    const transform = getComputedStyle(element).transform;
    if (!transform || transform === 'none') return 0;
    try {
      const matrix = new DOMMatrixReadOnly(transform);
      return Number.isFinite(matrix.m42) ? matrix.m42 : 0;
    } catch (_) {
      const match = transform.match(/^matrix\([^,]+,[^,]+,[^,]+,[^,]+,[^,]+,\s*([^\)]+)\)$/);
      return match ? (Number.parseFloat(match[1]) || 0) : 0;
    }
  };

  const cc614HomeFinalStageCenterY = (stage) => {
    if (!stage) return NaN;
    const rect = stage.getBoundingClientRect();
    if (!(rect.height > 0)) return NaN;
    const shell = stage.closest('.full-bottle-strip-image-shell');
    const finalLift = Number.parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--cc290-card-hover-lift')) || -5;
    const currentLift = cc614HomeCurrentTranslateY(shell);
    return rect.top + rect.height / 2 + (finalLift - currentLift);
  };

  /* NATIVE CSS ANCHOR POSITIONING
     ---------------------------------------------------------
     The homepage arrows no longer depend on a one-time pixel measurement.
     Each shelf gets three native CSS anchors:
       - the fixed carousel viewport for horizontal placement;
       - the first endpoint product VISUAL for the previous-arrow Y position;
       - the last endpoint product VISUAL for the next-arrow Y position.

     .full-bottle-strip-visual is intentionally used instead of the moving
     image shell: it has exactly the same dimensions as the image hover box but
     does not move during hover. Subtracting the approved 5px hover lift gives
     the exact final-hover image centre while the arrow itself stays static.

     Because anchor() is resolved by layout itself, refresh, zoom, scrollbar
     changes, font reflow and image loading cannot leave stale coordinates.
     There is no ResizeObserver / getBoundingClientRect correction loop in the
     supported path. */
  let cc625AnchorSerial = 0;
  const cc625AnchorSupported = Boolean(
    window.CSS?.supports?.('anchor-name: --cc625-test') &&
    window.CSS?.supports?.('top: anchor(--cc625-test center)')
  );

  const cc625ClearEndpointAnchor = (element, name) => {
    if (!element) return;
    const current = element.style.getPropertyValue('anchor-name').trim();
    if (!current) return;
    /* v2.15.674 — a single-listing page (the last Flash Sale page) puts BOTH
       endpoint names on the same listing, as "--prev, --next". The old exact
       string comparison never matched that pair, so the name was left behind
       when the shopper paged back: two listings then carried the same anchor
       name, and the browser resolves an ambiguous name against the LAST match
       in DOM order — the bundle sitting off-page to the right. That is what
       parked the greyed-out previous arrow on top of the last visible bundle.
       Remove the one name from the list instead of matching the whole list. */
    const remaining = current
      .split(',')
      .map((entry) => entry.trim())
      .filter((entry) => entry && entry !== name);
    if (remaining.length) element.style.setProperty('anchor-name', remaining.join(', '));
    else element.style.removeProperty('anchor-name');
  };

  /* v2.15.673 — the shared arrow-to-listing gap (this module has its own
     scope, so it reads the same custom property as the product-page shelves). */
  const cc673ShelfArrowGap = () => Number.parseFloat(
    getComputedStyle(document.documentElement).getPropertyValue('--cc673-shelf-arrow-gap')
  ) || 21;

  const cc625AssignAnchorGeometry = (wrap, prev, next, track, viewport, firstCard, lastCard) => {
    if (!wrap._cc625AnchorId) wrap._cc625AnchorId = ++cc625AnchorSerial;
    const id = wrap._cc625AnchorId;
    const viewportAnchor = `--cc625-vp-${id}`;
    const prevAnchor = `--cc625-prev-y-${id}`;
    const nextAnchor = `--cc625-next-y-${id}`;

    const firstVisual = firstCard?.querySelector('.full-bottle-strip-visual');
    const lastVisual = lastCard?.querySelector('.full-bottle-strip-visual');
    if (!firstVisual || !lastVisual) return false;

    /* PHONE ARROWS SHARE ONE TRUE IMAGE CENTRE.
       On phone, both controls must sit on the same horizontal line through the
       visible listing image. Do not let left/right endpoints independently
       choose slightly different Y anchors. Desktop/tablet keep endpoint Y. */
    const cc647SharedPhoneY = window.matchMedia?.('(max-width: 640px)').matches;
    const nextVisual = cc647SharedPhoneY ? firstVisual : lastVisual;

    /* Remove a reused anchor name from an old endpoint before assigning it to
       a different page. This prevents multiple-anchor ambiguity.
       v2.15.674 — clear BOTH names off every listing that is no longer the
       endpoint that will carry them, not just the one name it was tracked
       under. A listing can hold the pair, and clearing only half of it left a
       duplicate name behind. */
    [wrap._cc625PrevVisual, wrap._cc625NextVisual].forEach((visual) => {
      if (!visual) return;
      if (visual !== firstVisual) cc625ClearEndpointAnchor(visual, prevAnchor);
      if (visual !== nextVisual) cc625ClearEndpointAnchor(visual, nextAnchor);
    });
    wrap._cc625PrevVisual = firstVisual;
    wrap._cc625NextVisual = nextVisual;

    viewport.style.setProperty('anchor-name', viewportAnchor);
    /* v2.15.673 — a one-listing shelf (Flash Sale) uses the same listing as
       both endpoints. anchor-name takes a list, so both names have to be set
       together; setting them one after the other would drop the first and
       leave that arrow with no anchor to measure from. */
    const cc673SharedEndpoint = firstVisual === nextVisual;
    firstVisual.style.setProperty(
      'anchor-name',
      cc673SharedEndpoint && !cc647SharedPhoneY ? `${prevAnchor}, ${nextAnchor}` : prevAnchor
    );
    if (!cc647SharedPhoneY && !cc673SharedEndpoint) nextVisual.style.setProperty('anchor-name', nextAnchor);

    /* no endpoint shadow proxy. The real card shadow is allowed
       to fade naturally inside the larger shared safety gutter. */

    /* Keep one shared gap variable for New Arrivals / Best Sellers / Flash
       Sale. CSS media queries may reduce it on small screens, but both sides of
       every shelf always use the same value. */
    const finalLift = Number.parseFloat(
      getComputedStyle(document.documentElement).getPropertyValue('--cc290-card-hover-lift')
    ) || -5;
    /* Phone cards do not sit in the desktop -5px hover-lift position. Both
       arrows therefore target the literal centre of the visible image box. */
    const arrowLift = cc647SharedPhoneY ? 0 : finalLift;

    [prev, next].forEach((button) => {
      button.style.setProperty('position', 'absolute', 'important');
      button.style.setProperty('display', 'grid', 'important');
      button.style.setProperty('place-items', 'center', 'important');
      button.style.setProperty('visibility', 'visible', 'important');
      button.style.setProperty('z-index', '220', 'important');
      button.style.setProperty('right', 'auto', 'important');
      button.style.setProperty('bottom', 'auto', 'important');
      button.style.setProperty('transform', 'translate3d(0,-50%,0)', 'important');
      button.style.setProperty('transition-property', 'box-shadow, background-color, border-color, color, opacity', 'important');
    });

    /* Horizontal geometry is anchored to the stationary shelf wrapper edge.
       Keeping both controls inside the same wrapper avoids left/right
       sub-pixel rounding drift at browser zoom levels. */
    /* v2.15.673 — New Arrivals / Best Sellers fill their wrapper, so measuring
       from the wrapper edge already lands the arrow beside the first listing.
       The Flash Sale shows one centred listing in a full-width wrapper, so the
       same measurement parked its arrows at the far edges of the page. It
       measures from the listing itself instead, using the shared gap. */
    const cc673CardAnchoredArrows = Boolean(wrap.closest('.cc-hot-deals-section'))
      && !wrap.classList.contains('cc-swipe');
    if (cc673CardAnchoredArrows) {
      const cc673Gap = cc673ShelfArrowGap();
      prev.style.setProperty(
        'left',
        `calc(anchor(${prevAnchor} left) - ${cc673Gap}px - var(--cc625-home-arrow-size, 34px))`,
        'important'
      );
      /* Flash Sale desktop/tablet: the next arrow sits beside the LAST SLOT of
         the page, not the last listing on it. A final page with fewer listings
         (e.g. 1 of 3) therefore keeps both arrows exactly where they were.
         Layout offsets are used (not getBoundingClientRect) so the scroll
         reveal scale and hover lift cannot skew the measurement. */
      const cc680Cards = getCards(track);
      const cc680Count = pageSize(track);
      const cc680Visual = cc680Cards[0]?.querySelector('.full-bottle-strip-visual');
      /* Computed (fractional) widths, so the span matches the anchor exactly. */
      const cc680CardWidth = cc680Cards[0] ? Number.parseFloat(getComputedStyle(cc680Cards[0]).width) : 0;
      const cc680VisualWidth = cc680Visual ? Number.parseFloat(getComputedStyle(cc680Visual).width) : 0;
      const cc680GapValue = Number.parseFloat(getComputedStyle(track).columnGap);
      const cc680Pitch = cc680CardWidth + (Number.isFinite(cc680GapValue) ? cc680GapValue : 0);
      const cc680FixedSlots = !cc647SharedPhoneY && cc680Count > 1 && cc680Cards.length > cc680Count
        && cc680CardWidth > 0 && cc680VisualWidth > 0;
      if (cc680FixedSlots) {
        const cc680Span = (cc680Count - 1) * cc680Pitch + cc680VisualWidth;
        next.style.setProperty(
          'left',
          `calc(anchor(${prevAnchor} left) + ${cc680Span}px + ${cc673Gap}px)`,
          'important'
        );
      } else {
        next.style.setProperty(
          'left',
          `calc(anchor(${cc647SharedPhoneY ? prevAnchor : nextAnchor} right) + ${cc673Gap}px)`,
          'important'
        );
      }
    } else {
      prev.style.setProperty(
        'left',
        'var(--cc670-home-arrow-edge)',
        'important'
      );
      next.style.setProperty(
        'left',
        'calc(100% - var(--cc625-home-arrow-size, 34px) - var(--cc670-home-arrow-edge))',
        'important'
      );
    }

    /* Vertical geometry is the exact centre of each endpoint IMAGE/hover box
       after its final hover lift. The visual itself never moves, so the arrows
       remain perfectly static while the image shell animates. */
    prev.style.setProperty('top', `calc(anchor(${prevAnchor} center) + ${arrowLift}px)`, 'important');
    next.style.setProperty('top', `calc(anchor(${cc647SharedPhoneY ? prevAnchor : nextAnchor} center) + ${arrowLift}px)`, 'important');
    /* v2.16.27 — cc703: phones use the one fixed arrow line. */
    window.CC703RailArrowTop?.apply(wrap);

    /* v2.15.627: geometry owns position only. Do NOT write opacity or
       pointer-events inline here. Those are stateful properties and must be
       controlled by the button's disabled attribute + CSS so an arrow can
       reliably return from grey/disabled to active on the next page. */
    prev.style.removeProperty('opacity');
    prev.style.removeProperty('pointer-events');
    next.style.removeProperty('opacity');
    next.style.removeProperty('pointer-events');
    return true;
  };

  const syncArrowGeometry = (wrap, force = false) => {
    if (!wrap) return;
    const prev = wrap.querySelector('[data-cc246-prev]');
    const next = wrap.querySelector('[data-cc246-next]');
    const track = wrap.querySelector('[data-cc246-row]');
    const viewport = wrap.querySelector('[data-cc246-viewport]') || wrap;
    if (!prev || !next || !track || !viewport) return;
    if (track.hasAttribute('data-random-home-shelf') && track.dataset.randomShelfReady !== 'true') return;

    const cards = getCards(track);
    if (!cards.length) return;
    const count = pageSize(track);
    const page = Number.parseInt(wrap.dataset.cc246Page || '0', 10) || 0;
    const phoneHome = cc649IsPhoneHome(wrap);
    const phoneFlash = cc646IsPhoneFlash(wrap);
    const startIndex = phoneHome && !phoneFlash
      ? cc650PhonePairStart(cards, page)
      : Math.max(0, page * count);
    const pageCards = cards.slice(startIndex, Math.min(cards.length, startIndex + count));
    let firstCard = pageCards[0] || cards[0];
    let lastCard = pageCards[pageCards.length - 1] || cards[cards.length - 1];
    /* v2.15.673 — the Flash Sale stacks its listings in one cell, and the
       stacked cards are not all the same height. Measure against the listing
       that is actually visible so the arrows sit on its centre line. */
    if (phoneFlash) {
      const activeCard = cards.find((card) => card.classList.contains('cc647-flash-active'));
      if (activeCard) {
        firstCard = activeCard;
        lastCard = activeCard;
      }
    }

    if (cc625AnchorSupported && cc625AssignAnchorGeometry(wrap, prev, next, track, viewport, firstCard, lastCard)) {
      wrap.dataset.cc608ArrowGeometryLocked = 'true';
      wrap.dataset.cc612ArrowGeometrySettled = 'true';
      wrap.dataset.cc616ArrowVisible = 'true';
      wrap.dataset.cc624ArrowReady = 'true';
      wrap.dataset.cc625ArrowAnchored = 'true';
      return;
    }

    /* Conservative fallback for browsers without CSS anchor positioning.
       This is not used by current Chrome, but preserves basic behaviour. */
    const firstStage = firstCard?.querySelector('.full-bottle-strip-image-stage');
    const lastStage = lastCard?.querySelector('.full-bottle-strip-image-stage');
    if (!firstStage || !lastStage) return;
    const wrapRect = wrap.getBoundingClientRect();
    const prevWidth = prev.getBoundingClientRect().width || 34;
    const phoneSharedY = window.matchMedia?.('(max-width: 640px)').matches;
    const phoneFirstRect = firstStage.getBoundingClientRect();
    const prevTop = phoneSharedY
      ? (phoneFirstRect.top + phoneFirstRect.height / 2 - wrapRect.top)
      : (cc614HomeFinalStageCenterY(firstStage) - wrapRect.top);
    const nextTop = phoneSharedY
      ? prevTop
      : (cc614HomeFinalStageCenterY(lastStage) - wrapRect.top);
    const edge = cc670HomeArrowEdge();
    const nextWidth = next.getBoundingClientRect().width || prevWidth;
    const prevLeft = edge;
    const nextLeft = wrapRect.width - nextWidth - edge;

    [prev, next].forEach((button) => {
      button.style.setProperty('position', 'absolute', 'important');
      button.style.setProperty('display', 'grid', 'important');
      button.style.setProperty('place-items', 'center', 'important');
      button.style.setProperty('visibility', 'visible', 'important');
      button.style.setProperty('z-index', '220', 'important');
      button.style.setProperty('transform', 'translate3d(0,-50%,0)', 'important');
    });
    if (Number.isFinite(prevTop)) prev.style.setProperty('top', `${prevTop}px`, 'important');
    if (Number.isFinite(nextTop)) next.style.setProperty('top', `${nextTop}px`, 'important');
    window.CC703RailArrowTop?.apply(wrap);
    if (Number.isFinite(prevLeft)) prev.style.setProperty('left', `${prevLeft}px`, 'important');
    if (Number.isFinite(nextLeft)) next.style.setProperty('left', `${nextLeft}px`, 'important');
    prev.style.setProperty('right', 'auto', 'important');
    next.style.setProperty('right', 'auto', 'important');
    wrap.dataset.cc624ArrowReady = 'true';
  };

  /* no asynchronous geometry settling is required in browsers
     with native anchor positioning. The anchor relationship remains live and
     is recalculated by layout itself before paint whenever dimensions change. */
  const settleArrowGeometry = (wrap, { force = false } = {}) => {
    if (!wrap) return;
    const track = wrap.querySelector('[data-cc246-row]');
    if (!track) return;
    if (track.hasAttribute('data-random-home-shelf') && track.dataset.randomShelfReady !== 'true') return;
    syncArrowGeometry(wrap, true);
  };

  /* homepage arrows stay static at final-hover endpoint centre. */

  const cc660SetPhoneCardState = (card, active, mode) => {
    if (!card) return;
    /* v2.15.671 — on phones the shelves are finger-scrollable rails
       (cc-momentum.js marks the wrap .cc-swipe). Every card in a rail must
       stay visible and reachable, so the older "hide all but the active
       card" bookkeeping is skipped there, and anything it set earlier —
       while the rail was still being set up — is cleared. */
    if (card.closest('[data-cc246-wrap].cc-swipe')) {
      card.classList.remove('cc647-flash-active', 'cc650-phone-pair-active', 'cc650-phone-pair-hidden');
      card.removeAttribute('aria-hidden');
      if ('inert' in card) card.inert = false;
      return;
    }
    if (mode === 'flash') {
      card.classList.toggle('cc647-flash-active', active);
    } else {
      card.classList.toggle('cc650-phone-pair-active', active);
      card.classList.toggle('cc650-phone-pair-hidden', !active);
    }
    /* v2.15.666 — only a card the shopper genuinely cannot see may be inert.
       In 'flash' mode the non-active cards stay visible in a scrollable row,
       and marking those inert made every control on the card ignore taps
       (buttons AND the product link). Decide from what is actually rendered
       rather than from the active flag, so this stays correct if the phone
       shelf CSS changes. */
    let hidden = false;
    if (!active) {
      const view = window.getComputedStyle(card);
      hidden = view.display === 'none' || view.visibility === 'hidden' || Number(view.opacity) < 0.05;
    }
    card.setAttribute('aria-hidden', hidden ? 'true' : 'false');
    if ('inert' in card) card.inert = hidden;
  };

  const cc647ApplyPhoneFlashCard = (wrap, track, cards, page) => {
    const next = cards[page] || cards[0] || null;
    if (!wrap._cc660FlashInitialized) {
      cards.forEach((card) => cc660SetPhoneCardState(card, card === next, 'flash'));
      wrap._cc660FlashInitialized = true;
    } else {
      const previous = wrap._cc660FlashActive || null;
      if (previous && previous !== next) cc660SetPhoneCardState(previous, false, 'flash');
      if (next && previous !== next) cc660SetPhoneCardState(next, true, 'flash');
    }
    wrap._cc660FlashActive = next;
    track.style.setProperty('transition', 'none');
    track.style.setProperty('transform', 'none');
    requestAnimationFrame(() => syncArrowGeometry(wrap, true));
  };

  const cc650ApplyPhonePair = (wrap, track, cards, page) => {
    const phoneCards = cc652PhoneShelfCards(wrap, track);
    const start = cc650PhonePairStart(phoneCards, page);
    const nextActive = phoneCards.slice(start, Math.min(phoneCards.length, start + 2));

    if (!wrap._cc660PairInitialized) {
      const nextSet = new Set(nextActive);
      cards.forEach((card) => cc660SetPhoneCardState(card, nextSet.has(card), 'pair'));
      wrap._cc660PairInitialized = true;
    } else {
      const previous = wrap._cc660PairActive || [];
      previous.forEach((card) => {
        if (!nextActive.includes(card)) cc660SetPhoneCardState(card, false, 'pair');
      });
      nextActive.forEach((card) => {
        if (!previous.includes(card)) cc660SetPhoneCardState(card, true, 'pair');
      });
    }

    wrap._cc660PairActive = nextActive;
    track.style.setProperty('transition', 'none');
    track.style.setProperty('transform', 'none');
    requestAnimationFrame(() => syncArrowGeometry(wrap, true));
  };

  const setPage = (wrap, requestedPage, { animate = true } = {}) => {
    const track = wrap.querySelector('[data-cc246-row]');
    if (!track) return;
    const phoneHome = cc649IsPhoneHome(wrap);
    const phoneFlash = cc646IsPhoneFlash(wrap);
    const cards = getCards(track);
    const phoneShelfCards = phoneHome && !phoneFlash ? cc652PhoneShelfCards(wrap, track) : cards;
    /* phone page count is explicit and finite.
       New Arrivals / Best Sellers use exactly 8 mobile products, 2-up = 4 pages.
       Flash Sale stays 1-up. Desktop/tablet continue using the full rail. */
    const pages = phoneHome
      ? (phoneFlash ? Math.max(1, cards.length) : Math.max(1, Math.ceil(phoneShelfCards.length / 2)))
      : totalPages(track);
    const page = Math.max(0, Math.min(pages - 1, requestedPage));
    const previousPage = Number.parseInt(wrap.dataset.cc246Page || '0', 10) || 0;
    const prev = wrap.querySelector('[data-cc246-prev]');
    const next = wrap.querySelector('[data-cc246-next]');
    const viewport = wrap.querySelector('[data-cc246-viewport]');
    const noPaging = pages <= 1;

    wrap.dataset.cc246Page = String(page);
    wrap.classList.toggle('has-no-paging', noPaging);
    if (prev) prev.disabled = noPaging || page === 0;
    if (next) next.disabled = noPaging || page === pages - 1;

    /* every PHONE homepage shelf changes pages through one calm
       fade. New Arrivals / Best Sellers jump exactly two cards per page;
       Flash Sale swaps one stacked card. No neighbouring listing travels
       across the viewport, so nothing can clip against or collide with arrows. */
    if (phoneHome) {
      const current = Number.parseInt(wrap.dataset.cc649RenderedPage || '-1', 10);
      if (wrap._cc649FadeTimer) {
        window.clearTimeout(wrap._cc649FadeTimer);
        wrap._cc649FadeTimer = 0;
      }

      const apply = () => {
        if (phoneFlash) cc647ApplyPhoneFlashCard(wrap, track, cards, page);
        else cc650ApplyPhonePair(wrap, track, cards, page);
        wrap.dataset.cc649RenderedPage = String(page);
      };

      const clearFadeClasses = () => {
        viewport?.classList.remove(
          'cc649-phone-shelf-fade-out',
          'cc650-phone-shelf-fade-out',
          'cc650-fade-next',
          'cc650-fade-prev'
        );
      };

      if (!animate || !motionOK() || current < 0 || current === page || !viewport) {
        clearFadeClasses();
        apply();
        return;
      }

      /* lightweight asymmetric phone crossfade.
         No blur, saturation, mask or gradient repaint. The current page exits
         quickly, the pair is switched while invisible, then the new page eases
         back in. This is substantially cheaper on iOS and keeps the interaction
         responsive without exposing neighbouring listings. */
      clearFadeClasses();
      viewport.classList.add('cc653-phone-shelf-fade-out');
      wrap._cc649FadeTimer = window.setTimeout(() => {
        apply();
        requestAnimationFrame(() => {
          viewport.classList.remove('cc653-phone-shelf-fade-out');
        });
        wrap._cc649FadeTimer = 0;
      }, 105);
      return;
    }

    /* Leaving phone mode must restore every card to the normal desktop/tablet rail. */
    cards.forEach((card) => {
      card.classList.remove('cc647-flash-active', 'cc650-phone-pair-active', 'cc650-phone-pair-hidden');
      card.removeAttribute('aria-hidden');
      if ('inert' in card) card.inert = false;
    });
    wrap._cc660PairInitialized = false;
    wrap._cc660PairActive = [];
    wrap._cc660FlashInitialized = false;
    wrap._cc660FlashActive = null;

    const targetOffset = pageOffset(track, page);
    /* Flash Sale pages (desktop/tablet) use the same dissolve as New Arrivals /
       Best Sellers now that it can hold more bundles than fit on one page. */
    const isStandardHomeShelf = Boolean(wrap.closest('.product-section-home'));

    /* v2.15.668: New Arrivals + Best Sellers use the same slow dissolve as the
       PDP shelves, but the snap is recalculated at the exact swap frame. This
       avoids stale offsets after Shopify editor resizing / browser zoom and
       guarantees the rail lands on a real card boundary. */
    if (isStandardHomeShelf && viewport) {
      if (wrap._cc667HomeFadeTimer) window.clearTimeout(wrap._cc667HomeFadeTimer);
      if (wrap._cc667HomeCleanupTimer) window.clearTimeout(wrap._cc667HomeCleanupTimer);

      const direction = Math.sign(page - previousPage) || 1;
      const applyExactPage = () => {
        /* Re-measure now, not 240ms earlier. A theme-preview resize or changed
           scrollbar width during the fade can otherwise leave a fractional
           card peeking at one edge. Snap to the nearest physical pixel. */
        const measured = pageOffset(track, page);
        const dpr = Math.max(1, window.devicePixelRatio || 1);
        const exactOffset = Math.round(measured * dpr) / dpr;
        track.style.transition = 'none';
        track.style.transform = `translate3d(${-exactOffset}px,0,0)`;
        wrap.dataset.cc667RenderedPage = String(page);
        requestAnimationFrame(() => syncArrowGeometry(wrap, true));
      };
      const clearDesktopFade = () => {
        viewport.classList.remove('cc667-home-shelf-fade-out');
        wrap.classList.remove('cc667-home-shelf-transitioning','cc667-home-shelf-next','cc667-home-shelf-prev');
      };

      const renderedPage = Number.parseInt(wrap.dataset.cc667RenderedPage || '-1', 10);
      if (!animate || !motionOK() || renderedPage < 0 || renderedPage === page) {
        clearDesktopFade();
        applyExactPage();
        return;
      }

      clearDesktopFade();
      wrap.classList.add('cc667-home-shelf-transitioning', direction > 0 ? 'cc667-home-shelf-next' : 'cc667-home-shelf-prev');
      viewport.classList.add('cc667-home-shelf-fade-out');

      wrap._cc667HomeFadeTimer = window.setTimeout(() => {
        applyExactPage();
        requestAnimationFrame(() => requestAnimationFrame(() => {
          viewport.classList.remove('cc667-home-shelf-fade-out');
        }));
        wrap._cc667HomeCleanupTimer = window.setTimeout(() => {
          wrap.classList.remove('cc667-home-shelf-transitioning','cc667-home-shelf-next','cc667-home-shelf-prev');
          syncArrowGeometry(wrap, true);
          wrap._cc667HomeCleanupTimer = 0;
        }, 560);
        wrap._cc667HomeFadeTimer = 0;
      }, 240);
      return;
    }

    /* Flash Sale and other non-standard shelves keep their existing motion. */
    const cc674Animated = animate && motionOK();
    track.style.transition = cc674Animated
      ? 'transform 620ms cubic-bezier(.16,1,.3,1)'
      : 'none';
    track.style.transform = `translate3d(${-targetOffset}px,0,0)`;

    /* v2.15.674 — RE-ANCHOR THE FLASH SALE ARROWS ON EVERY PAGE CHANGE.
       Since v2.15.673 the Flash Sale controls are anchored to the listing that
       is actually on screen, not to the shelf wrapper. Every other branch of
       setPage already re-runs the geometry pass, but this one did not, so the
       rail moved to the new page while both controls stayed attached to the
       previous page's cards: the previous control travelled off-screen and the
       next control came to rest on top of the visible bundle. It only showed
       up under 981px, because at desktop width all three bundles sit on one
       page and the arrows never have a page to change to. */
    if (wrap._cc674ArrowSettleTimer) {
      window.clearTimeout(wrap._cc674ArrowSettleTimer);
      wrap._cc674ArrowSettleTimer = 0;
    }
    requestAnimationFrame(() => syncArrowGeometry(wrap, true));
    if (cc674Animated) {
      /* One more pass once the 620ms rail motion has finished, so the resting
         position is measured against the settled layout. */
      wrap._cc674ArrowSettleTimer = window.setTimeout(() => {
        wrap._cc674ArrowSettleTimer = 0;
        syncArrowGeometry(wrap, true);
      }, 660);
    }
  };

  const stopIntro = (wrap) => {
    (wrap._cc246Timers || []).forEach((id) => window.clearTimeout(id));
    wrap._cc246Timers = [];

    const track = wrap.querySelector('[data-cc246-row]');
    if (track && wrap.classList.contains('is-intro-sweeping')) {
      /* Freeze the rail at its exact rendered position before normal paging takes
         over. This prevents a mid-sweep cancel from snapping to either endpoint. */
      const renderedTransform = getComputedStyle(track).transform;
      track.style.transition = 'none';
      if (renderedTransform && renderedTransform !== 'none') track.style.transform = renderedTransform;
      void track.offsetWidth;
    }

    wrap.classList.remove('is-intro-sweeping');
  };

  /* reliable style homepage-return shelf whip.
     The old effect was not a normal refresh intro: it appeared when the homepage
     was restored after visiting another page. Recreate that behavior explicitly,
     using one fast continuous transform and retaining the exact final transform.

     New Arrivals: end (24) -> start (1).
     Best Sellers: start (1) -> end (24).
     No intermediate page stops and no post-animation correction. */
  const runReturnSweep = (wrap) => {
    if (!motionOK()) return;
    const track = wrap.querySelector('[data-cc246-row]');
    if (!track || track.dataset.randomShelfReady !== 'true') return;

    const pages = totalPages(track);
    if (pages <= 1) return;

    stopIntro(wrap);

    const lastPage = pages - 1;
    const kind = String(track.dataset.homeShelfKind || '').toLowerCase();
    const isBestSellers = kind.includes('best');
    const startPage = isBestSellers ? 0 : lastPage;
    const endPage = isBestSellers ? lastPage : 0;
    const startX = -pageOffset(track, startPage);
    const endX = -pageOffset(track, endPage);

    /* Close to the native quick smooth-scroll feel that was visible in 2.15.245.
       Intentionally much faster than the later dedicated intro sweeps. */
    const sweepDuration = 400;

    wrap.dataset.cc246Page = String(startPage);
    syncArrowGeometry(wrap);
    wrap.classList.add('is-intro-sweeping');
    wrap._cc246Timers = [];

    /* Establish the start position before the browser paints the return frame. */
    track.style.transition = 'none';
    track.style.transform = `translate3d(${startX}px,0,0)`;
    void track.offsetWidth;

    requestAnimationFrame(() => {
      if (!wrap.classList.contains('is-intro-sweeping')) return;
      requestAnimationFrame(() => {
        if (!wrap.classList.contains('is-intro-sweeping')) return;
        track.style.transition = `transform ${sweepDuration}ms cubic-bezier(.2,.78,.24,1)`;
        track.style.transform = `translate3d(${endX}px,0,0)`;

        const finish = () => {
          if (!wrap.classList.contains('is-intro-sweeping')) return;
          track.style.transition = 'none';
          /* Keep the identical transform value used by normal paging. */
          track.style.transform = `translate3d(${endX}px,0,0)`;
          wrap.dataset.cc246Page = String(endPage);
          wrap.classList.remove('is-intro-sweeping');

          const prev = wrap.querySelector('[data-cc246-prev]');
          const next = wrap.querySelector('[data-cc246-next]');
          if (prev) prev.disabled = endPage === 0;
          if (next) next.disabled = endPage === pages - 1;
          syncArrowGeometry(wrap);
        };

        const timer = window.setTimeout(finish, sweepDuration + 18);
        wrap._cc246Timers.push(timer);
      });
    });
  };

  /* robust homepage-return detection.
     Shopify/browser navigation does not always restore the page through a
     persisted pageshow event, so relying on event.persisted/back_forward alone
     can suppress the sweep entirely. Arm the sweep when the shopper leaves the
     homepage through an internal link, and also recognize an internal referrer
     when the homepage is loaded again normally. */
  const RETURN_SWEEP_KEY = 'cc-home-return-whip';
  let returnSweepPending = false;
  let returnSweepRan = false;

  const normalizedPath = (value) => {
    const path = String(value || '/').replace(/\/+$/, '');
    return path || '/';
  };

  const navigationType = () => {
    try { return performance.getEntriesByType?.('navigation')?.[0]?.type || ''; } catch (_) { return ''; }
  };

  const hasArmedReturn = () => {
    try { return sessionStorage.getItem(RETURN_SWEEP_KEY) === '1'; } catch (_) { return false; }
  };

  const armReturnSweep = () => {
    try { sessionStorage.setItem(RETURN_SWEEP_KEY, '1'); } catch (_) {}
  };

  const clearReturnSweep = () => {
    try { sessionStorage.removeItem(RETURN_SWEEP_KEY); } catch (_) {}
  };

  const cameFromInternalPage = () => {
    if (!document.referrer) return false;
    try {
      const ref = new URL(document.referrer);
      if (ref.origin !== window.location.origin) return false;
      return normalizedPath(ref.pathname) !== normalizedPath(window.location.pathname);
    } catch (_) { return false; }
  };

  const isHomepageReturn = (event) => {
    if (event?.persisted) return true;
    if (navigationType() === 'back_forward') return true;
    if (hasArmedReturn()) return true;
    if (cameFromInternalPage()) return true;
    return false;
  };

  /* Arm before normal internal navigation away from the homepage. This survives
     BFCache as well as a full Shopify page reload when the shopper comes back. */
  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('a[href]');
    if (!link || link.target === '_blank' || link.hasAttribute('download')) return;
    try {
      const url = new URL(link.href, window.location.href);
      if (url.origin !== window.location.origin) return;
      if (normalizedPath(url.pathname) === normalizedPath(window.location.pathname)) return;
      armReturnSweep();
    } catch (_) {}
  }, true);

  const runPendingReturnSweep = () => {
    if (!returnSweepPending || returnSweepRan) return;
    const wraps = qsa(document, '[data-cc246-wrap]');
    if (!wraps.length) return;
    const readyWraps = wraps.filter((wrap) => wrap.querySelector('[data-cc246-row]')?.dataset.randomShelfReady === 'true');
    if (readyWraps.length !== wraps.length) return;

    returnSweepRan = true;
    returnSweepPending = false;
    clearReturnSweep();

    /* Let the final randomized DOM order paint once, then launch both whips in
       the same frame. This is what makes the movement visible and reliable. */
    requestAnimationFrame(() => requestAnimationFrame(() => {
      readyWraps.forEach((wrap) => {
        syncArrowGeometry(wrap);
        runReturnSweep(wrap);
      });
    }));
  };

  const ready = (wrap, { intro = false } = {}) => {
    requestAnimationFrame(() => {
      if (!wrap.classList.contains('is-intro-sweeping')) {
        if (cc646IsPhoneFlash(wrap)) {
          const track = wrap.querySelector('[data-cc246-row]');
          const stored = Number.parseInt(wrap.dataset.cc246Page || '', 10);
          const page = wrap.dataset.cc646FlashPhoneInitialized === 'true' && Number.isFinite(stored)
            ? stored
            : cc646FlashCenterIndex(track);
          wrap.dataset.cc646FlashPhoneInitialized = 'true';
          setPage(wrap, page, { animate: false });
        } else {
          delete wrap.dataset.cc646FlashPhoneInitialized;
          setPage(wrap, 0, { animate: false });
        }
      }
      settleArrowGeometry(wrap);
      runPendingReturnSweep();
    });
  };

  /* no image-load / ResizeObserver coordinate rewrites.
     Those callbacks were the source of late sideways/vertical kicks. Initial
     load and browser zoom each have one dedicated settled geometry pass. */
  const bindArrowResync = (wrap, track) => {
    if (!wrap || !track || wrap._cc246ArrowBindDone) return;
    wrap._cc246ArrowBindDone = true;
  };

  const initWrap = (wrap) => {
    if (!wrap || wrap.dataset.cc246Ready === 'true') return;
    wrap.dataset.cc246Ready = 'true';
    const track = wrap.querySelector('[data-cc246-row]');
    const prev = wrap.querySelector('[data-cc246-prev]');
    const next = wrap.querySelector('[data-cc246-next]');
    if (!track || !prev || !next) return;
    bindArrowResync(wrap, track);
    /* Phones now scroll these shelves natively (see "Phone shelf swiping" in
       cc-momentum.js), so the old one-page-per-flick gesture is no longer bound. */

    prev.addEventListener('click', (event) => {
      event.preventDefault(); event.stopPropagation();
      stopIntro(wrap);
      const current = Number.parseInt(wrap.dataset.cc246Page || '0', 10) || 0;
      setPage(wrap, current - 1, { animate: true });
    });
    next.addEventListener('click', (event) => {
      event.preventDefault(); event.stopPropagation();
      stopIntro(wrap);
      const current = Number.parseInt(wrap.dataset.cc246Page || '0', 10) || 0;
      setPage(wrap, current + 1, { animate: true });
    });

    /* Pointer clicks must not leave browser focus/active styling behind. */
    [prev, next].forEach((button) => {
      button.addEventListener('pointerup', () => {
        requestAnimationFrame(() => {
          if (document.activeElement === button) button.blur();
        });
      }, { passive: true });
    });

    const observer = new MutationObserver(() => {
      /* Random-shelf mutations can land in the same frame as the intro event.
         Never let that housekeeping reset interrupt the continuous sweep. */
      if (wrap.classList.contains('is-intro-sweeping')) return;
      ready(wrap, { intro: false });
    });
    observer.observe(track, { childList: true, attributes: true, attributeFilter: ['hidden'] });
    /* Normal loads stay still. The fast 2.15.245-style whip belongs to
       history return, not refresh/first load. */
    ready(wrap, { intro: false });
  };

  const init = (root = document) => qsa(root, '[data-cc246-wrap]').forEach(initWrap);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);

  document.addEventListener('cc:home-shelf-ready', (event) => {
    const wrap = event.target.closest?.('[data-cc246-wrap]');
    if (!wrap) return;
    delete wrap.dataset.cc608ArrowGeometryLocked;
    delete wrap.dataset.cc612ArrowGeometrySettled;
    ready(wrap, { intro: false });
  });
  document.addEventListener('shopify:section:load', (event) => init(event.target));

  /* v2.15.624 safety passes: randomization may cancel an earlier token in the
     same startup frame. These calls use the same one-shot geometry path and are
     harmless once the shelf is already stable. */
  const cc624SettleAll = () => qsa(document, '[data-cc246-wrap]').forEach((wrap) => settleArrowGeometry(wrap));
  window.addEventListener('load', cc624SettleAll, { once: true });
  window.setTimeout(cc624SettleAll, 180);
  window.setTimeout(cc624SettleAll, 520);

  /* Match the old v2.15.245 moment: returning from a category/product page.
     Queue the whip even if Shopify gives us a normal load instead of BFCache. */
  window.addEventListener('pageshow', (event) => {
    if (!isHomepageReturn(event)) return;
    returnSweepPending = true;
    runPendingReturnSweep();
    /* Random shelf selection may finish just after pageshow. */
    window.setTimeout(runPendingReturnSweep, 40);
    window.setTimeout(runPendingReturnSweep, 120);
  });

  /* A full navigation back to / can finish DOMContentLoaded before pageshow.
     Pre-arm from referrer/session state so cc:home-shelf-ready can launch it. */
  if (hasArmedReturn() || navigationType() === 'back_forward' || cameFromInternalPage()) {
    returnSweepPending = true;
  }

  let resizeTimer = 0;
  window.addEventListener('resize', () => {
    window.clearTimeout(resizeTimer);
    /* phone Flash Sale uses exact card offsets, so a real viewport
       resize/orientation change re-applies the CURRENT card offset once. This
       keeps the same listing centred without the old width-estimate drift. */
    resizeTimer = window.setTimeout(() => qsa(document, '[data-cc246-wrap]').forEach((wrap) => {
      stopIntro(wrap);
      if (cc649IsPhoneHome(wrap)) {
        const current = Number.parseInt(wrap.dataset.cc246Page || '', 10);
        const track = wrap.querySelector('[data-cc246-row]');
        const fallback = cc646IsPhoneFlash(wrap) ? cc646FlashCenterIndex(track) : 0;
        const page = Number.isFinite(current) ? current : fallback;
        if (cc646IsPhoneFlash(wrap)) wrap.dataset.cc646FlashPhoneInitialized = 'true';
        setPage(wrap, page, { animate: false });
      } else {
        const current = Number.parseInt(wrap.dataset.cc246Page || '0', 10) || 0;
        if (wrap.dataset.cc646FlashPhoneInitialized === 'true') {
          delete wrap.dataset.cc646FlashPhoneInitialized;
          delete wrap.dataset.cc649RenderedPage;
        }
        /* v2.15.668: a real desktop resize/zoom changes card width, so the old
           transform cannot be trusted. Recompute the CURRENT page offset once. */
        setPage(wrap, current, { animate: false });
      }
      syncArrowGeometry(wrap, true);
    }), 100);
  }, { passive: true });
})();

/* pointer clicks must never leave a listing action with retained
   focus after the pointer interaction. Keyboard focus remains untouched because
   pointerup is not emitted by keyboard activation. */
(() => {
  const selector = '.listing-wishlist-button, .listing-share-button, .listing-hover-add';
  document.addEventListener('pointerup', (event) => {
    const action = event.target.closest?.(selector);
    if (!action) return;
    window.requestAnimationFrame(() => {
      if (document.activeElement === action) action.blur();
    });
  }, { passive: true });
})();

/* unified clipped-row hover underlay.
   v2.15.356 animated the row itself and the real shell/scrollbar gutters using
   two different painting paths (background-color vs registered color gradient).
   At a clipped top/bottom edge Chromium could make the gutter read faster even
   with the same nominal duration.  One persistent underlay now paints only the
   *visible* row intersection and fades with ordinary opacity. */
(() => {
  /* .ccs-* = header search results, so they get the exact same hover as cart + wishlist rows. */
  const ROW_SELECTOR = '.header-cart-preview .cart-preview-item, .header-wishlist-preview .wishlist-preview-item, .ccs-list .ccs-row';
  const SHELL_SELECTOR = '.cc324-drawer-scroll-shell, .ccs-card';
  const SCROLLER_SELECTOR = '.cart-preview-items, .wishlist-preview-items, .ccs-body';
  const activeRows = new WeakMap();

  const ensureWash = (shell) => {
    if (!shell) return null;
    let wash = shell.querySelector(':scope > .cc357-hover-wash');
    if (!wash) {
      wash = document.createElement('span');
      wash.className = 'cc357-hover-wash';
      wash.setAttribute('aria-hidden', 'true');
      shell.prepend(wash);
    }
    return wash;
  };

  const installWashes = (root = document) => {
    root.querySelectorAll?.(SHELL_SELECTOR).forEach(ensureWash);
  };

  const hideWash = (shell) => {
    const wash = ensureWash(shell);
    if (!wash) return;
    wash.classList.remove('is-visible');
  };

  const syncWash = (row, reveal = true) => {
    if (!row?.isConnected) return;
    const scroller = row.closest(SCROLLER_SELECTOR);
    const shell = row.closest(SHELL_SELECTOR);
    if (!scroller || !shell) return;

    const wash = ensureWash(shell);
    if (!wash) return;

    const rowRect = row.getBoundingClientRect();
    const scrollerRect = scroller.getBoundingClientRect();
    const shellRect = shell.getBoundingClientRect();

    /* Only paint the portion of the row that is actually visible in the
       scroller.  This is the key fix for rows cut by the top/bottom curve. */
    const visibleTop = Math.max(rowRect.top, scrollerRect.top);
    const visibleBottom = Math.min(rowRect.bottom, scrollerRect.bottom);
    if (visibleBottom <= visibleTop) {
      hideWash(shell);
      return;
    }

    const touchesTop = rowRect.top <= scrollerRect.top + 0.75;
    const touchesBottom = rowRect.bottom >= scrollerRect.bottom - 0.75;

    let top = visibleTop - shellRect.top;
    let bottom = visibleBottom - shellRect.top;

    /* If the hovered row is the currently clipped edge row, extend the same
       wash through the shell's real 9px breathing room so the rounded edge and
       scrollbar lane animate as one surface. */
    if (touchesTop) top = 0;
    if (touchesBottom) bottom = shellRect.height;

    top = Math.max(0, Math.min(shellRect.height, top));
    bottom = Math.max(top, Math.min(shellRect.height, bottom));

    wash.style.top = `${top.toFixed(2)}px`;
    wash.style.height = `${Math.max(0, bottom - top).toFixed(2)}px`;
    activeRows.set(shell, row);

    if (reveal) wash.classList.add('is-visible');
  };

  const rowStillActive = (row) => row?.matches?.(':hover') || row?.contains?.(document.activeElement);

  installWashes();

  /* Header drawers can rerender their row contents; the shell normally stays
     mounted, but this keeps the underlay guaranteed without touching layout. */
  /* When a row is removed in place (fast cart / wishlist removals) the next
     row slides under a still pointer without a pointerover, so re-aim the wash
     at whatever row is now under the pointer, or hide it. */
  let lastPointer = null;
  document.addEventListener('pointermove', (event) => {
    lastPointer = event.pointerType === 'touch' ? null : { x: event.clientX, y: event.clientY };
  }, { passive: true });
  const reaimShells = new Set();
  let reaimFrame = 0;
  const reaimWashes = () => {
    reaimFrame = 0;
    reaimShells.forEach((shell) => {
      if (!shell.isConnected) return;
      const under = lastPointer ? document.elementFromPoint(lastPointer.x, lastPointer.y)?.closest?.(ROW_SELECTOR) : null;
      if (under && under.closest(SHELL_SELECTOR) === shell) syncWash(under, true);
      else { activeRows.delete(shell); hideWash(shell); }
    });
    reaimShells.clear();
  };

  const observer = new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (node.matches?.(SHELL_SELECTOR)) ensureWash(node);
        installWashes(node);
      }
      for (const node of record.removedNodes) {
        if (!(node instanceof Element) || !node.matches?.(ROW_SELECTOR)) continue;
        const shell = record.target instanceof Element ? record.target.closest(SHELL_SELECTOR) : null;
        if (shell) reaimShells.add(shell);
      }
    }
    if (reaimShells.size && !reaimFrame) reaimFrame = requestAnimationFrame(reaimWashes);
  });
  const observedDrawers = new WeakSet();
  const observeDrawers = (root = document) => {
    root.querySelectorAll?.('[data-cart-preview], [data-wishlist-preview], [data-predictive-search-panel]').forEach((drawer) => {
      if (observedDrawers.has(drawer)) return;
      observedDrawers.add(drawer);
      installWashes(drawer);
      observer.observe(drawer, { childList: true, subtree: true });
    });
  };
  observeDrawers();
  document.addEventListener('shopify:section:load', (event) => observeDrawers(event.target));

  document.addEventListener('pointerover', (event) => {
    if (event.pointerType === 'touch') return;
    const row = event.target.closest?.(ROW_SELECTOR);
    if (!row || row.contains(event.relatedTarget)) return;
    syncWash(row, true);
  }, { passive: true });

  document.addEventListener('pointerout', (event) => {
    const row = event.target.closest?.(ROW_SELECTOR);
    if (!row || row.contains(event.relatedTarget)) return;
    const shell = row.closest(SHELL_SELECTOR);
    if (!shell) return;

    /* If the pointer is moving straight into another row, that row's
       pointerover will reposition the already-visible wash in the same frame. */
    const nextRow = event.relatedTarget?.closest?.(ROW_SELECTOR);
    if (nextRow && nextRow.closest(SHELL_SELECTOR) === shell) return;

    activeRows.delete(shell);
    hideWash(shell);
  }, { passive: true });

  document.addEventListener('focusin', (event) => {
    const row = event.target.closest?.(ROW_SELECTOR);
    if (row) syncWash(row, true);
  });

  document.addEventListener('focusout', (event) => {
    const row = event.target.closest?.(ROW_SELECTOR);
    if (!row) return;
    const shell = row.closest(SHELL_SELECTOR);
    if (!shell) return;
    requestAnimationFrame(() => {
      if (rowStillActive(row)) return;
      activeRows.delete(shell);
      hideWash(shell);
    });
  });

  document.addEventListener('scroll', (event) => {
    const scroller = event.target?.matches?.(SCROLLER_SELECTOR) ? event.target : null;
    if (!scroller) return;
    const shell = scroller.closest(SHELL_SELECTOR);
    const row = shell ? activeRows.get(shell) : null;
    if (row && rowStillActive(row)) syncWash(row, true);
  }, true);

  window.addEventListener('resize', () => {
    document.querySelectorAll(SHELL_SELECTOR).forEach((shell) => {
      const row = activeRows.get(shell);
      if (row && rowStillActive(row)) syncWash(row, true);
    });
  }, { passive: true });
})();

/* randomly alternate hero CTA arrow hover accent. */
(() => {
  const selector = '.source-v0514-hero .cc481-hero-button';

  const chooseArrowAccent = (button) => {
    if (!button) return;
    button.classList.remove('cc489-arrow-hover-red', 'cc489-arrow-hover-blue');
    button.classList.add(Math.random() < 0.40 ? 'cc489-arrow-hover-blue' : 'cc489-arrow-hover-red');
  };

  document.addEventListener('pointerover', (event) => {
    const button = event.target.closest?.(selector);
    if (!button) return;
    if (event.relatedTarget && button.contains(event.relatedTarget)) return;
    chooseArrowAccent(button);
  }, { passive: true });

  document.addEventListener('focusin', (event) => {
    const button = event.target.closest?.(selector);
    if (button) chooseArrowAccent(button);
  });
})();

/* =========================================================
   final PDP sales helpers
   Native <details> handles disclosure reliability.
   ========================================================= */
(() => {
  const page = document.querySelector('.cc-product-page');
  if (!page) return;

  const summary = page.querySelector('.cc-summary');
  const form = page.querySelector('#MainProductForm');
  if (!summary || !form) return;

  const select = form.querySelector('[data-variant-select]');
  const testerNote = form.querySelector('[data-cc544-tester-note]');

  const currentOption = () => select?.selectedOptions?.[0] || null;

  const syncTesterNote = () => {
    if (!testerNote) return;
    const option = currentOption();
    const label = `${option?.dataset?.formatTitle || option?.textContent || ''}`.toLowerCase();
    testerNote.hidden = !label.includes('tester');
  };

  select?.addEventListener('change', () => {
    requestAnimationFrame(syncTesterNote);
  });

  syncTesterNote();
})();

/* =========================================================
   PDP format-line sync
   ========================================================= */
(() => {
  const page = document.querySelector('.cc-product-page');
  if (!page) return;

  const select = page.querySelector('[data-variant-select]');
  const formatLine = page.querySelector('[data-cc547-format-line]');
  if (!select || !formatLine) return;

  const syncFormatLine = () => {
    const option = select.selectedOptions?.[0];
    if (!option) return;
    const label = `${option.dataset.formatTitle || option.textContent || ''}`.trim();
    if (label) formatLine.textContent = label;
  };

  select.addEventListener('change', syncFormatLine);
  syncFormatLine();
})();

/* =========================================================
   tester tooltip accessibility
   ========================================================= */
(() => {
  const help = document.querySelector('.cc551-tester-help');
  if (!help) return;
  const trigger = help.querySelector('.cc551-tester-trigger');
  if (!trigger) return;

  trigger.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') trigger.blur();
  });
})();

/* =========================================================
   PDP shelf boundary-state sync
   Give You Make Also Like / Recently Viewed the same visible disabled-arrow
   logic as homepage shelves. Buttons remain present at all times; only the
   unavailable direction receives disabled=true.
   ========================================================= */
(() => {
  const SELECTOR = '.source-product-shelf .source-shelf-wrap';
  const EDGE_EPSILON = 2;

  const syncWrap = (wrap) => {
    if (!wrap) return;
    const row = wrap.querySelector('[data-shelf-row]');
    const prev = wrap.querySelector('[data-shelf-prev]');
    const next = wrap.querySelector('[data-shelf-next]');
    if (!row || !prev || !next) return;

    const maxScroll = Math.max(0, row.scrollWidth - row.clientWidth);
    const current = Math.max(0, row.scrollLeft);
    const noScroll = maxScroll <= EDGE_EPSILON;

    prev.disabled = noScroll || current <= EDGE_EPSILON;
    next.disabled = noScroll || current >= maxScroll - EDGE_EPSILON;
  };

  const bindWrap = (wrap) => {
    if (!wrap || wrap.dataset.cc593BoundaryReady === 'true') {
      syncWrap(wrap);
      return;
    }
    wrap.dataset.cc593BoundaryReady = 'true';
    const row = wrap.querySelector('[data-shelf-row]');
    if (!row) return;

    let frame = 0;
    const sync = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(() => {
        frame = 0;
        if (wrap.isConnected) syncWrap(wrap);
      });
    };
    row.addEventListener('scroll', sync, { passive: true });

    const mutationObserver = new MutationObserver(sync);
    mutationObserver.observe(row, { childList: true });

    if ('ResizeObserver' in window) {
      const resizeObserver = new ResizeObserver(sync);
      resizeObserver.observe(row);
      resizeObserver.observe(wrap);
    }

    sync();
    window.setTimeout(sync, 120);
    window.setTimeout(sync, 500);
  };

  const init = (root = document) => {
    root.querySelectorAll?.(SELECTOR).forEach(bindWrap);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }

  window.addEventListener('resize', () => {
    document.querySelectorAll(SELECTOR).forEach(syncWrap);
  }, { passive: true });

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('cc:listings-updated', (event) => init(event.target || document));
})();

/* =========================================================
   MOBILE TOUCH STATE, NO ZOOM
   ---------------------------------------------------------
   Mobile keeps the approved touch outline/shadow/image-swap language, but no
   scale-up transform is applied to the listing image or the action rail. This
   removes the touch-zoom compositor conflict that could make the three action
   buttons pulse/jump on iOS. Timing remains unchanged.
   ========================================================= */
(() => {
  const coarseQuery = window.matchMedia?.('(hover: none) and (pointer: coarse)');
  if (!coarseQuery) return;

  let card = null;
  let startX = 0;
  let startY = 0;
  let moved = false;
  let clearTimer = 0;

  const clear = (delay = 0) => {
    window.clearTimeout(clearTimer);
    const current = card;
    card = null;
    const remove = () => current?.classList.remove('cc660-mobile-touch-active');
    if (delay > 0) clearTimer = window.setTimeout(remove, delay);
    else remove();
  };

  document.addEventListener('touchstart', (event) => {
    if (!coarseQuery.matches || !event.touches || event.touches.length !== 1) return;
    const next = event.target.closest?.('.full-bottle-strip-card[data-product-card]');
    if (!next || event.target.closest?.('.listing-hover-toolbar')) return;
    if (card && card !== next) clear();
    const touch = event.touches[0];
    card = next;
    startX = touch.clientX;
    startY = touch.clientY;
    moved = false;
    window.clearTimeout(clearTimer);
    card.classList.add('cc660-mobile-touch-active');
  }, { passive: true, capture: true });

  document.addEventListener('touchmove', (event) => {
    if (!card || !event.touches || event.touches.length !== 1) return;
    const touch = event.touches[0];
    const dx = touch.clientX - startX;
    const dy = touch.clientY - startY;
    if ((dx * dx) + (dy * dy) >= 100) {
      moved = true;
      clear();
    }
  }, { passive: true, capture: true });

  document.addEventListener('touchend', () => {
    if (!card) return;
    clear(moved ? 0 : 90);
  }, { passive: true, capture: true });
  document.addEventListener('touchcancel', () => clear(), { passive: true, capture: true });
})();

/* =========================================================
   Canada Cologne v2.15.664 — PDP shelf arrow geometry parity
   ---------------------------------------------------------
   A deliberately small final synchronizer for You May Also Like / Recently
   Viewed. It runs after all legacy shelf code and owns only the final arrow
   coordinates. No readiness/visibility gate is required.
   ========================================================= */
(() => {
  const SHELF = 'body.template-product .source-product-shelf .source-shelf-wrap';
  const LIFT_VAR = '--cc290-card-hover-lift';

  const finalLift = () => {
    const raw = Number.parseFloat(getComputedStyle(document.documentElement).getPropertyValue(LIFT_VAR));
    return Number.isFinite(raw) ? raw : -5;
  };

  const visibleCards = (row) => {
    const cards = Array.from(row?.querySelectorAll?.(':scope > [data-product-card]') || []).filter((card) => !card.hidden);
    if (!cards.length) return [];
    const rowRect = row.getBoundingClientRect();
    const visible = cards.filter((card) => {
      const rect = card.getBoundingClientRect();
      return rect.right > rowRect.left + 2 && rect.left < rowRect.right - 2;
    });
    return visible.length ? visible : cards;
  };

  const sync = (wrap) => {
    if (!wrap) return;
    const row = wrap.querySelector('[data-shelf-row]');
    const prev = wrap.querySelector('[data-shelf-prev]');
    const next = wrap.querySelector('[data-shelf-next]');
    if (!row || !prev || !next) return;

    /* v78: once the anchored arrow system (syncShelfArrowCenters) owns this
       shelf, it keeps the arrows pinned to the listing photos by itself. A second
       pixel pass here measured a different box and fought it, so the arrows
       flickered sideways for a frame after every page change. */
    if (wrap.dataset.cc629ShelfAnchored === 'true') {
      prev.style.setProperty('visibility', 'visible', 'important');
      next.style.setProperty('visibility', 'visible', 'important');
      wrap.dataset.cc664PdpArrowsReady = 'true';
      return;
    }

    const cards = visibleCards(row);
    if (!cards.length) return;
    const stage = cards[0].querySelector('.full-bottle-strip-image-stage');
    if (!stage) return;

    const wrapRect = wrap.getBoundingClientRect();
    const stageRect = stage.getBoundingClientRect();
    if (!(stageRect.height > 0)) return;

    /* Desktop arrows sit at the preview's final-hover centre, matching the
       homepage endpoint contract. On touch-only phones the card still uses the
       same subtle lift state, so the same final centre remains correct. */
    const railLayout = window.matchMedia
      ? window.matchMedia('(max-width: 759px)').matches
      : window.innerWidth <= 759;
    const y = stageRect.top - wrapRect.top + (stageRect.height / 2) + finalLift();
    if (!Number.isFinite(y)) return;

    wrap.style.setProperty('--cc664-pdp-arrow-y', `${y}px`);
    wrap.dataset.cc664PdpArrowsReady = 'true';

    const size = getComputedStyle(document.documentElement).getPropertyValue('--cc629-carousel-arrow-size').trim() || '34px';
    const arrowSize = Number.parseFloat(size) || 34;

    /* v2.15.673 — leave the same gap between the arrow and the listing that
       New Arrivals / Best Sellers use. The row already holds some padding of
       its own, so the arrow only makes up the difference. Measured from the
       row's own edges, which do not move while the shelf is scrolled. */
    const sharedGap = Number.parseFloat(
      getComputedStyle(document.documentElement).getPropertyValue('--cc673-shelf-arrow-gap')
    ) || 21;
    const rowRect = row.getBoundingClientRect();
    const rowStyle = getComputedStyle(row);
    const insideLeft = (rowRect.left - wrapRect.left) + (Number.parseFloat(rowStyle.paddingLeft) || 0);
    const insideRight = (wrapRect.right - rowRect.right) + (Number.parseFloat(rowStyle.paddingRight) || 0);
    /* v2.16.24 — cc700. Phones and small tablets use the homepage contract:
       both circles sit INSIDE the wrapper, one fixed inset from each edge, so
       neither can be clipped by the side of the screen. Wider screens keep the
       established outside-the-row placement, clamped to the same safe inset. */
    const edge = window.innerWidth <= 640 ? 10 : 12;
    const limit = document.documentElement.clientWidth;
    const rawPrevLeft = insideLeft - sharedGap - arrowSize;
    const rawNextLeft = wrapRect.width - (insideRight - sharedGap - arrowSize) - arrowSize;
    const prevLeft = railLayout
      ? edge
      : Math.max(edge - wrapRect.left, Number.isFinite(rawPrevLeft) ? rawPrevLeft : -arrowSize);
    const nextLeft = railLayout
      ? (wrapRect.width - arrowSize - edge)
      : Math.min(
          limit - edge - arrowSize - wrapRect.left,
          Number.isFinite(rawNextLeft) ? rawNextLeft : wrapRect.width
        );

    prev.style.setProperty('top', `${y}px`, 'important');
    prev.style.setProperty('left', `${prevLeft}px`, 'important');
    prev.style.setProperty('right', 'auto', 'important');
    prev.style.setProperty('visibility', 'visible', 'important');

    next.style.setProperty('top', `${y}px`, 'important');
    next.style.setProperty('left', `${nextLeft}px`, 'important');
    next.style.setProperty('right', 'auto', 'important');
    next.style.setProperty('visibility', 'visible', 'important');
    /* v2.16.27 — cc703: phones use the one fixed arrow line. */
    window.CC703RailArrowTop?.apply(wrap);
  };

  const schedule = (wrap) => {
    if (!wrap) return;
    cancelAnimationFrame(wrap._cc664PdpArrowRaf || 0);
    wrap._cc664PdpArrowRaf = requestAnimationFrame(() => {
      wrap._cc664PdpArrowRaf = 0;
      sync(wrap);
    });
  };

  const bind = (wrap) => {
    if (!wrap) return;
    if (wrap.dataset.cc664PdpBound === 'true') {
      schedule(wrap);
      return;
    }
    wrap.dataset.cc664PdpBound = 'true';
    const row = wrap.querySelector('[data-shelf-row]');
    if (!row) return;

    row.addEventListener('scroll', () => schedule(wrap), { passive:true });
    new MutationObserver(() => schedule(wrap)).observe(row, { childList:true, subtree:false, attributes:true, attributeFilter:['hidden'] });
    if ('ResizeObserver' in window) {
      const ro = new ResizeObserver(() => schedule(wrap));
      ro.observe(wrap);
      ro.observe(row);
    }
    Array.from(row.querySelectorAll('img')).forEach((img) => {
      if (!img.complete) {
        img.addEventListener('load', () => schedule(wrap), { once:true });
        img.addEventListener('error', () => schedule(wrap), { once:true });
      }
    });
    schedule(wrap);
    window.setTimeout(() => schedule(wrap), 120);
    window.setTimeout(() => schedule(wrap), 500);
  };

  const init = (root = document) => root.querySelectorAll?.(SHELF).forEach(bind);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once:true });
  else init(document);
  window.addEventListener('load', () => init(document), { once:true });
  window.addEventListener('resize', () => document.querySelectorAll(SHELF).forEach(schedule), { passive:true });
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('cc:listings-updated', (event) => init(event.target || document));
})();

/* Canada Cologne v2.16.23 — clear stale homepage shelf fade state after scroll-back. */
(() => {
  const SHELF_WRAP = '.template-index .product-section-home [data-cc246-wrap]';
  let cleanupFrame = 0;

  const clearStaleHomeShelfFade = () => {
    cleanupFrame = 0;
    document.querySelectorAll(SHELF_WRAP).forEach((wrap) => {
      const viewport = wrap.querySelector('[data-cc246-viewport]');
      if (!viewport) return;
      if (wrap._cc667HomeFadeTimer || wrap._cc667HomeCleanupTimer) return;
      /* Only touch the DOM when a stale class is actually present (this runs on scroll). */
      if (viewport.classList.contains('cc667-home-shelf-fade-out')) viewport.classList.remove('cc667-home-shelf-fade-out');
      if (wrap.classList.contains('cc667-home-shelf-transitioning') || wrap.classList.contains('cc667-home-shelf-next') || wrap.classList.contains('cc667-home-shelf-prev')) {
        wrap.classList.remove('cc667-home-shelf-transitioning', 'cc667-home-shelf-next', 'cc667-home-shelf-prev');
      }
    });
  };

  const scheduleCleanup = () => {
    if (!document.body?.classList.contains('template-index')) return;
    if (cleanupFrame) return;
    cleanupFrame = requestAnimationFrame(clearStaleHomeShelfFade);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleCleanup, { once:true });
  } else {
    scheduleCleanup();
  }
  window.addEventListener('pageshow', scheduleCleanup, { passive:true });
  window.addEventListener('resize', scheduleCleanup, { passive:true });
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) scheduleCleanup();
  });
  document.addEventListener('scroll', scheduleCleanup, { passive:true });
  document.addEventListener('cc:home-shelf-ready', scheduleCleanup);
document.addEventListener('shopify:section:load', scheduleCleanup);
})();

/* =========================================================
   Canada Cologne performance layer (render-cost only; no visual change)
   1. Infinite decorative CSS animations (announcement colours, title glow,
      logo pulses) are paused while their section is off-screen and resumed
      at the exact phase they would have reached, so nothing visibly differs.
   2. Permanent will-change hints are released after load (all devices). Each promoted element otherwise holds its own GPU layer (400+ on
      the homepage), which is what makes phone scrolling stutter. Stacking,
      containing blocks and backdrop roots are preserved exactly.
   ========================================================= */
(() => {
  if (!('getAnimations' in document) || !('IntersectionObserver' in window)) return;

  const groups = new Map();
  const tracked = new WeakSet();
  const groupRootFor = (target) => {
    let el = target;
    if (el instanceof SVGElement && !(el instanceof SVGSVGElement)) el = el.ownerSVGElement || el.closest('svg') || el;
    return el.closest?.('.shopify-section, header, footer, section') || el;
  };

  /* Start time that reproduces the current phase, even while play is pending. */
  const savedStartOf = (animation) => (animation.startTime !== null && animation.startTime !== undefined)
    ? animation.startTime
    : (document.timeline.currentTime - (animation.currentTime || 0));

  const setVisible = (group, visible) => {
    if (group.visible === visible) return;
    group.visible = visible;
    group.animations.forEach((animation) => {
      try {
        if (animation.playState === 'idle' || animation.playState === 'finished') return;
        if (!visible) {
          if (animation.playState === 'running') {
            animation._ccSavedStart = savedStartOf(animation);
            animation.pause();
          }
        } else if (animation.playState === 'paused' && animation._ccSavedStart !== undefined) {
          const start = animation._ccSavedStart;
          animation._ccSavedStart = undefined;
          animation.play();
          if (start !== null && start !== undefined) animation.startTime = start;
        }
      } catch (_) {}
    });
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const group = groups.get(entry.target);
      if (group) setVisible(group, entry.isIntersecting);
    });
  }, { rootMargin: '160px 0px 160px 0px' });

  const scan = () => {
    document.getAnimations().forEach((animation) => {
      if (tracked.has(animation) || typeof CSSAnimation === 'undefined' || !(animation instanceof CSSAnimation)) return;
      const timing = animation.effect?.getTiming?.();
      if (!timing || timing.iterations !== Infinity) return;
      const target = animation.effect.target;
      if (!target || !target.isConnected) return;
      tracked.add(animation);
      const root = groupRootFor(target);
      let group = groups.get(root);
      if (!group) {
        group = { animations: new Set(), visible: true };
        groups.set(root, group);
        observer.observe(root);
      }
      group.animations.add(animation);
      if (!group.visible && animation.playState === 'running') {
        animation._ccSavedStart = savedStartOf(animation);
        animation.pause();
      }
    });
  };

  const start = () => {
    scan();
    window.setTimeout(scan, 2500);
  };
  if (document.readyState === 'complete') start();
  else window.addEventListener('load', start, { once: true });
  document.addEventListener('shopify:section:load', () => window.setTimeout(scan, 300));
})();

(() => {
  /* v83: runs on every device. A permanent will-change keeps an element in its
     own GPU layer, which Chrome rasterises at low quality first and without
     sub-pixel text, so pages looked soft for a moment after loading. Running
     transitions still get their own layer automatically, so motion is unchanged. */
  if (!window.getComputedStyle) return;

  const LAYER_ONLY = /^(transform|opacity|filter|translate|scale|rotate|box-shadow|background|background-color|background-position|border-color|color|text-shadow|height|width)$/;
  const STACKING = /^(transform|opacity|filter|translate|scale|rotate)$/;
  const CONTAINING = /^(transform|filter|translate|scale|rotate)$/;

  const isStackingContext = (cs) => (
    (cs.position !== 'static' && cs.zIndex !== 'auto')
    || cs.position === 'fixed' || cs.position === 'sticky'
    || cs.opacity !== '1' || cs.transform !== 'none' || cs.filter !== 'none'
    || cs.translate !== 'none' || cs.scale !== 'none' || cs.rotate !== 'none'
    || cs.isolation === 'isolate' || cs.mixBlendMode !== 'normal'
    || (cs.clipPath && cs.clipPath !== 'none') || (cs.backdropFilter && cs.backdropFilter !== 'none')
    || /paint|layout|strict|content/.test(cs.contain || '')
  );

  const needsOwnContainingBlock = (el, cs) => {
    const already = cs.transform !== 'none' || cs.filter !== 'none' || cs.translate !== 'none'
      || cs.scale !== 'none' || cs.rotate !== 'none' || /paint|layout|strict|content/.test(cs.contain || '');
    if (already) return false;
    const descendants = el.getElementsByTagName('*');
    if (descendants.length > 400) return true;
    for (const child of descendants) {
      const position = getComputedStyle(child).position;
      if (position === 'fixed') return true;
      if (position === 'absolute' && cs.position === 'static') return true;
    }
    return false;
  };

  const hasBackdropInside = (el) => {
    const cs = getComputedStyle(el);
    if (cs.backdropFilter && cs.backdropFilter !== 'none') return true;
    for (const child of el.getElementsByTagName('*')) {
      const bf = getComputedStyle(child).backdropFilter;
      if (bf && bf !== 'none') return true;
    }
    return false;
  };

  const relieve = (el) => {
    if (el.style.willChange) return;
    const cs = getComputedStyle(el);
    const value = cs.willChange;
    if (!value || value === 'auto') return;
    const props = value.split(',').map((part) => part.trim());
    if (!props.every((prop) => LAYER_ONLY.test(prop))) return;
    if (el.getAnimations && el.getAnimations().some((a) => a.playState === 'running')) return;
    const createsStacking = props.some((prop) => STACKING.test(prop));
    const createsContaining = props.some((prop) => CONTAINING.test(prop));
    if (createsContaining && needsOwnContainingBlock(el, cs)) return;
    if (createsStacking && hasBackdropInside(el)) return;
    if (createsStacking && !isStackingContext(cs)) el.style.setProperty('isolation', 'isolate');
    el.style.setProperty('will-change', 'auto', 'important');
  };

  const run = () => {
    const all = Array.from(document.body.getElementsByTagName('*'));
    let index = 0;
    const idle = window.requestIdleCallback || ((cb) => window.setTimeout(() => cb({ timeRemaining: () => 8 }), 50));
    const step = (deadline) => {
      while (index < all.length && deadline.timeRemaining() > 2) {
        const el = all[index++];
        if (el.isConnected) {
          try { relieve(el); } catch (_) {}
        }
      }
      if (index < all.length) idle(step);
    };
    idle(step);
  };

  if (document.readyState === 'complete') window.setTimeout(run, 1200);
  else window.addEventListener('load', () => window.setTimeout(run, 1200), { once: true });
})();

/* Header dropdowns: keep --cc-dd-top equal to the bottom edge of the header's
   bottom line so search / cart / wishlist / contact panels open right under it
   (see canada-cologne-mobile-dropdowns.css). The header's own padding is added
   to the logo row, so an open mobile menu does not push the panels down. */
(() => {
  let frame = 0;
  const update = () => {
    frame = 0;
    const header = document.querySelector('.site-header');
    const row = header?.querySelector('.cc-header-inner');
    if (!header || !row) return;
    const headerStyle = getComputedStyle(header);
    const padBottom = parseFloat(headerStyle.paddingBottom) || 0;
    const lineWidth = parseFloat(headerStyle.borderBottomWidth) || 0;
    // Just below the header's bottom line: every header dropdown starts here.
    const bottom = Math.max(0, Math.round(row.getBoundingClientRect().bottom + padBottom + lineWidth));
    // Performance: every panel that reads --cc-dd-top lives inside the header,
    // so the value is set on the header (not <html>) and only when it changes.
    // Writing it on <html> forced a full-page style recalculation on every
    // scroll frame near the top of the page.
    const top = `${bottom}px`;
    // Desktop cart / wishlist / contact panels hang from their icon; tell each
    // one how far its icon sits above the header line so it opens right under it.
    // (All positions are read first, then written, so layout is measured once.)
    const drops = Array.from(header.querySelectorAll('.header-cart-wrap, .header-wishlist-wrap, .header-contact-wrap'), (wrap) => (
      [wrap, `${Math.round((bottom - wrap.getBoundingClientRect().top) * 100) / 100}px`]
    ));
    if (header.style.getPropertyValue('--cc-dd-top') !== top) header.style.setProperty('--cc-dd-top', top);
    drops.forEach(([wrap, drop]) => {
      if (wrap.style.getPropertyValue('--cc-dd-drop') !== drop) wrap.style.setProperty('--cc-dd-drop', drop);
    });
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
  ['resize', 'scroll', 'orientationchange'].forEach((type) => window.addEventListener(type, schedule, { passive: true }));
  document.addEventListener('click', (event) => { if (event.target.closest?.('.site-header')) update(); }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update, { once: true });
  else update();
})();

/* =========================================================
   Canada Cologne v2.15.665 — touch tooltips for listing actions
   ---------------------------------------------------------
   Desktop reveals the action tooltip on hover. Touch devices have no
   hover, so a tap adds .cc661-tip-open for a moment and the same
   tooltip appears with the same styling. Purely additive: no existing
   handler, class or state is touched.
   ========================================================= */
(() => {
  const coarse = window.matchMedia?.('(hover: none) and (pointer: coarse)');
  const SELECTOR = '.listing-wishlist-button, .listing-share-button, .listing-hover-add';
  const HOLD = 1500;
  let open = null;
  let timer = 0;

  const close = () => {
    window.clearTimeout(timer);
    timer = 0;
    open?.classList.remove('cc661-tip-open');
    open = null;
  };

  document.addEventListener('touchstart', (event) => {
    if (coarse && !coarse.matches) return;
    const button = event.target.closest?.(SELECTOR);
    if (!button) { if (open) close(); return; }
    if (open && open !== button) close();
    open = button;
    button.classList.add('cc661-tip-open');
    window.clearTimeout(timer);
    timer = window.setTimeout(close, HOLD);
  }, { passive: true, capture: true });

  window.addEventListener('scroll', () => { if (open) close(); }, { passive: true, capture: true });
})();

/* v2.16 — product-card action tooltips (Wishlist / Saved, Share, Add To Cart)
   scale with their button. The tooltip was designed for the standard 31.5px
   button (11px text); larger buttons such as the Flash Sale's get a
   proportionally larger tooltip so the pair always looks balanced. Buttons at
   the standard size are left exactly as they were. */
(() => {
  if (!('ResizeObserver' in window)) return;
  const BASE_BUTTON = 31.5;
  const BUTTONS = '.listing-wishlist-button, .listing-share-button, .listing-hover-add';
  const observed = new WeakSet();
  const apply = (button) => {
    const toolbar = button.closest('.listing-hover-toolbar');
    if (!toolbar || toolbar.querySelector(BUTTONS) !== button) return;
    const width = button.getBoundingClientRect().width;
    if (!width) return;
    const scale = Math.min(1.6, width / BASE_BUTTON);
    if (scale < 1.04) {
      toolbar.classList.remove('cc-tip-scaled');
      toolbar.style.removeProperty('--cc-tip-scale');
      return;
    }
    toolbar.style.setProperty('--cc-tip-scale', scale.toFixed(3));
    toolbar.classList.add('cc-tip-scaled');
  };
  const observer = new ResizeObserver((entries) => entries.forEach((entry) => apply(entry.target)));
  const watch = (root = document) => {
    root.querySelectorAll?.('.listing-hover-toolbar').forEach((toolbar) => {
      const first = toolbar.querySelector(BUTTONS);
      if (!first || observed.has(first)) return;
      observed.add(first);
      observer.observe(first);
    });
  };
  const start = () => watch();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('cc:listings-updated', (event) => watch(event.target || document));
  document.addEventListener('shopify:section:load', (event) => watch(event.target || document));
})();

/* Canada Cologne v2.16.27 — cc703 binder. Recomputes the fixed phone arrow
   line only when layout can actually change it (resize, images, fonts,
   section reloads). Scrolling, paging and touching never move the arrows. */
(() => {
  const api = window.CC703RailArrowTop;
  if (!api) return;
  let frame = 0;
  const schedule = () => {
    if (frame) return;
    frame = requestAnimationFrame(() => { frame = 0; api.applyAll(document); });
  };
  const bindImages = (root) => {
    (root || document).querySelectorAll?.(api.WRAP).forEach((wrap) => {
      if (wrap.dataset.cc703Bound === 'true') return;
      wrap.dataset.cc703Bound = 'true';
      wrap.querySelectorAll('img').forEach((img) => {
        if (!img.complete) {
          img.addEventListener('load', schedule, { once:true });
          img.addEventListener('error', schedule, { once:true });
        }
      });
      if ('ResizeObserver' in window) new ResizeObserver(schedule).observe(wrap);
    });
  };
  const init = (root) => { bindImages(root); schedule(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once:true });
  else init(document);
  window.addEventListener('load', () => { init(document); setTimeout(schedule, 400); }, { once:true });
  window.addEventListener('resize', schedule, { passive:true });
  document.fonts?.ready?.then(schedule).catch(() => {});
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  document.addEventListener('cc:listings-updated', (e) => init(e.target || document));
})();

/* =========================================================
   v95: PDP variant link — the address bar and the Share button carry
   ?variant=<id> for the size on screen (bottle or decant), so a copied or
   shared link opens on exactly that size.
   ========================================================= */
(() => {
  const page = document.querySelector('.cc-product-page');
  if (!page || !/\/products\//.test(window.location.pathname)) return;
  const select = page.querySelector('[data-variant-select]');
  if (!select) return;
  const share = page.querySelector('.listing-share-button[data-card-share]');

  const syncVariantLink = () => {
    const id = select.value;
    if (!id) return;
    try {
      const url = new URL(window.location.href);
      if (url.searchParams.get('variant') !== id) {
        url.searchParams.set('variant', id);
        window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
      }
      if (share && share.dataset.url) {
        const shareUrl = new URL(share.dataset.url, window.location.origin);
        shareUrl.searchParams.set('variant', id);
        share.dataset.url = shareUrl.href;
      }
    } catch (_) { /* leave the link as it is */ }
  };

  select.addEventListener('change', syncVariantLink);
  syncVariantLink();
})();

/* =========================================================
   v99: endless decorative animations (announcement bar colour drift and
   marquee, home hero colour wander / glow) stop ticking while their area
   is scrolled out of view and pick up exactly where they were when it
   returns. Nothing changes on screen; the phone just stops repainting
   things nobody can see, which keeps scrolling smooth.
   ========================================================= */
(() => {
  if (!('IntersectionObserver' in window) || typeof Element.prototype.getAnimations !== 'function') return;
  const HOSTS = '.announcement-bar, .source-v0514-hero';
  const endless = (host) => host.getAnimations({ subtree: true })
    .filter((animation) => animation.effect?.getTiming?.().iterations === Infinity);
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const host = entry.target;
      if (entry.isIntersecting) {
        if (!host._ccAnimPaused) return;
        host._ccAnimPaused = false;
        endless(host).forEach((animation) => { if (animation.playState === 'paused') animation.play(); });
      } else {
        host._ccAnimPaused = true;
        endless(host).forEach((animation) => { if (animation.playState === 'running') animation.pause(); });
      }
    });
  });
  const watch = (root = document) => root.querySelectorAll?.(HOSTS).forEach((host) => {
    if (host._ccAnimWatched) return;
    host._ccAnimWatched = true;
    observer.observe(host);
  });
  watch();
  document.addEventListener('shopify:section:load', (event) => watch(event.target));
})();

/* v103: phone filter drawer - while it is open the page behind it is held still.
   iOS Safari (and in-app browsers) ignore overflow:hidden on <body>, so the
   listings scrolled underneath and the drawer drifted up and down with them. */
(() => {
  const sidebar = document.querySelector('[data-filter-sidebar]');
  if (!sidebar) return;
  const drawerMode = window.matchMedia('(max-width: 899px)');
  const body = document.body;
  const root = document.documentElement;
  const LOCK = { position: 'fixed', top: '', left: '0', right: '0', width: '100%' };
  let lockedY = null;
  const lock = () => {
    if (lockedY !== null || !drawerMode.matches) return;
    lockedY = window.scrollY;
    Object.entries({ ...LOCK, top: `${-lockedY}px` }).forEach(([prop, value]) => body.style.setProperty(prop, value, 'important'));
  };
  const unlock = () => {
    if (lockedY === null) return;
    const y = lockedY;
    lockedY = null;
    Object.keys(LOCK).forEach((prop) => body.style.removeProperty(prop));
    const behavior = root.style.scrollBehavior;
    root.style.scrollBehavior = 'auto';
    window.scrollTo(0, y);
    root.style.scrollBehavior = behavior;
  };
  const sync = () => (sidebar.classList.contains('is-open') && drawerMode.matches ? lock() : unlock());
  new MutationObserver(sync).observe(sidebar, { attributes: true, attributeFilter: ['class'] });
  if (drawerMode.addEventListener) drawerMode.addEventListener('change', sync);
  window.addEventListener('pageshow', sync);
  sync();
})();

/* v109: homepage shelves (New Arrivals, Best Sellers, Hot Deals) - the photos
   of the first page of cards on each shelf are fetched as soon as the page has
   loaded, and straight away when the shopper scrolls towards a shelf, instead of
   waiting until the shelf is almost on screen. A fast scroll down no longer
   reaches a shelf whose photos are still missing. */
(() => {
  const PAGE = 8;
  const start = () => {
  const sections = Array.from(document.querySelectorAll('.product-section-home'));
  if (!sections.length) return;
  const prime = (section) => {
    if (section._ccPhotosPrimed) return;
    section._ccPhotosPrimed = true;
    const cards = Array.from(section.querySelectorAll('.full-bottle-strip-card'))
      .filter((card) => !card.closest('[hidden]'))
      .slice(0, PAGE);
    cards.forEach((card) => {
      card.querySelectorAll('img[loading="lazy"]').forEach((img) => { img.loading = 'eager'; });
    });
  };
  const primeAll = () => sections.forEach(prime);
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        prime(entry.target);
      });
    }, { rootMargin: '1600px 0px 1600px 0px' });
    sections.forEach((section) => observer.observe(section));
  }
  const afterLoad = () => {
    const idle = window.requestIdleCallback || ((fn) => window.setTimeout(fn, 200));
    idle(primeAll, { timeout: 1500 });
  };
  if (document.readyState === 'complete') afterLoad();
  else window.addEventListener('load', afterLoad, { once: true });
  };
  /* Runs after the shelves have picked their random cards (DOMContentLoaded). */
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => window.setTimeout(start, 0), { once: true });
  else window.setTimeout(start, 0);
})();
